<template>
  <div class="page-container">
    <!-- 固定导航栏 -->
    <nav class="navbar" :class="{ 'navbar-fixed': isNavbarFixed, 'navbar-scrolled': isScrolled }">
      <div class="navbar-content">
        <div class="navbar-brand">
          <img src="./assets/img/FigmaDDSSlicePNG1f52009cf8f709682e81af452679a99e.png" alt="Logo" class="navbar-logo" />
          <span class="navbar-title">中广天择2026真实世界全系列声学活动数据集</span>
        </div>
        <div class="navbar-menu">
          <a href="#home" class="navbar-item" @click.prevent="scrollToSection('home')">首页</a>
          <a href="#overview" class="navbar-item" @click.prevent="scrollToSection('overview')">数据概览</a>
          <!-- <a href="#annotation" class="navbar-item" @click.prevent="scrollToSection('annotation')">视频标注</a> -->
          <a href="#structure" class="navbar-item" @click.prevent="scrollToSection('structure')">数据集结构</a>
          <a href="#contact" class="navbar-item" @click.prevent="scrollToSection('contact')">联系我们</a>
          <a href="http://szzx.sjj.tvzone.cn/multi-viewData/index/" class="navbar-item" target="_blank">2026连续多视角4D视频数据集</a>
          <a href="https://tvzone.cn/AI/index" class="navbar-item" target="_blank">中广天择数据产品全系列</a>
          <button class="navbar-btn-lang" @click="switchLanguage">English</button>
        </div>
      </div>
    </nav>

    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 首页区域 -->
      <section id="home" class="section hero-section">
        <!-- 图片背景 -->
        <img class="hero-video" src="./assets/img/bg6.png" alt="Background" />
<!--        <img class="hero-video" :src="require('./assets/img/bg6.png')" alt="Background" />-->
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <h1 class="hero-title">中广天择2026真实世界全系列<br>声学活动数据集</h1>
          <!--          <h1 class="hero-title"><span class="hero-title-prefix">中广天择2026年</span>真实世界声学数据集</h1>-->

          <p class="hero-subtitle">
            <span class="stat-line stat-line-single"> 复杂环境声音<strong> 5000+小时 </strong>| 人声 <strong> 4000+小时 </strong> | 自然声音 <strong> 2000+小时 </strong>| 乐器 <strong> 2000+小时 </strong></span>
<!--            <span class="stat-line"> 总采集时长 <strong> 14000+小时 </strong> </span>-->
            <!-- <span class="stat-line">涵盖体育场馆、社区、家居、公园、消费场所、舞台演出等多类型室内外环境</span>
            <span class="stat-line">覆盖幼、青、中、老年全年龄段，捕捉年龄、体型、体能带来的真实动作差异</span> -->
<!--            <span class="stat-line">采集场景：城市 / 家庭 / 工业 / 自然</span>-->
<!--            <span class="stat-line">采集人次：1000+，男女比例均衡，覆盖全年龄段</span>-->
<!--            <span class="stat-line">采样率&ge;16kHz，底噪&le;-50db，前后静默&le;2s，字准率&ge;98%</span>-->
<!--            <span class="stat-line">“多场景 × 多事件 × 多源混合 声音数据体系”</span>-->
<!--            <span class="feature-tagline">让机器听懂真实世界的复杂声音</span>-->
          </p>

          <div class="hero-tags">
            <span class="hero-tag">2000+现实场景深度覆盖</span>
            <span class="hero-tag">2000+人次，完整授权真人ID</span>
            <span class="hero-tag">男女比例均衡</span>
            <span class="hero-tag">全年龄段覆盖</span>
            <span class="hero-tag">采样率 ≥44.1kHz</span>
<!--            <span class="hero-tag">标注准确率 ≥97%</span>-->
            <span class="hero-tag">多场景 × 多事件 × 多源混合</span>
          </div>

          <div class="hero-actions">
            <button class="btn btn-primary" @click="scrollToSection('overview')">
              <i class="icon"></i> 简介
            </button>
            <button class="btn btn-secondary" @click="playIntroVideo">
              <i class="icon"></i> 查看样例
            </button>
            <button class="btn btn-outline" @click="scrollToSection('data-details')">
              <i class="icon"></i> 数据详情
            </button>
          </div>

        </div>

        <p class="hero-subtitle bottom">
          <span class="feature-tagline tagline-wide">服务于世界模型与语音大模型训练</span>
          <span class="feature-tagline tagline-wide">可支撑声音理解、声学场景识别、声音事件检测等核心技术任务</span>
          <span class="feature-tagline tagline-wide">可落地于机器人听觉感知、车载声学系统、音频创作与音效生成等应用场景</span>
        </p>

        <div class="scroll-indicator" @click="scrollToSection('overview')">
          <i class="icon">▼</i>
        </div>
      </section>

      <!-- 项目简介 -->
      <section id="overview" class="section overview-section">
        <!-- 外层容器：控制整体居中+背景+圆角 -->
        <div style="width: 90%; max-width: 1200px; margin: 0 auto; background: rgba(0, 10, 41, 0.85); border-radius: 12px; padding: 40px 50px; color: #fff; box-sizing: border-box;">
          <!-- 标题行：居中+下划线+右侧备注 -->
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; position: relative;">
            <h2 style="font-size: 32px; font-weight: 700; margin: 0; text-align: center; width: 100%;">项目简介</h2>
            <!-- 标题下划线 -->
            <div style="position: absolute; left: 50%; bottom: -10px; transform: translateX(-50%); width: 80px; height: 3px; background: #00a8ff;"></div>
          </div>

          <!-- 正文内容：行间距+蓝色高亮+统一字号 -->
          <div style="font-size: 16px; line-height: 1.8; letter-spacing: 0.5px;">
            <p style="margin: 0 0 20px 0;">
              为突破声学环境理解、多源声音事件识别及高精度标注的关键瓶颈，中广天择依托成熟的规模化真实场景采集能力，正式推出
              <span style="color: #00a8ff;">真实世界全系列声学活动数据集</span>
              。项目由中广天择自主完成采集、标注、质控全流程建设，拥有完整知识产权。
            </p>
            <p style="margin: 0 0 20px 0;">
              数据集覆盖
              <span style="color: #00a8ff;">2000余种真实生活与生产场景</span>
              ，涵盖商业、家庭、办公、校园、工业、交通及自然环境，配置50余种、500余套专业声学采集设备矩阵，并由上千人次全域声学采集师及专业录音质控团队协同执行，
              形成从场景规划、设备部署到数据交付的标准化工程体系，确保数据具备最新时效与高保真度。
            </p>
            <p style="margin: 0 0 20px 0;">
              项目实现智能算法赋能与精细化人工校验的双向核心突破，一方面通过
              <span style="color: #00a8ff;">多模态大模型协同组合</span>
              ，构建具备时序感知能力的声音标注专用Agent，
              高效完成音频基础自动化标注工作，破解声音事件检测算法落地中大规模、长时序数据自动化生成的行业痛点；另一方面攻克
              <span style="color: #00a8ff;">真实复杂声场下人工标注</span>的高难度行业难题。
              区别于常规数据标注，本项目音频标注需精准甄别复杂声场下多声源叠加、时序交错的各类声音信息，区分全局不同说话人身份属性，
              同时精细化核验校正人声年龄、性别、情绪状态、行为声学特征及各类环境声音事件细节，标注维度多、甄别难度大、校验精度要求极高。
              依托AI智能初筛+高标准人工精修的双重模式，解决复杂声场下多源事件识别偏差、时序切分不准、结构化标注不精准的核心问题，
              大幅提升数据的真实性、精准度与专业性，为声学算法落地筑牢高质量数据根基。
            </p>
            <p style="margin: 0 0 20px 0;">
              数据集覆盖人声、自然环境声、乐器声与复杂混合声场的完整声音体系
<!--              ，沉淀-->
<!--              <span style="color: #00a8ff;">超10000声音ID</span>-->
              ，覆盖全年龄段、全性别人群，并系统收录300余种非语言人声事件，包含情绪表达、生理反应、口腔气流及肢体行为等高表现力声学特征；复杂环境声音则聚焦多声源并发、长时序连续与真实混合场景，强化模型对现实世界复杂声场的理解能力。
            </p>
            <p style="margin: 0;">
              依托“真实采集 × Agent标注 × 精细质控”一体化能力，本数据集可广泛服务于
              <span style="color: #00a8ff;">声音事件检测、声学场景理解、音频大模型训练，</span>并为
              <span style="color: #00a8ff;">机器人感知、多模态大模型、自动驾驶、智能安防及智能家居</span>
              提供可训练、可部署的听觉智能数据底座。
            </p>
          </div>
        </div>
      </section>

      <!-- 数据特色模块（4个卡片 / 一行两个 / 无红框 / 居中） -->
      <section id="data-features" class="section data-features-section">
        <div class="section-title-wrapper">
          <h2 class="section-title">数据特色</h2>
        </div>

        <div class="features-container">
          <!-- 卡片1 - ka1 轮播图 -->
          <div class="feature-item">
            <h3>2000+完整授权真人ID</h3>
            <p>覆盖儿童男、儿童女、少年男、少年女、青年男、青年女、中年男、中年女、老年男、老年女、全年龄段、全性别人群。</p>
            <div class="carousel-container" style="width:100%;height:280px;border:none;box-shadow:none;margin:0;"
                 @mouseenter="stopAutoPlay(1)" @mouseleave="startAutoPlay(1)">
              <div class="carousel-wrapper" :style="{ transform: 'translateX(-' + (carouselIndex1 * 100) + '%)' }">
                <div class="carousel-card" v-for="(img, i) in carouselImages1" :key="i">
                  <img :src="img" style="width:100%;height:100%;object-fit:contain;">
                </div>
              </div>
              <button class="carousel-btn prev-btn" @click="prevCarousel(1)">&lt;</button>
              <button class="carousel-btn next-btn" @click="nextCarousel(1)">&gt;</button>
              <div class="carousel-indicators">
          <span v-for="(img, i) in carouselImages1" :key="i"
                class="indicator" :class="{ active: i === carouselIndex1 }"
                @click="goToCarousel(1, i)"></span>
              </div>
            </div>
          </div>

          <!-- 卡片2 - ka2 轮播图 -->
          <div class="feature-item">
            <h3>全知识产权</h3>
            <p>中广天择全自主采集标注,对所有发言人具有完整的权利让渡,未成年人拥有其监护人的授权书。</p>
            <div class="carousel-container" style="width:100%;height:280px;border:none;box-shadow:none;margin:0;"
                 @mouseenter="stopAutoPlay(2)" @mouseleave="startAutoPlay(2)">
              <div class="carousel-wrapper" :style="{ transform: 'translateX(-' + (carouselIndex2 * 100) + '%)' }">
                <div class="carousel-card" v-for="(img, i) in carouselImages2" :key="i">
                  <img :src="img" style="width:100%;height:100%;object-fit:contain;">
                </div>
              </div>
              <button class="carousel-btn prev-btn" @click="prevCarousel(2)">&lt;</button>
              <button class="carousel-btn next-btn" @click="nextCarousel(2)">&gt;</button>
              <div class="carousel-indicators">
          <span v-for="(img, i) in carouselImages2" :key="i"
                class="indicator" :class="{ active: i === carouselIndex2 }"
                @click="goToCarousel(2, i)"></span>
              </div>
            </div>
          </div>

          <!-- 卡片3 - ka3 轮播图 -->
          <div class="feature-item">
            <h3>2000+ 现实场景</h3>
            <p>深入商业、家庭、办公、校园、工业、交通、医院、体育赛场、夜市及自然环境等室内室外真实场景采集,还原复杂声场下的多源声音并发、长时序连续特征。</p>
            <div class="carousel-container" style="width:100%;height:280px;border:none;box-shadow:none;margin:0;"
                 @mouseenter="stopAutoPlay(3)" @mouseleave="startAutoPlay(3)">
              <div class="carousel-wrapper" :style="{ transform: 'translateX(-' + (carouselIndex3 * 100) + '%)' }">
                <div class="carousel-card" v-for="(img, i) in carouselImages3" :key="i">
                  <img :src="img" style="width:100%;height:100%;object-fit:contain;">
                </div>
              </div>
              <button class="carousel-btn prev-btn" @click="prevCarousel(3)">&lt;</button>
              <button class="carousel-btn next-btn" @click="nextCarousel(3)">&gt;</button>
              <div class="carousel-indicators">
          <span v-for="(img, i) in carouselImages3" :key="i"
                class="indicator" :class="{ active: i === carouselIndex3 }"
                @click="goToCarousel(3, i)"></span>
              </div>
            </div>
          </div>

          <!-- 卡片4 - ka4 轮播图 -->
          <div class="feature-item">
            <h3>高难度声源全面覆盖</h3>
            <p>针对现实中采集环境受限、收音条件严苛、获取成本高的各类真实声场景开展实地收录，完整还原多层级复杂声场特征，深度提升模型实景声学理解精度，满足多行业、多复杂场景算法落地适配需求。</p>
            <div class="carousel-container" style="width:100%;height:280px;border:none;box-shadow:none;margin:0;"
                 @mouseenter="stopAutoPlay(4)" @mouseleave="startAutoPlay(4)">
              <div class="carousel-wrapper" :style="{ transform: 'translateX(-' + (carouselIndex4 * 100) + '%)' }">
                <div class="carousel-card" v-for="(img, i) in carouselImages4" :key="i">
                  <img :src="img" style="width:100%;height:100%;object-fit:contain;">
                </div>
              </div>
              <button class="carousel-btn prev-btn" @click="prevCarousel(4)">&lt;</button>
              <button class="carousel-btn next-btn" @click="nextCarousel(4)">&gt;</button>
              <div class="carousel-indicators">
          <span v-for="(img, i) in carouselImages4" :key="i"
                class="indicator" :class="{ active: i === carouselIndex4 }"
                @click="goToCarousel(4, i)"></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 视频介绍 -->
      <section id="video-intro" class="section video-section">
        <div class="section-header">
          <h2 class="section-title">视频介绍</h2>
        </div>
        <div class="video-player">
          <div class="video-container">
            <!-- 视频元素 -->
            <video
                ref="introVideo"
                class="intro-video"
                loop
                @loadedmetadata="onVideoLoaded"
                @timeupdate="onTimeUpdate"
                @ended="onVideoEnded"
                @click="togglePlayPause"
            >
              <source src="./assets/video/复杂声音事件介绍视频0624（2）.mp4" type="video/mp4">
              您的浏览器不支持视频播放。
            </video>

            <!-- 播放按钮覆盖层（视频未播放时显示） -->
            <div class="video-overlay" v-if="!isPlaying">
              <button class="play-button" @click="playVideo">
                <span>▶</span>
              </button>
            </div>

            <!-- 视频控制栏 -->
            <div class="video-controls" v-if="showControls">
              <div class="logo-tag">中广天择</div>
              <div class="progress-bar" @click="seekVideo">
                <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
              </div>
              <div class="control-buttons">
                <button class="control-btn" @click="togglePlayPause">
                  {{ isPlaying ? '⏸️' : '▶️' }}
                </button>
                <div><img src="./assets/img/FigmaDDSSlicePNG1f52009cf8f709682e81af452679a99e.png" alt="icon"></div>
                <span class="time-display">{{ currentTime }} / {{ duration }}</span>
                <button class="control-btn" @click="toggleMute">
                  {{ isMuted ? '🔇' : '🔊' }}
                </button>
                <button class="control-btn" @click="toggleFullscreen">⛶</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 音频数据能力 -->
      <section id="audio-capability" class="section audio-capability-section">
        <div class="audio-cap-container">
          <h1>音频数据能力</h1>

          <div class="tabs">
            <div class="tab" :class="{ active: currentTab === 0 }" @click="switchAudioTab(0)">人声</div>
            <div class="tab" :class="{ active: currentTab === 1 }" @click="switchAudioTab(1)">自然</div>
            <div class="tab" :class="{ active: currentTab === 2 }" @click="switchAudioTab(2)">音乐</div>
            <div class="tab" :class="{ active: currentTab === 3 }" @click="switchAudioTab(3)">复杂</div>
          </div>

          <!-- 动态描述区域 -->
          <div class="desc-bar">{{ currentData.desc }}</div>

          <div class="func-tags">
            <div class="f-tag" v-for="(tag, i) in currentData.tags" :key="i">{{ tag }}</div>
          </div>

          <div class="spec-grid">
            <div class="spec-card">
              <span class="spec-label">数据特征</span>
              <span class="spec-value">{{ currentData.specs[0] }}；{{ currentData.specs[2] || '' }}</span>
            </div>
            <div class="spec-card">
              <span class="spec-label">内容分类</span>
              <span class="spec-value">{{ currentData.specs[1] }}</span>
            </div>
            <!--            <div class="spec-card">-->
            <!--              <span class="spec-label">数据规模</span>-->
            <!--              <span class="spec-value">{{ currentData.specs[2] || '' }}</span>-->
            <!--            </div>-->
            <!--            <div class="spec-card">-->
            <!--              <span class="spec-label">数据质量</span>-->
            <!--              <span class="spec-value">{{ currentData.specs[3] || '' }}</span>-->
            <!--            </div>-->
          </div>



          <div class="audio-grid audio-grid-align">
            <div class="audio-card" v-for="(title, i) in currentData.titles" :key="i" :id="`card-${i}`">
              <div class="audio-info">
                <button class="btn-play-control" @click="toggleAudioPlay(i)" :class="{ playing: playingIndex === i }">
                  <div class="icon-play"></div>
                  <div class="icon-pause"></div>
                </button>
                <span class="audio-title">{{ title }}</span>
              </div>
              <div class="progress-wrapper" @click="seekAudio1($event, i)">
                <div class="progress-track">
                  <div class="progress-fill" :style="{ width: progressWidths[i] + '%' }"></div>
                </div>
              </div>
              <audio :ref="`audio-${i}`" :src="getAudioPath(i)" @timeupdate="onAudioTimeUpdate(i)" @ended="onAudioEnd(i)"></audio>

            </div>
          </div>
        </div>
      </section>

      <!-- 声音分类数据库 -->
<!--      <section id="sound-classification" class="section sound-classification-section">-->
<!--        <div class="sound-db-card">-->
<!--          <div class="header-area">-->
<!--            <div class="title">声音分类数据库</div>-->
<!--          </div>-->

<!--          <div class="table-wrapper" ref="scrollContainer" @scroll="updateStatus">-->
<!--            <table class="sound-db-table">-->
<!--              <thead>-->
<!--              <tr>-->
<!--                <th>一级分类</th>-->
<!--                <th>二级分类</th>-->
<!--                <th>三级种类详情</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <tr v-for="(row, rowIndex) in allFlatRows" :key="rowIndex">-->
<!--                <td v-if="row.showLv1" :rowspan="row.lv1RowSpan" class="lv1-cell">-->
<!--                  <div class="scroll-anchor" :data-name="row.lv1"></div>-->
<!--                  <div class="sticky-wrapper">-->
<!--                    <span class="cat-title">{{ row.lv1 }}</span>-->
<!--                  </div>-->
<!--                </td>-->
<!--                <td v-if="row.showLv2" :rowspan="row.lv2RowSpan" class="lv2-cell">-->
<!--                  <div class="sticky-wrapper">-->
<!--                    <span class="cat-title lv2-title">{{ row.lv2 }}</span>-->
<!--                  </div>-->
<!--                </td>-->
<!--                <td class="lv3-cell">{{ row.lv3 }}</td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->

<!--          <div class="status-bar">-->
<!--            <div v-html="statusText"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </section>-->

<!--      <section id="data-details" class="section data-details-section">-->
<!--        <div class="scene-diversity">-->
<!--          <div class="scene-header">-->
<!--            <div class="scene-header-left">-->
<!--              &lt;!&ndash; <div class="h_1"></div> &ndash;&gt;-->
<!--              <div class="h_title">声音事件样音试听</div>-->
<!--&lt;!&ndash;              <p class="set-desc">更多样音试听，请点击右侧“更多”按钮</p>&ndash;&gt;-->
<!--            </div>-->
<!--&lt;!&ndash;            <button class="more-btn morebtn0" @click="goToMoreDetails">&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="slide-track">&ndash;&gt;-->
<!--&lt;!&ndash;                    <span>更多</span>&ndash;&gt;-->
<!--&lt;!&ndash;                    <span>>>></span>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </button>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 人声事件 &ndash;&gt;-->
<!--        <div class="category-section">-->
<!--          <div class="category-header">-->
<!--            <h2 class="category-title">人声</h2>-->
<!--&lt;!&ndash;            <a href="#" class="btn-more">探索更多 →</a>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="audio-grid">-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 0 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 0 }" @click="togglePlay(0)">-->
<!--                    {{ currentPlaying === 0 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">7岁男孩惊讶</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">惊讶</span><span class="tag">儿童</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 0)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[0] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[0]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[0]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio0" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(0)" @timeupdate="updateProgress(0)" @ended="audioEnded(0)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 1 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 1 }" @click="togglePlay(1)">-->
<!--                    {{ currentPlaying === 1 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">成年女性低泣</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">哭泣</span><span class="tag">女性</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 1)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[1] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[1]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[1]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio1" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(1)" @timeupdate="updateProgress(1)" @ended="audioEnded(1)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 2 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 2 }" @click="togglePlay(2)">-->
<!--                    {{ currentPlaying === 2 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">多人欢呼雀跃</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">欢呼</span><span class="tag">群体</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 2)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[2] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[2]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[2]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio2" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(2)" @timeupdate="updateProgress(2)" @ended="audioEnded(2)"></audio>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 自然事件 &ndash;&gt;-->
<!--        <div class="category-section">-->
<!--          <div class="category-header">-->
<!--            <h2 class="category-title">自然</h2>-->
<!--&lt;!&ndash;            <a href="#" class="btn-more">探索更多 →</a>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="audio-grid">-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 3 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 3 }" @click="togglePlay(3)">-->
<!--                    {{ currentPlaying === 3 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">雷雨交加</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">雷声</span><span class="tag">雨声</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 3)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[3] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[3]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[3]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio3" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(3)" @timeupdate="updateProgress(3)" @ended="audioEnded(3)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 4 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 4 }" @click="togglePlay(4)">-->
<!--                    {{ currentPlaying === 4 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">海浪拍岸</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">海浪</span><span class="tag">水声</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 4)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[4] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[4]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[4]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio4" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(4)" @timeupdate="updateProgress(4)" @ended="audioEnded(4)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 5 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 5 }" @click="togglePlay(5)">-->
<!--                    {{ currentPlaying === 5 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">森林鸟鸣</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">鸟叫</span><span class="tag">森林</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 5)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[5] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[5]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[5]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio5" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(5)" @timeupdate="updateProgress(5)" @ended="audioEnded(5)"></audio>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 乐器演奏 &ndash;&gt;-->
<!--        <div class="category-section">-->
<!--          <div class="category-header">-->
<!--            <h2 class="category-title">音乐</h2>-->
<!--&lt;!&ndash;            <a href="#" class="btn-more">探索更多 →</a>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="audio-grid">-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 6 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 6 }" @click="togglePlay(6)">-->
<!--                    {{ currentPlaying === 6 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">古典吉他独奏</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">吉他</span><span class="tag">古典</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 6)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[6] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[6]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[6]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio6" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(6)" @timeupdate="updateProgress(6)" @ended="audioEnded(6)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 7 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 7 }" @click="togglePlay(7)">-->
<!--                    {{ currentPlaying === 7 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">钢琴轻柔旋律</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">钢琴</span><span class="tag">轻柔</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 7)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[7] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[7]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[7]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio7" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(7)" @timeupdate="updateProgress(7)" @ended="audioEnded(7)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 8 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 8 }" @click="togglePlay(8)">-->
<!--                    {{ currentPlaying === 8 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">爵士鼓组节拍</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">鼓</span><span class="tag">爵士</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 8)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[8] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[8]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[8]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio8" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(8)" @timeupdate="updateProgress(8)" @ended="audioEnded(8)"></audio>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; 复杂事件 &ndash;&gt;-->
<!--        <div class="category-section">-->
<!--          <div class="category-header">-->
<!--            <h2 class="category-title">复杂</h2>-->
<!--&lt;!&ndash;            <a href="#" class="btn-more">探索更多 →</a>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="audio-grid">-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 9 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 9 }" @click="togglePlay(9)">-->
<!--                    {{ currentPlaying === 9 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">地铁站人流</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">交通</span><span class="tag">人群</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 9)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[9] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[9]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[9]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio9" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(9)" @timeupdate="updateProgress(9)" @ended="audioEnded(9)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 10 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 10 }" @click="togglePlay(10)">-->
<!--                    {{ currentPlaying === 10 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">城市街道车流</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">交通</span><span class="tag">环境</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 10)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[10] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[10]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[10]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio10" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(10)" @timeupdate="updateProgress(10)" @ended="audioEnded(10)"></audio>-->
<!--            </div>-->
<!--            <div class="audio-card" :class="{ playing: currentPlaying === 11 }">-->
<!--              <div class="audio-body">-->
<!--                <div class="audio-control">-->
<!--                  <div class="play-btn" :class="{ playing: currentPlaying === 11 }" @click="togglePlay(11)">-->
<!--                    {{ currentPlaying === 11 ? '⏸' : '▶' }}-->
<!--                  </div>-->
<!--                  <div class="audio-meta">-->
<!--                    <div class="audio-title">咖啡馆背景音</div>-->
<!--                    <div class="audio-tags">-->
<!--                      <span class="tag">环境</span><span class="tag">氛围</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="progress-container" @click="seekAudio($event, 11)">-->
<!--                  <div class="progress-bar" :style="{ width: audioProgress[11] + '%' }"></div>-->
<!--                </div>-->
<!--                <div class="audio-time">-->
<!--                  <span>{{ formatAudioTime(audioCurrentTime[11]) }}</span>-->
<!--                  <span>/ {{ formatAudioTime(audioDuration[11]) }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <audio ref="audio11" :src="require('./assets/audio/audio01test.wav')" @loadedmetadata="loadAudio(11)" @timeupdate="updateProgress(11)" @ended="audioEnded(11)"></audio>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </section>-->

      <!-- 数据概览 -->
      <section id="data-details" class="section data-overview-section">
        <div class="section-header">
          <div class="section-title-group">
            <img src="./assets/img/FigmaDDSSlicePNG08e268df1e0d3e6c78d49be8ccdaf359.png" alt="" class="section-icon" />
            <h2 class="section-title">数据概览</h2>
            <span class="badge">行业领先</span>
          </div>
        </div>

        <div class="section-content">
          <!-- 卡片1 - 总时长 -->
          <div class="stat-card-new">
            <div class="stat-card-icon">
              <img src="./assets/icon/dataIcon1.svg" alt="Icon">
            </div>
            <div class="stat-card-label">总时长</div>
            <div class="stat-card-value">13500+ <span class="stat-card-unit">小时</span></div>
            <div class="stat-card-tag">全量精标，开箱可用</div>
          </div>

          <!-- 卡片2 - 人声事件 -->
          <div class="stat-card-new">
            <div class="stat-card-icon icon-blue">
              <img src="./assets/icon/dataIcon3.svg" alt="Icon">
            </div>
            <div class="stat-card-label">人声事件</div>
            <div class="stat-card-value">4000+ <span class="stat-card-unit">小时</span></div>
            <div class="stat-card-tag">全年龄段覆盖</div>
          </div>

          <!-- 卡片3 - 自然事件 -->
          <div class="stat-card-new">
            <div class="stat-card-icon icon-green">
              <img src="./assets/icon/dataIcon2.svg" alt="Icon">
            </div>
            <div class="stat-card-label">自然事件</div>
            <div class="stat-card-value">2000+ <span class="stat-card-unit">小时</span></div>
            <div class="stat-card-tag">海量精细声源</div>
          </div>

          <!-- 卡片4 - 乐器演奏 -->
          <div class="stat-card-new">
            <div class="stat-card-icon icon-red">
              <img src="./assets/icon/box-icon2.svg" alt="Icon">
            </div>
            <div class="stat-card-label">乐器演奏</div>
            <div class="stat-card-value">2000+ <span class="stat-card-unit">小时</span></div>
            <div class="stat-card-tag">全类中西乐器</div>
          </div>

          <!-- 卡片5 - 复杂事件 -->
          <div class="stat-card-new">
            <div class="stat-card-icon icon-orange">
              <img src="./assets/icon/dataIcon4.svg" alt="Icon">
            </div>
            <div class="stat-card-label">复杂事件</div>
            <div class="stat-card-value">5500+ <span class="stat-card-unit">小时</span></div>
            <div class="stat-card-tag">现实场景深度覆盖</div>
          </div>
        </div>

        <!-- 动作集 -->
        <div class="action-set-container">
          <div class="action-set-header">
            <img src="../lanhu_frame_1/assets/img/FigmaDDSSlicePNG80d4fcca1a86c1f9514cbac4deb6ee59.png" alt="" class="action-icon" />
            <h3>声音类目集（Audio Categories）</h3>
          </div>
          <p class="action-set-desc">对13500+小时音频数据进行抽样整理。此处显示了各类声音事件中的分类概览。块大小代表相应的动作时长。</p>

          <div class="action-visualization">
            <div class="viz-box" style="flex: 1 1 100%; min-width: 100%;">
              <div class="viz-header">
                <img src="../lanhu_frame_1/assets/img/FigmaDDSSlicePNG1c14ab2797a5b77846a692a28306c6d5.png" alt="" class="viz-thumbnail" />
                <span class="viz-text" @click="openFullscreenChart" style="cursor: pointer;">交互式声音类目数据可视化(Sunburst Chart)</span>
              </div>
              <div class="plotly-container">
                <div id="plotly-action-viz" style="width: 100%; height: 500px;"></div>
              </div>
            </div>
          </div>
        </div>

<!--        <div class="feature-boxes">-->
<!--          <div class="feature-box">-->
<!--            <div class="box-header">-->
<!--              <div class="box-icon"><img src="./assets/icon/box-icon1.svg" alt="Icon"></div>-->
<!--              <h3>声音事件检测</h3>-->
<!--            </div>-->
<!--            <p class="box-description">-->
<!--              基于精细化音频标注体系，实现对人声、环境声及机械声等多类声音事件的精准识别，支持多标签、多事件并行识别任务，提升模型在复杂声学环境下的理解能力。-->
<!--            </p>-->
<!--&lt;!&ndash;            <div class="box-tags">&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="tag">多机位</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="tag">25 FPS</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </div>-->

<!--          <div class="feature-box">-->
<!--            <div class="box-header">-->
<!--              <div class="box-icon"><img src="./assets/icon/box-icon2.svg" alt="Icon"></div>-->
<!--              <h3>声学结构建模</h3>-->
<!--            </div>-->
<!--            <p class="box-description">-->
<!--              通过音频切片与事件级标注，构建完整的声学时间序列结构，实现对复杂声音事件的时序关系建模，为音频大模型提供结构化输入基础。-->
<!--            </p>-->
<!--&lt;!&ndash;            <div class="box-tags tags2">&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="tag">SMPL-X</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="tag">3D Mesh</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </div>-->

<!--          <div class="feature-box">-->
<!--            <div class="box-header">-->
<!--              <div class="box-icon"><img src="./assets/icon/box-icon2.svg" alt="Icon"></div>-->
<!--              <h3>多源声场理解</h3>-->
<!--            </div>-->
<!--            <p class="box-description">-->
<!--              融合多场景、多来源音频数据，实现城市、家庭、工业等复杂声场的联合建模与理解，支持跨场景泛化能力训练。-->
<!--            </p>-->
<!--&lt;!&ndash;            <div class="box-tags tags2">&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="tag">SMPL-X</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="tag">3D Mesh</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--          </div>-->

<!--          <div class="feature-box">-->
<!--            <div class="box-header">-->
<!--              <h3>数据分布占比</h3>-->
<!--              &lt;!&ndash; <button class="more-btn" @click="goToMoreDetails">更多</button> &ndash;&gt;-->
<!--            </div>-->

<!--            <div class="distribution-chart">-->
<!--              <div class="pie-chart"></div>-->
<!--              <div class="chart-legend">-->
<!--                <div class="legend-item">-->
<!--                  <span class="legend-color single"></span>-->
<!--                  <span>人声事件 0.28571429</span>-->
<!--                </div>-->
<!--                <div class="legend-item">-->
<!--                  <span class="legend-color double"></span>-->
<!--                  <span>music 0.14285714</span>-->
<!--                </div>-->
<!--                <div class="legend-item">-->
<!--                  <span class="legend-color audio"></span>-->
<!--                  <span>自然声音事件 0.14285714</span>-->
<!--                </div>-->
<!--                <div class="legend-item">-->
<!--                  <span class="legend-color audio"></span>-->
<!--                  <span>复杂声音事件 0.35714286</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <!-- 对比表格 -->
<!--        <div class="comparison-table">-->
<!--          <div class="table-header">-->
<!--            <div class="w_first">-->
<!--              <div class="w_1"></div>-->
<!--              <div class="w_title">主流3D人体数据集参数对比</div>-->
<!--            </div>-->
<!--            <div class="legend">-->
<!--              <div class="l_dot1"></div>-->
<!--              <div class="legend-item our">本数据集</div>-->
<!--              <div class="l_dot2"></div>-->
<!--              <div class="legend-item other">其他</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="table-content">-->
<!--            <div class="table-row header">-->
<!--              <span>数据集</span>-->
<!--              <span>环境</span>-->
<!--              <span>场景</span>-->
<!--              <span>时长</span>-->
<!--              &lt;!&ndash; <span>帧率</span> &ndash;&gt;-->
<!--              <span>人次</span>-->
<!--              <span>单条时长</span>-->
<!--            </div>-->
<!--            <div class="table-row" v-for="(item, index) in comparisonData" :key="index" :class="{ highlight: item.isOurs }">-->
<!--              <span :class="{ 'our-text': item.isOurs }">-->
<!--                <span>{{ item.name }}</span>-->
<!--                <span class="camera-tag" :class="item.isFixed ? 'fixed' : 'movable'">-->
<!--                  {{ item.isFixed ? '固定镜头' : '移动镜头' }}-->
<!--                </span>-->
<!--              </span>-->
<!--              <span :class="['env-badge', item.environment === '真实场景' ? 'real-world' : 'lab']">{{ item.environment }}</span>-->
<!--              <span>{{ item.scenes }}</span>-->
<!--              <span :class="{ 'our-text': item.isOurs }">{{ item.duration }}</span>-->
<!--              &lt;!&ndash; <span>{{ item.fps }}</span> &ndash;&gt;-->
<!--              <span>{{ item.people }}</span>-->
<!--              <span>{{ item.one_min }}</span>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="note-box">-->
<!--            <div class="note-header">-->
<!--              &lt;!&ndash; <span>† 说明:</span> &ndash;&gt;-->
<!--              <span>† 说明:中广天择高清连续多视角4D视频数据集严格采用横屏、1080p、25fps的统一标准采集，多数单条视频时长超过60分钟，在各维度均实现了数量级跨越，能够完整覆盖从简单到复杂的动作体系。</span>-->
<!--            </div>-->
<!--            &lt;!&ndash; <div class="note-footer">-->
<!--              <span>可移动的，摄像机姿态在不同的视频序列中会发生变化。</span>-->
<!--            </div> &ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
      </section>

      <!-- 视频标注 -->
      <!-- <section id="annotation" class="section annotation-section">
        <div class="section-header">
          <h2 class="section-title">视频标注</h2>
        </div>
        <div class="annotation-content">
          <div class="annotation-card">
            <h3>多ID场景对比</h3>
            <div class="id-grid">
              <div class="id-item">ID_001</div>
              <div class="id-item">ID_002</div>
              <div class="id-item">ID_003</div>
              <div class="id-item">ID_004</div>
            </div>
            <p class="annotation-desc">
              在完全一致的光照与背景下，通过更换不同ID（演员）来丰富数据集的多样性。
            </p>
          </div>

          <div class="annotation-card">
            <h3>3D SMPL 标注可视化</h3>
            <div class="smpl-view">
              <span>🔧 3D Skeleton View</span>
            </div>
            <p class="annotation-desc">
              提供每一帧的高精度3D人体网格标注，支持骨骼点检测与姿态估计。
            </p>
          </div>
        </div>
      </section> -->

      <!-- 数据集结构 -->
      <section id="structure" class="section structure-section">
        <div class="section-header">
          <h2 class="section-title">数据集结构</h2>
          <p class="action-str-desc">我们提供结构化的各类声音事件标注数据，覆盖从音频级到片段级的声音信息。
            <br>数据包含多层级声音类别、场景类型、环境信息及对应时长与统计信息。</p>
        </div>
        <div class="structure-content">
          <div class="file-header">
            <span>📄 dataset_structure_preview.txt</span>
          </div>
          <div class="tree-view">
            <div class="tree-line tree-root">├── Dataset_Root/</div>
            <div class="tree-line tree-level1">│   ├── Audio_Dataset/</div>
            <div class="tree-line tree-level2">│   │   ├── Voice_Events/                            # 一级分类</div>
            <div class="tree-line tree-level3">│   │   │   ├── &lt;Secondary_Category&gt;/                       # 二级分类</div>
            <div class="tree-line tree-file">│   │   │   │   ├── &lt;audio01&gt;.wav                    # 任意音频文件</div>
            <div class="tree-line tree-file">│   │   │   │   ── &lt;audio01&gt;.json                   # 标注文件</div>
            <div class="tree-line tree-annotation">│   │   │   │       └── "segments": [                 # 标注列表结构</div>
            <div class="tree-line tree-object">│   │   │   │           └── {                         # 单条标注结构</div>
            <div class="tree-line tree-key">│   │   │   │               "time": [start, end],     # 1. 时间戳 (起止)</div>
            <div class="tree-line tree-key">│   │   │   │               "text": ""      # 2. 内容转写</div>
            <div class="tree-line tree-bracket">│   │   │   │           }</div>
            <div class="tree-line tree-bracket">│   │   │   │       ]</div>
            <div class="tree-line tree-divider">│   │</div>
            <div class="tree-line tree-level2">│   │   ├── Music_Events/                            # 一级分类</div>
            <div class="tree-line tree-level3">│   │   │   ├── &lt;Secondary_Category&gt;/                       # 二级分类</div>
            <div class="tree-line tree-file">│   │   │   │   ├── &lt;audio02&gt;.wav                    # 任意音频文件</div>
            <div class="tree-line tree-file">│   │   │   │   └── &lt;audio02&gt;.json                   # 标注文件</div>
            <div class="tree-line tree-annotation">│   │   │   │       └── "segments": [</div>
            <div class="tree-line tree-object">│   │   │   │           └── {</div>
            <div class="tree-line tree-key">│   │   │   │               "time": [start, end],     # 时间戳 (起止)</div>
            <div class="tree-line tree-key">│   │   │   │               "text": ""            # 内容</div>
            <div class="tree-line tree-bracket">│   │   │   │           }</div>
            <div class="tree-line tree-bracket">│   │   │   │       ]</div>
            <div class="tree-line tree-divider">│   │</div>
            <div class="tree-line tree-level2">│   │   ├── Natural_Sound_Events/                    # 一级分类</div>
            <div class="tree-line tree-level3">│   │   │   ├── &lt;Secondary_Category&gt;/                       # 二级分类</div>
            <div class="tree-line tree-file">│   │   │   │   ├── &lt;audio03&gt;.wav                    # 任意音频文件</div>
            <div class="tree-line tree-file">│   │   │   │   └── &lt;audio03&gt;.json                   # 标注文件</div>
            <div class="tree-line tree-object">│   │   │   │       └── {                             # JSON根对象</div>
            <div class="tree-line tree-annotation">│   │   │   │           "clauses": [                  # 事件列表 (不同声音事件类型均有体现)</div>
            <div class="tree-line tree-object">│   │   │   │               └── {                     # 单条事件结构</div>
            <div class="tree-line tree-key">│   │   │   │                   "text": "",      # 具体事件内容</div>
            <div class="tree-line tree-key">│   │   │   │                   "start": ,         # 起始时间戳</div>
            <div class="tree-line tree-key">│   │   │   │                   "end":           # 结束时间戳</div>
            <div class="tree-line tree-bracket">│   │   │   │               },</div>
            <div class="tree-line tree-ellipsis">│   │   │   │               ...                       # 更多细分事件</div>
            <div class="tree-line tree-bracket">│   │   │   │           ]</div>
            <div class="tree-line tree-bracket">│   │   │       }</div>
            <div class="tree-line tree-divider">│   │</div>
            <div class="tree-line tree-level2">│   │   └── Complex_Sound_Events/                    # 一级分类</div>
            <div class="tree-line tree-level3">│   │       ├── &lt;Secondary_Category&gt;/                       # 二级分类</div>
            <div class="tree-line tree-file">│   │       │   ├── &lt;audio04&gt;.wav                    # 任意音频文件</div>
            <div class="tree-line tree-file">│   │       │   └── &lt;audio04&gt;.json                   # 标注文件</div>
            <div class="tree-line tree-object">│   │       │       └── {                             # JSON根对象</div>
            <div class="tree-line tree-key">│   │       │           "duration": "&lt;Duration&gt;",         # 音频总时长</div>
            <div class="tree-line tree-key">│   │       │           "overall_description": "...", # 整体场景概括</div>
            <div class="tree-line tree-annotation">│   │       │           "sound_events": [             # 详细事件列表</div>
            <div class="tree-line tree-object">│   │       │               └── {                     # 单条事件结构</div>
            <div class="tree-line tree-key">│   │       │                   "sound_description": "...", # 详细的听觉描述</div>
            <div class="tree-line tree-key">│   │       │                   "speaker_description": "...", # 人员特征描述</div>
            <div class="tree-line tree-key">│   │       │                   "timestamp": "[start - end]" # 时间戳区间</div>
            <div class="tree-line tree-bracket">│   │       │               },</div>
            <div class="tree-line tree-ellipsis">│   │       │               ...                       # 更多事件片段</div>
            <div class="tree-line tree-bracket">│   │       │           ]</div>
            <div class="tree-line tree-bracket">│   │       │       }</div>
          </div>
          <!-- <div class="compliance-notice">
            <span>⚠</span>
            <span>使用本数据集需遵循商业合规协议</span>
          </div> -->
          <!-- <button class="download-btn" @click="downloadDocument">下载完整文档说明</button> -->
        </div>
      </section>

      <!-- 产品链接独立区域 -->
      <div style="width:96%;max-width:1340px;margin:0 auto 48px;text-align:center;padding:24px;background:rgba(96,165,250,0.08);border-radius:8px;box-sizing:border-box;">
        <a href="https://tvzone.cn/AI/index" target="_blank" style="display:inline-block;text-decoration:none;cursor:pointer;">
          <span style="color:#60a5fa;font-size:28px;font-weight:bold;">中广天择数据产品全系列产品官网</span>
          <svg style="vertical-align:middle;margin-left:8px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#60a5fa" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"/><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>        </a>
        <a href="https://tvzone.cn/AI/index" target="_blank" style="display:inline-block;margin-left:12px;color:#94a3b8;font-size:14px;text-decoration:none;cursor:pointer;">欢迎点击进入详情页观览</a>
      </div>
      <!-- 联系我们 -->
      <section id="contact" class="section contact-section">
        <div class="contact-content">
          <div class="contact-info">
            <h3>欢迎联系我们获取更多技术细节、沟通合作</h3>
            <div class="contact-item">
              <span>🏃‍♂️‍➡️</span>
              <span>中广天择传媒股份有限公司-数智中心</span>
            </div>
            <div class="contact-item">
              <div class="contact-address">聚焦高质量音视频算法训练语料的规模化研发、生产、运营交付等全链路
                <br> 成熟支撑国内多家顶尖科技公司的训练与场景化落地应用</div>
            </div>
            <div class="contact-item">
              <span>📧</span>
              <span>电子邮件</span>
            </div>
            <div class="contact-item">
              <div class="contact-address">szzx@tvzone.cn</div>
            </div>
            <div class="contact-item feishu-item">
              <span>💬</span>
              <span>加上飞书直接聊（请注明来意）</span>
            </div>
            <div class="contact-item">
              <img src="./assets/img/tongna.png" alt="飞书二维码" class="feishu-qr feishu-qr-small" @click="expandFeishuQR">
            </div>
            <div class="contact-item">
              <span>📍</span>
              <span>地址</span>
            </div>
            <div class="contact-address">湖南省长沙市开福区月湖街道鸭子铺路46号中广天择总部基地</div>
            <!-- <div class="contact-links"> -->
              <!-- <span>资源链接</span>
              <div class="link-group">
                <a href="#" class="link-item">GitHub Repo</a>
                <a href="#" class="link-item">集团主页</a>
                <a href="#" class="link-item">FreeMan API</a>
              </div> -->
            <!-- </div> -->
          </div>
          <div class="contact-qr">
            <!-- QR码占位 -->
            <img class="address-img" src="./assets/img/Address.png" alt="img">
          </div>
        </div>
        <div class="footer">
          <p>© 2026 中广天择2026真实世界全系列声学活动数据集. All rights reserved.</p>
        </div>
      </section>
    </div>
    <!-- 联系我们弹窗 -->
    <div class="modal-overlay" :class="{ 'modal-active': showContactModal }" @click="closeContactModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <div class="modal-title-wrapper">
<!--            <h3 class="modal-title">让我们联系您</h3>-->
            <!--            <img src="./assets/img/tongna.png" alt="联系我们" class="modal-image">-->
          </div>
          <button class="modal-close" @click="closeContactModal">×</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitContactForm">
            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">👤</span>
                姓名
              </label>
              <input
                  v-model="contactForm.name"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的姓名"
              >
            </div>

            <!--            <div class="form-group">-->
            <!--              <label class="form-label">性别</label>-->
            <!--              <div class="radio-group">-->
            <!--                <label class="radio-item">-->
            <!--                  <input-->
            <!--                      type="radio"-->
            <!--                      v-model="contactForm.gender"-->
            <!--                      value="男"-->
            <!--                      name="gender"-->
            <!--                  >-->
            <!--                  <span>男</span>-->
            <!--                </label>-->
            <!--                <label class="radio-item">-->
            <!--                  <input-->
            <!--                      type="radio"-->
            <!--                      v-model="contactForm.gender"-->
            <!--                      value="女"-->
            <!--                      name="gender"-->
            <!--                  >-->
            <!--                  <span>女</span>-->
            <!--                </label>-->
            <!--              </div>-->
            <!--            </div>-->

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">📱</span>
                联系电话
              </label>
              <input
                  v-model="contactForm.phone"
                  type="tel"
                  class="form-input"
                  placeholder="请输入您的联系电话"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">🏢</span>
                公司名称
              </label>
              <input
                  v-model="contactForm.company"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的公司名称"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon">✉️</span>
                工作邮箱
              </label>
              <input
                  v-model="contactForm.email"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的工作邮箱"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <span class="label-icon"></span>
                职位
              </label>
              <input
                  v-model="contactForm.position"
                  type="text"
                  class="form-input"
                  placeholder="请输入您的职位"
              >
            </div>

            <div class="form-group">
              <textarea
                  v-model="contactForm.message"
                  class="form-textarea"
                  placeholder="请详细描述您的需求、数据集规模以及预期效果，我们会尽快回复您。"
                  rows="4"
              ></textarea>
            </div>

            <!--            <div class="submit-image-wrapper">-->
            <!--              <img src="./assets/img/tongna.png" alt="提交" class="submit-image">-->
            <!--            </div>-->

            <button type="submit" class="submit-btn">提交</button>
          </form>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <!--    <div class="image-preview-overlay" :class="{ 'preview-active': showPreview }" @click="closeImagePreview">-->
    <!--      <div class="image-preview-content" @click.stop>-->
    <!--        <button class="preview-close" @click="closeImagePreview">×</button>-->
    <!--        <img src="./assets/img/tongna.png" alt="预览" class="preview-image">-->
    <!--      </div>-->
    <!--    </div>-->


    <!-- 飞书二维码预览弹窗 -->
    <div class="feishu-preview-overlay" :class="{ 'feishu-preview-active': showFeishuPreview }" @click="closeFeishuPreview">
      <div class="feishu-preview-content" @click.stop>
        <button class="feishu-preview-close" @click="closeFeishuPreview">×</button>
        <img src="./assets/img/tongna.png" alt="飞书二维码" class="feishu-preview-image">
      </div>
    </div>
    <!-- 右侧悬浮栏 -->
    <div class="floating-sidebar">
      <!-- 飞书按钮 -->
      <!--      <div-->
      <!--          class="sidebar-item sidebar-item-top"-->
      <!--          id="feishu-btn"-->
      <!--      >-->
      <!--        <div class="sidebar-icon">-->
      <!--          <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">-->
      <!--            <path d="M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM12 2C6.48 2 2 6 2 11c0 2.76 1.38 5.26 3.59 6.93L5 22l4.64-2.32A10.9 10.9 0 0 0 12 20c5.52 0 10-4 10-9S17.52 2 12 2z"/>-->
      <!--          </svg>-->
      <!--        </div>-->
      <!--        <span class="sidebar-label">飞书</span>-->
      <!--      </div>-->

      <!--      &lt;!&ndash; 分隔线 &ndash;&gt;-->
      <!--      <div class="sidebar-divider"></div>-->

      <!-- 邮箱按钮 -->
<!--      <div-->
<!--          class="sidebar-item sidebar-item-email"-->
<!--          id="email-btn"-->
<!--      >-->
<!--        <div class="sidebar-icon">-->
<!--          <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">-->
<!--            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span class="sidebar-label">邮件</span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Plotly from 'plotly.js/dist/plotly.min.js';
window.Plotly = Plotly;
export default {
  name: 'LanhuFrame',
  data() {
    return {
      // 轮播图相关
      carouselIndex1: 0,
      carouselIndex2: 0,
      carouselIndex3: 0,
      carouselIndex4: 0,
      carouselImages1: [
        // require('./assets/sjts_img/ka1/1.jpg'),
        // require('./assets/sjts_img/ka1/2.jpg'),
        // require('./assets/sjts_img/ka1/3.jpg'),
        require('./assets/sjts_img/ka1/4.jpg'),
        // require('./assets/sjts_img/ka1/5.jpg'),
        // require('./assets/sjts_img/ka1/6.jpeg'),
        // require('./assets/sjts_img/ka1/7.jpg'),
        // require('./assets/sjts_img/ka1/8.jpeg'),
        // require('./assets/sjts_img/ka1/9.jpg'),
        // require('./assets/sjts_img/ka1/10.jpg'),
      ],
      carouselImages2: [
        require('./assets/sjts_img/ka2/1.jpg'),
        require('./assets/sjts_img/ka2/2.png'),
        require('./assets/sjts_img/ka2/3.png'),
      ],
      carouselImages3: [
        require('./assets/sjts_img/ka3/1.jpeg'),
        require('./assets/sjts_img/ka3/2.jpeg'),
        require('./assets/sjts_img/ka3/3.jpg'),
        require('./assets/sjts_img/ka3/4.jpeg'),
        require('./assets/sjts_img/ka3/5.jpg'),
        require('./assets/sjts_img/ka3/6.jpeg'),
        require('./assets/sjts_img/ka3/7.jpeg'),
        require('./assets/sjts_img/ka3/8.jpeg'),
        require('./assets/sjts_img/ka3/9.jpeg'),
        require('./assets/sjts_img/ka3/10.jpeg'),
        require('./assets/sjts_img/ka3/11.jpeg'),
        require('./assets/sjts_img/ka3/12.jpeg'),
        require('./assets/sjts_img/ka3/13.jpeg'),
        require('./assets/sjts_img/ka3/14.jpg'),
      ],
      carouselImages4: [
        require('./assets/sjts_img/ka4/1.jpg'),
        require('./assets/sjts_img/ka4/2.jpg'),
        require('./assets/sjts_img/ka4/3.jpg'),
        require('./assets/sjts_img/ka4/4.jpg'),
        require('./assets/sjts_img/ka4/5.jpg'),
        require('./assets/sjts_img/ka4/6.jpg'),
        require('./assets/sjts_img/ka4/7.jpg'),
        require('./assets/sjts_img/ka4/8.jpg'),
      ],
      carouselTimer1: null,
      carouselTimer2: null,
      carouselTimer3: null,
      carouselTimer4: null,
      currentPlaying: -1,
      audioProgress: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      audioCurrentTime: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      audioDuration: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      isNavbarFixed: false,
      isScrolled: false,
      plotlyLoaded: false,
      showContactModal: false,
      showFeishuTip: false,
      showEmailTip: false,
      showFeishuPreview: false,
      contactForm: {
        name: '',
        gender: '',
        phone: '',
        company: '',
        email: '',
        position: '',
        message: ''
      },
      videoLoaded: {
        solo: false,
        two: false,
        audio: false
      },
      plotlyData: {
        branchvalues: "total",
        customdata: [["人声"],["复杂"],["自然"],["音乐"],["“不好”的声音"],["“不屑”的声音"],["“亲嘴”的声音"],["“切”的声音"],["“口吃”的声音"],["“叫喊”声"],["“叹气”声"],["“吃东西”的声音"],["“吞咽”声"],["“吸气”声"],["“吸溜”声"],["“吹口哨”的声音"],["“吹气”的声音"],["“吼”的声音"],["“呕吐”声"],["“呱”的声音"],["“呵”的声音"],["“呼吸”声"],["“呼气”声"],["“咀嚼”声"],["“咦”的声音"],["“咯咯”声"],["“咳嗽”声"],["“咳痰”声音"],["“咻”的声音"],["“哀嚎”声"],["“哆嗦”的声音"],["“哈欠”声"],["“哭”的声音"],["“哽咽”声"],["“喏”声"],["“喘气”的声音"],["“喝东西”的声音"],["“嘟”的声音"],["“嘲讽”声"],["“嘶”声"],["“嘶哈”声"],["“嘿”的声音"],["“嚯”的声音"],["“奥”的声音"],["“好”的声音"],["“尖叫”的声音"],["“干杯”的声音"],["“应和”声"],["“开心”的声音"],["“弹舌”的声音"],["“惊叹”声"],["“打响指”的声音"],["“打喷嚏”的声音"],["“打嗝”的声音"],["“打招呼”的声音"],["“打气”声"],["“打耳光”的声音"],["“打鼾”的声音"],["“抖腿”声"],["“抽泣”的声音"],["“拍打”的声音"],["“搓手”的声音"],["“摩擦”的声音"],["“摸索”声"],["“撒娇”声"],["“欢呼”的声音"],["“气泡”声"],["“漱口”声音"],["“生气”的声音"],["“略略”声"],["“疑惑”声"],["“疑问”声"],["“疼痛”的声音"],["“磨牙”声"],["“突突”声"],["“笑”声"],["“练气”声"],["“自我介绍”声"],["“赶动物”声音"],["“跺脚”的声音"],["“逗小孩”声音"],["“闻”的声音"],["“额”的声音"],["“鼓掌”声"],["”吞咽“声"],["发出“OK”的声音"],["发出“吧唧”的声音"],["发出“呲”的声音"],["发出“哇”的声音"],["发出“哦”的声音"],["发出“哼”的声音"],["发出“唉”的声音"],["发出“唉呀”的声音"],["发出“唤动物”声音"],["发出“啊”的声音"],["发出“喂”的声音"],["发出“嗨”的声音"],["发出“嗯”的声音"],["发出“嘘”的声音"],["发出“噗”的声音"],["发出“尴尬”的声音"],["发出“擤鼻涕”的声音"],["发出“颤音”"],["发出“鼻音”"],["学动物叫声"],["小声说话"],["长音"],["室内"],["室外"],["城市环境声"],["城市环境音"],["特定设备声"],["自然界声音"],["乐器合奏"],["乐器演奏"],["交响乐演出"],["伴奏"],["合唱"],["唱歌"],["戏曲"],["进行曲"],["通俗唱法"],["音乐演奏"],["音乐盒"],["音效合成"],["“不好”的声音"],["“不屑”的声音"],["“亲嘴”的声音"],["“亲嘴”的声音"],["“亲嘴”的声音"],["“切”的声音"],["“切”的声音"],["“口吃”的声音"],["“口吃”的声音"],["“叫喊”声"],["“叫喊”声"],["“叫喊”声"],["“叫喊”声"],["“叹气”声"],["“叹气”声"],["“叹气”声"],["“叹气”声"],["“叹气”声"],["“叹气”声"],["“吃东西”的声音"],["“吃东西”的声音"],["“吃东西”的声音"],["“吃东西”的声音"],["“吞咽”声"],["“吞咽”声"],["“吞咽”声"],["“吸气”声"],["“吸气”声"],["“吸溜”声"],["“吹口哨”的声音"],["“吹口哨”的声音"],["“吹口哨”的声音"],["“吹气”的声音"],["“吹气”的声音"],["“吼”的声音"],["“吼”的声音"],["“吼”的声音"],["“吼”的声音"],["“吼”的声音"],["“吼”的声音"],["“吼”的声音"],["“呕吐”声"],["“呕吐”声"],["“呱”的声音"],["“呵”的声音"],["“呵”的声音"],["“呼吸”声"],["“呼吸”声"],["“呼气”声"],["“呼气”声"],["“呼气”声"],["“咀嚼”声"],["“咀嚼”声"],["“咦”的声音"],["“咦”的声音"],["“咦”的声音"],["“咦”的声音"],["“咦”的声音"],["“咯咯”声"],["“咳嗽”声"],["“咳嗽”声"],["“咳嗽”声"],["“咳嗽”声"],["“咳嗽”声"],["“咳痰”声音"],["“咻”的声音"],["“咻”的声音"],["“哀嚎”声"],["“哀嚎”声"],["“哆嗦”的声音"],["“哆嗦”的声音"],["“哆嗦”的声音"],["“哈欠”声"],["“哈欠”声"],["“哈欠”声"],["“哈欠”声"],["“哈欠”声"],["“哈欠”声"],["“哈欠”声"],["“哈欠”声"],["“哭”的声音"],["“哭”的声音"],["“哭”的声音"],["“哭”的声音"],["“哭”的声音"],["“哭”的声音"],["“哽咽”声"],["“喏”声"],["“喘气”的声音"],["“喘气”的声音"],["“喘气”的声音"],["“喘气”的声音"],["“喝东西”的声音"],["“喝东西”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘟”的声音"],["“嘲讽”声"],["“嘲讽”声"],["“嘲讽”声"],["“嘲讽”声"],["“嘲讽”声"],["“嘶”声"],["“嘶”声"],["“嘶哈”声"],["“嘶哈”声"],["“嘿”的声音"],["“嘿”的声音"],["“嘿”的声音"],["“嘿”的声音"],["“嚯”的声音"],["“嚯”的声音"],["“嚯”的声音"],["“奥”的声音"],["“好”的声音"],["“尖叫”的声音"],["“尖叫”的声音"],["“尖叫”的声音"],["“干杯”的声音"],["“应和”声"],["“应和”声"],["“开心”的声音"],["“开心”的声音"],["“开心”的声音"],["“开心”的声音"],["“开心”的声音"],["“弹舌”的声音"],["“弹舌”的声音"],["“弹舌”的声音"],["“弹舌”的声音"],["“弹舌”的声音"],["“惊叹”声"],["“惊叹”声"],["“惊叹”声"],["“惊叹”声"],["“惊叹”声"],["“惊叹”声"],["“打响指”的声音"],["“打喷嚏”的声音"],["“打喷嚏”的声音"],["“打喷嚏”的声音"],["“打喷嚏”的声音"],["“打喷嚏”的声音"],["“打喷嚏”的声音"],["“打嗝”的声音"],["“打嗝”的声音"],["“打嗝”的声音"],["“打招呼”的声音"],["“打招呼”的声音"],["“打气”声"],["“打气”声"],["“打气”声"],["“打气”声"],["“打耳光”的声音"],["“打耳光”的声音"],["“打耳光”的声音"],["“打耳光”的声音"],["“打鼾”的声音"],["“打鼾”的声音"],["“打鼾”的声音"],["“打鼾”的声音"],["“打鼾”的声音"],["“抖腿”声"],["“抽泣”的声音"],["“抽泣”的声音"],["“抽泣”的声音"],["“抽泣”的声音"],["“抽泣”的声音"],["“拍打”的声音"],["“拍打”的声音"],["“拍打”的声音"],["“拍打”的声音"],["“拍打”的声音"],["“拍打”的声音"],["“拍打”的声音"],["“搓手”的声音"],["“搓手”的声音"],["“摩擦”的声音"],["“摩擦”的声音"],["“摸索”声"],["“摸索”声"],["“撒娇”声"],["“撒娇”声"],["“欢呼”的声音"],["“欢呼”的声音"],["“气泡”声"],["“漱口”声音"],["“漱口”声音"],["“生气”的声音"],["“生气”的声音"],["“略略”声"],["“略略”声"],["“疑惑”声"],["“疑问”声"],["“疼痛”的声音"],["“疼痛”的声音"],["“疼痛”的声音"],["“磨牙”声"],["“磨牙”声"],["“磨牙”声"],["“磨牙”声"],["“突突”声"],["“笑”声"],["“笑”声"],["“练气”声"],["“练气”声"],["“自我介绍”声"],["“赶动物”声音"],["“赶动物”声音"],["“跺脚”的声音"],["“跺脚”的声音"],["“跺脚”的声音"],["“逗小孩”声音"],["“逗小孩”声音"],["“闻”的声音"],["“闻”的声音"],["“闻”的声音"],["“闻”的声音"],["“闻”的声音"],["“额”的声音"],["“额”的声音"],["“额”的声音"],["“鼓掌”声"],["“鼓掌”声"],["“鼓掌”声"],["“鼓掌”声"],["”吞咽“声"],["”吞咽“声"],["发出“OK”的声音"],["发出“吧唧”的声音"],["发出“吧唧”的声音"],["发出“吧唧”的声音"],["发出“吧唧”的声音"],["发出“吧唧”的声音"],["发出“呲”的声音"],["发出“呲”的声音"],["发出“呲”的声音"],["发出“呲”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哇”的声音"],["发出“哦”的声音"],["发出“哦”的声音"],["发出“哦”的声音"],["发出“哦”的声音"],["发出“哦”的声音"],["发出“哼”的声音"],["发出“哼”的声音"],["发出“哼”的声音"],["发出“哼”的声音"],["发出“哼”的声音"],["发出“哼”的声音"],["发出“哼”的声音"],["发出“唉”的声音"],["发出“唉”的声音"],["发出“唉”的声音"],["发出“唉”的声音"],["发出“唉”的声音"],["发出“唉呀”的声音"],["发出“唉呀”的声音"],["发出“唉呀”的声音"],["发出“唉呀”的声音"],["发出“唉呀”的声音"],["发出“唉呀”的声音"],["发出“唤动物”声音"],["发出“唤动物”声音"],["发出“唤动物”声音"],["发出“唤动物”声音"],["发出“唤动物”声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“啊”的声音"],["发出“喂”的声音"],["发出“喂”的声音"],["发出“嗨”的声音"],["发出“嗨”的声音"],["发出“嗯”的声音"],["发出“嗯”的声音"],["发出“嗯”的声音"],["发出“嗯”的声音"],["发出“嗯”的声音"],["发出“嘘”的声音"],["发出“嘘”的声音"],["发出“嘘”的声音"],["发出“嘘”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“噗”的声音"],["发出“尴尬”的声音"],["发出“擤鼻涕”的声音"],["发出“擤鼻涕”的声音"],["发出“颤音”"],["发出“颤音”"],["发出“颤音”"],["发出“颤音”"],["发出“颤音”"],["发出“鼻音”"],["发出“鼻音”"],["发出“鼻音”"],["学动物叫声"],["学动物叫声"],["学动物叫声"],["小声说话"],["小声说话"],["小声说话"],["长音"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室内"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["室外"],["城市环境声"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["城市环境音"],["特定设备声"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["自然界声音"],["乐器合奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["乐器演奏"],["交响乐演出"],["伴奏"],["合唱"],["唱歌"],["戏曲"],["进行曲"],["通俗唱法"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐演奏"],["音乐盒"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"],["音效合成"]],
        ids: ["人声","复杂","自然","音乐","人声/“不好”的声音","人声/“不屑”的声音","人声/“亲嘴”的声音","人声/“切”的声音","人声/“口吃”的声音","人声/“叫喊”声","人声/“叹气”声","人声/“吃东西”的声音","人声/“吞咽”声","人声/“吸气”声","人声/“吸溜”声","人声/“吹口哨”的声音","人声/“吹气”的声音","人声/“吼”的声音","人声/“呕吐”声","人声/“呱”的声音","人声/“呵”的声音","人声/“呼吸”声","人声/“呼气”声","人声/“咀嚼”声","人声/“咦”的声音","人声/“咯咯”声","人声/“咳嗽”声","人声/“咳痰”声音","人声/“咻”的声音","人声/“哀嚎”声","人声/“哆嗦”的声音","人声/“哈欠”声","人声/“哭”的声音","人声/“哽咽”声","人声/“喏”声","人声/“喘气”的声音","人声/“喝东西”的声音","人声/“嘟”的声音","人声/“嘲讽”声","人声/“嘶”声","人声/“嘶哈”声","人声/“嘿”的声音","人声/“嚯”的声音","人声/“奥”的声音","人声/“好”的声音","人声/“尖叫”的声音","人声/“干杯”的声音","人声/“应和”声","人声/“开心”的声音","人声/“弹舌”的声音","人声/“惊叹”声","人声/“打响指”的声音","人声/“打喷嚏”的声音","人声/“打嗝”的声音","人声/“打招呼”的声音","人声/“打气”声","人声/“打耳光”的声音","人声/“打鼾”的声音","人声/“抖腿”声","人声/“抽泣”的声音","人声/“拍打”的声音","人声/“搓手”的声音","人声/“摩擦”的声音","人声/“摸索”声","人声/“撒娇”声","人声/“欢呼”的声音","人声/“气泡”声","人声/“漱口”声音","人声/“生气”的声音","人声/“略略”声","人声/“疑惑”声","人声/“疑问”声","人声/“疼痛”的声音","人声/“磨牙”声","人声/“突突”声","人声/“笑”声","人声/“练气”声","人声/“自我介绍”声","人声/“赶动物”声音","人声/“跺脚”的声音","人声/“逗小孩”声音","人声/“闻”的声音","人声/“额”的声音","人声/“鼓掌”声","人声/”吞咽“声","人声/发出“OK”的声音","人声/发出“吧唧”的声音","人声/发出“呲”的声音","人声/发出“哇”的声音","人声/发出“哦”的声音","人声/发出“哼”的声音","人声/发出“唉”的声音","人声/发出“唉呀”的声音","人声/发出“唤动物”声音","人声/发出“啊”的声音","人声/发出“喂”的声音","人声/发出“嗨”的声音","人声/发出“嗯”的声音","人声/发出“嘘”的声音","人声/发出“噗”的声音","人声/发出“尴尬”的声音","人声/发出“擤鼻涕”的声音","人声/发出“颤音”","人声/发出“鼻音”","人声/学动物叫声","人声/小声说话","人声/长音","复杂/室内","复杂/室外","自然/城市环境声","自然/城市环境音","自然/特定设备声","自然/自然界声音","音乐/乐器合奏","音乐/乐器演奏","音乐/交响乐演出","音乐/伴奏","音乐/合唱","音乐/唱歌","音乐/戏曲","音乐/进行曲","音乐/通俗唱法","音乐/音乐演奏","音乐/音乐盒","音乐/音效合成","人声/“不好”的声音/否定不好","人声/“不屑”的声音/淡漠不屑声","人声/“亲嘴”的声音/亲昵亲嘴","人声/“亲嘴”的声音/细碎亲嘴声","人声/“亲嘴”的声音/轻吻亲吻","人声/“切”的声音/不屑切","人声/“切”的声音/冷淡切声","人声/“口吃”的声音/滞涩口吃声","人声/“口吃”的声音/结巴口吃","人声/“叫喊”声/娇柔喊妈妈","人声/“叫喊”声/朦胧迷糊时的叫喊","人声/“叫喊”声/激昂呐喊声","人声/“叫喊”声/稚嫩喊爸爸","人声/“叹气”声/低沉叹息声","人声/“叹气”声/怅然惋惜声","人声/“叹气”声/意外惊叹声","人声/“叹气”声/沉闷叹气声","人声/“叹气”声/落寞叹气","人声/“叹气”声/轻缓叹息","人声/“吃东西”的声音/咀嚼吃食物","人声/“吃东西”的声音/慢咽吃东西声音","人声/“吃东西”的声音/细品吃东西的声音","人声/“吃东西”的声音/细嚼吃东西","人声/“吞咽”声/厚重吞咽声","人声/“吞咽”声/自然吞咽","人声/“吞咽”声/馋人咽口水声","人声/“吸气”声/绵长吸气声","人声/“吸气”声/轻缓吸气","人声/“吸溜”声/软糯吸溜声","人声/“吹口哨”的声音/婉转口哨声","人声/“吹口哨”的声音/悠扬吹口哨","人声/“吹口哨”的声音/清亮口哨","人声/“吹气”的声音/徐缓吹气声","人声/“吹气”的声音/轻送吹气","人声/“吼”的声音/仿声模仿摩托车","人声/“吼”的声音/凄厉嘶吼声","人声/“吼”的声音/暴怒怒吼声","人声/“吼”的声音/沉闷低吼声","人声/“吼”的声音/浑厚低泡声","人声/“吼”的声音/粗狂吼","人声/“吼”的声音/震鸣吼声","人声/“呕吐”声/作呕呕吐","人声/“呕吐”声/反胃呕吐","人声/“呱”的声音/低沉呱声","人声/“呵”的声音/淡然呵声","人声/“呵”的声音/轻缓呵气","人声/“呼吸”声/匀净呼吸","人声/“呼吸”声/平缓呼吸声","人声/“呼气”声/悠然呼声","人声/“呼气”声/绵长呼气声","人声/“呼气”声/轻吐呼气","人声/“咀嚼”声/沉稳咀嚼声","人声/“咀嚼”声/鲜香咀嚼","人声/“咦”的声音/娇软咦呀","人声/“咦”的声音/婉转咦呀","人声/“咦”的声音/惊奇咦","人声/“咦”的声音/柔和咦音","人声/“咦”的声音/轻细咦声","人声/“咯咯”声/清脆咯咯声","人声/“咳嗽”声/低沉清嗓子","人声/“咳嗽”声/利落清嗓子声","人声/“咳嗽”声/沉实咳嗽声","人声/“咳嗽”声/粗哑口噪声","人声/“咳嗽”声/轻浅咳嗽","人声/“咳痰”声音/浊重咯痰","人声/“咻”的声音/破空咻声","人声/“咻”的声音/连绵咻咻声","人声/“哀嚎”声/凄切哀嚎","人声/“哀嚎”声/悲凉哀嚎声","人声/“哆嗦”的声音/发颤哆嗦","人声/“哆嗦”的声音/微抖哆嗦声","人声/“哆嗦”的声音/瑟缩打哆嗦","人声/“哈欠”声/低柔哈声","人声/“哈欠”声/倦意哈气声","人声/“哈欠”声/倦闷斯哈","人声/“哈欠”声/困倦哈欠","人声/“哈欠”声/慵懒哈","人声/“哈欠”声/松弛哈气","人声/“哈欠”声/沉缓哈欠声","人声/“哈欠”声/绵长哈气声","人声/“哭”的声音/低沉呜咽声","人声/“哭”的声音/凄切哭声","人声/“哭”的声音/哽咽呜咽","人声/“哭”的声音/喜极边笑边哭","人声/“哭”的声音/委屈哭","人声/“哭”的声音/闷郁唔声","人声/“哽咽”声/酸涩哽咽声","人声/“喏”声/应声喏声","人声/“喘气”的声音/低吟喘息声","人声/“喘气”的声音/微喘喘息","人声/“喘气”的声音/急促喘气","人声/“喘气”的声音/粗重喘气声","人声/“喝东西”的声音/清冽喝水声","人声/“喝东西”的声音/畅快喝东西","人声/“嘟”的声音/低沉嘟噜声","人声/“嘟”的声音/圆润打嘟","人声/“嘟”的声音/抿嘴嘟嘴声","人声/“嘟”的声音/碎念嘟囔声","人声/“嘟”的声音/绵软打嘟噜","人声/“嘟”的声音/绵长打嘟噜声","人声/“嘟”的声音/轻响打嘟声","人声/“嘟”的声音/轻扬嘟声","人声/“嘟”的声音/连环嘟嘟声","人声/“嘲讽”声/冷言讥讽声","人声/“嘲讽”声/厌弃呸声","人声/“嘲讽”声/嗤笑哧哧声","人声/“嘲讽”声/疏离嫌弃声","人声/“嘲讽”声/轻鄙呸","人声/“嘶”声/倒吸嘶","人声/“嘶”声/冷嘶嘶声","人声/“嘶哈”声/忍痛嘶哈","人声/“嘶哈”声/抽气嘶哈","人声/“嘿”的声音/利落嘿","人声/“嘿”的声音/昂扬嘿呀","人声/“嘿”的声音/清亮嘿声","人声/“嘿”的声音/爽朗嘿嘿","人声/“嚯”的声音/惊觉嚯","人声/“嚯”的声音/短促嚯声","人声/“嚯”的声音/诧异嚯咦声","人声/“奥”的声音/恍然奥声","人声/“好”的声音/爽快好","人声/“尖叫”的声音/刺耳尖叫","人声/“尖叫”的声音/尖锐尖叫声","人声/“尖叫”的声音/清亮叫声","人声/“干杯”的声音/碰杯干杯声","人声/“应和”声/利落应和声","人声/“应和”声/随和应和声","人声/“开心”的声音/热忱恭喜","人声/“开心”的声音/舒展放松声","人声/“开心”的声音/舒心愉悦","人声/“开心”的声音/雀跃耶","人声/“开心”的声音/高扬耶声","人声/“弹舌”的声音/利落咋舌","人声/“弹舌”的声音/利落弹舌","人声/“弹舌”的声音/利落弹舌声","人声/“弹舌”的声音/清越弹舌声","人声/“弹舌”的声音/脆响弹舌","人声/“惊叹”声/恍然惊讶哦豁","人声/“惊叹”声/愕然惊叹声","人声/“惊叹”声/扬调惊讶声调上扬声","人声/“惊叹”声/由衷赞叹声","人声/“惊叹”声/讶异惊讶","人声/“惊叹”声/诧异惊讶声","人声/“打响指”的声音/脆亮打响指","人声/“打喷嚏”的声音/低哑啧声","人声/“打喷嚏”的声音/断续啧啧声","人声/“打喷嚏”的声音/猝然打喷嚏","人声/“打喷嚏”的声音/短促喷嚏","人声/“打喷嚏”的声音/轻抿啧","人声/“打喷嚏”的声音/闷响打喷嚏声","人声/“打嗝”的声音/突兀打嗝声","人声/“打嗝”的声音/轻顿嗝","人声/“打嗝”的声音/闷逆打嗝","人声/“打招呼”的声音/温和打招呼声","人声/“打招呼”的声音/随和打招呼","人声/“打气”声/沉厚用力声","人声/“打气”声/激昂喝彩声","人声/“打气”声/雄浑劳动号子","人声/“打气”声/鼓劲加油","人声/“打耳光”的声音/凌厉耳光","人声/“打耳光”的声音/清亮打耳光声","人声/“打耳光”的声音/脆响打耳光","人声/“打耳光”的声音/震响耳光声","人声/“打鼾”的声音/厚重打鼾","人声/“打鼾”的声音/悠远鼾声","人声/“打鼾”的声音/沉缓打鼾声","人声/“打鼾”的声音/沉闷打呼噜声","人声/“打鼾”的声音/酣然打呼噜","人声/“抖腿”声/轻晃抖腿声","人声/“抽泣”的声音/低泣抽噎声","人声/“抽泣”的声音/哽咽抽噎","人声/“抽泣”的声音/心酸抽泣","人声/“抽泣”的声音/悲切抽泣声","人声/“抽泣”的声音/断续抽气声","人声/“拍打”的声音/厚实胸脯声","人声/“拍打”的声音/沉稳敲门声","人声/“拍打”的声音/清脆敲打声","人声/“拍打”的声音/笃定拍胸脯声","人声/“拍打”的声音/轻拍护肤","人声/“拍打”的声音/轻缓身体拍打声","人声/“拍打”的声音/重拍桌子","人声/“搓手”的声音/干涩搓手声","人声/“搓手”的声音/摩擦搓手","人声/“摩擦”的声音/干涩摩擦声","人声/“摩擦”的声音/粗砺刮擦声","人声/“摸索”声/细碎悉悉索索","人声/“摸索”声/脆响掰手指","人声/“撒娇”声/甜柔撒娇声","人声/“撒娇”声/软媚撒娇","人声/“欢呼”的声音/热烈欢呼声","人声/“欢呼”的声音/雀跃欢呼","人声/“气泡”声/轻盈气泡声","人声/“漱口”声音/清爽漱口","人声/“漱口”声音/轻响漱口声","人声/“生气”的声音/怒吼咆哮","人声/“生气”的声音/暴怒咆哮","人声/“略略”声/俏皮吐舌头略","人声/“略略”声/调皮略略声","人声/“疑惑”声/不解质疑声","人声/“疑问”声/困惑疑问声","人声/“疼痛”的声音/刺痛痛感声","人声/“疼痛”的声音/痛苦呻吟声","人声/“疼痛”的声音/难忍疼痛声","人声/“磨牙”声/沉震磨牙声","人声/“磨牙”声/磨动齿音","人声/“磨牙”声/紧咬磨牙","人声/“磨牙”声/轻叩叩齿声","人声/“突突”声/急促突突声","人声/“笑”声/开怀笑","人声/“笑”声/清甜笑声","人声/“练气”声/凝神练功声","人声/“练气”声/聚气练气声","人声/“自我介绍”声/大方自我介绍","人声/“赶动物”声音/厉声驱赶动物","人声/“赶动物”声音/呵斥赶动物","人声/“跺脚”的声音/厚重跺脚声","人声/“跺脚”的声音/沉稳脚部声音","人声/“跺脚”的声音/用力跺脚","人声/“逗小孩”声音/亲昵逗孩子","人声/“逗小孩”声音/童趣小孩互动","人声/“闻”的声音/凑近嗅闻","人声/“闻”的声音/淡淡嗅闻声","人声/“闻”的声音/清幽嗅声","人声/“闻”的声音/细碎闻嗅声","人声/“闻”的声音/轻浅闻嗅","人声/“额”的声音/沉吟额声","人声/“额”的声音/迟疑额","人声/“额”的声音/顿住额音","人声/“鼓掌”声/合拍手掌拍打","人声/“鼓掌”声/洪亮掌声","人声/“鼓掌”声/热烈鼓掌声","人声/“鼓掌”声/节奏鼓点声","人声/”吞咽“声/沉闷咽吞声","人声/”吞咽“声/顺滑咽水","人声/发出“OK”的声音/爽快OK","人声/发出“吧唧”的声音/慵懒咂嘴声","人声/发出“吧唧”的声音/满足吧唧嘴","人声/发出“吧唧”的声音/玩味咂舌","人声/发出“吧唧”的声音/贪吃吧唧","人声/发出“吧唧”的声音/轻弹咂舌声","人声/发出“呲”的声音/冷厉呲声","人声/发出“呲”的声音/憋笑噗呲","人声/发出“呲”的声音/细碎呲呲声","人声/发出“呲”的声音/轻嗤呲呲","人声/发出“哇”的声音/呆萌的哇偶","人声/发出“哇”的声音/响亮的哇塞","人声/发出“哇”的声音/夸张的哇塞","人声/发出“哇”的声音/委屈的哇哇","人声/发出“哇”的声音/小声的哇唔","人声/发出“哇”的声音/悠长的哇","人声/发出“哇”的声音/惊喜的哇","人声/发出“哇”的声音/惊讶的哇","人声/发出“哇”的声音/慌张的哇呀","人声/发出“哇”的声音/爽朗的哇","人声/发出“哇”的声音/突然的打","人声/发出“哇”的声音/调皮的哇","人声/发出“哇”的声音/软萌的哇呜","人声/发出“哇”的声音/轻轻的哇声","人声/发出“哇”的声音/难过的呜哇","人声/发出“哦”的声音/恍然哦","人声/发出“哦”的声音/惊喜哦吼","人声/发出“哦”的声音/惋惜哦豁","人声/发出“哦”的声音/无奈哦豁声","人声/发出“哦”的声音/清淡哦声","人声/发出“哼”的声音/不屑哼","人声/发出“哼”的声音/冷淡哼声","人声/发出“哼”的声音/愉悦哼唱","人声/发出“哼”的声音/温柔哼唱声","人声/发出“哼”的声音/赌气哼气","人声/发出“哼”的声音/软萌哼唧","人声/发出“哼”的声音/轻快哼唱","人声/发出“唉”的声音/低沉唉声","人声/发出“唉”的声音/无奈唉","人声/发出“唉”的声音/柔和唉","人声/发出“唉”的声音/轻叹唉声","人声/发出“唉”的声音/轻细唉声","人声/发出“唉呀”的声音/娇俏唉呀","人声/发出“唉呀”的声音/娇呼唉呀","人声/发出“唉呀”的声音/婉转唉呀声","人声/发出“唉呀”的声音/惊呼唉呀","人声/发出“唉呀”的声音/清甜唉呀","人声/发出“唉呀”的声音/轻缓唉呀","人声/发出“唤动物”声音/呼唤动物","人声/发出“唤动物”声音/投喂喂动物","人声/发出“唤动物”声音/招呼动物","人声/发出“唤动物”声音/温柔啰啰声","人声/发出“唤动物”声音/轻唤嘬声","人声/发出“啊”的声音/哽咽呜啊","人声/发出“啊”的声音/婉转啊呀声","人声/发出“啊”的声音/平淡啊声","人声/发出“啊”的声音/微弱低啊声","人声/发出“啊”的声音/恍然啊哦","人声/发出“啊”的声音/惊呀啊","人声/发出“啊”的声音/柔和啊哦声","人声/发出“啊”的声音/欢快啊哈","人声/发出“啊”的声音/爽朗啊哈声","人声/发出“啊”的声音/高亢啊叫声","人声/发出“喂”的声音/大声喂","人声/发出“喂”的声音/小声喂","人声/发出“嗨”的声音/开朗嗨","人声/发出“嗨”的声音/清爽嗨声","人声/发出“嗯”的声音/低沉嗯声","人声/发出“嗯”的声音/娇软嗯哼声","人声/发出“嗯”的声音/宠溺嗯哼","人声/发出“嗯”的声音/应诺嗯","人声/发出“嗯”的声音/软糯嗯嗯声","人声/发出“嘘”的声音/低声嘘","人声/发出“嘘”的声音/大声嘘","人声/发出“嘘”的声音/短嘘","人声/发出“嘘”的声音/长嘘","人声/发出“噗”的声音/不屑噗 撇唇声","人声/发出“噗”的声音/可爱噗 打噗噜","人声/发出“噗”的声音/含糊噗 秃噜声","人声/发出“噗”的声音/委屈噗 瘪嘴声","人声/发出“噗”的声音/安静噗 噤声","人声/发出“噗”的声音/尴尬噗 屁声","人声/发出“噗”的声音/短促噗 噗声","人声/发出“噗”的声音/细微噗 噗噗声","人声/发出“噗”的声音/细碎噗 嘴部口腔声","人声/发出“噗”的声音/轻快噗 噗噗","人声/发出“尴尬”的声音/窘迫尴尬声","人声/发出“擤鼻涕”的声音/轻擤鼻涕","人声/发出“擤鼻涕”的声音/重擤鼻涕","人声/发出“颤音”/微抖颤声","人声/发出“颤音”/惊惧颤抖","人声/发出“颤音”/柔转颤音","人声/发出“颤音”/瑟缩打寒颤","人声/发出“颤音”/绵长颤音声","人声/发出“鼻音”/慵懒鼻息声","人声/发出“鼻音”/软糯鼻音","人声/发出“鼻音”/闷沉鼻声","人声/学动物叫声/情绪高涨的模仿声","人声/学动物叫声/蛙鸣","人声/学动物叫声/骑马","人声/小声说话/呓语声","人声/小声说话/呢喃声","人声/小声说话/悄悄话声","人声/长音/很长的拖音","复杂/室内/KTV","复杂/室内/中医馆","复杂/室内/乐器店","复杂/室内/人活动音50","复杂/室内/企业--团建","复杂/室内/企业--大厅","复杂/室内/休闲","复杂/室内/会议室","复杂/室内/会议室-95","复杂/室内/便利店","复杂/室内/停车场","复杂/室内/健身房","复杂/室内/写字楼","复杂/室内/冰块厂","复杂/室内/别墅","复杂/室内/剧组--剧目","复杂/室内/剧组--影视","复杂/室内/剧院","复杂/室内/办公室","复杂/室内/动物园","复杂/室内/包子铺","复杂/室内/医院","复杂/室内/卫生院","复杂/室内/台球厅","复杂/室内/台球店","复杂/室内/咖啡店","复杂/室内/商业","复杂/室内/商业娱乐50","复杂/室内/商场","复杂/室内/商店","复杂/室内/地下车库","复杂/室内/场馆","复杂/室内/大头贴店","复杂/室内/奶茶店","复杂/室内/娱乐场所","复杂/室内/学校","复杂/室内/室内","复杂/室内/室内-49","复杂/室内/家庭","复杂/室内/家庭-1","复杂/室内/密室逃脱","复杂/室内/寺庙","复杂/室内/小酒馆","复杂/室内/居家","复杂/室内/居家环境","复杂/室内/展厅","复杂/室内/展厅-4","复杂/室内/展览","复杂/室内/工作室","复杂/室内/工厂--室内厂房","复杂/室内/工厂--户外厂房","复杂/室内/工厂--户外厂房-1","复杂/室内/幼儿园","复杂/室内/幼儿园--校园环境50","复杂/室内/彩票店","复杂/室内/快递服务站","复杂/室内/戏院","复杂/室内/扎染房","复杂/室内/拳击店","复杂/室内/按摩店","复杂/室内/教育机构","复杂/室内/文体活动","复杂/室内/文化学习","复杂/室内/文娱活动","复杂/室内/文艺活动","复杂/室内/文艺活动50","复杂/室内/日常活动","复杂/室内/服装店","复杂/室内/服饰店","复杂/室内/机场","复杂/室内/校园--初中日常","复杂/室内/校园--初中课堂","复杂/室内/校园--大学上课","复杂/室内/校园--大学日常","复杂/室内/校园--大学生活日常","复杂/室内/校园--大学课堂","复杂/室内/校园--小学","复杂/室内/校园--小学日常","复杂/室内/校园--小学课堂","复杂/室内/校园--小学课堂-1","复杂/室内/校园--幼儿园日常","复杂/室内/校园--幼儿园课堂","复杂/室内/校园--高中","复杂/室内/校园--高中日常","复杂/室内/校园--高中课堂","复杂/室内/棋牌室","复杂/室内/民宿","复杂/室内/汽修店","复杂/室内/活动大厅","复杂/室内/游戏体验馆","复杂/室内/游戏厅","复杂/室内/演唱会","复杂/室内/演播厅","复杂/室内/火锅店","复杂/室内/照相馆","复杂/室内/猫粮店","复杂/室内/理发店","复杂/室内/理疗店、中医馆","复杂/室内/甜品店","复杂/室内/生态农场","复杂/室内/生活日常","复杂/室内/生活日常小件","复杂/室内/电梯","复杂/室内/电梯间","复杂/室内/电竞酒店","复杂/室内/直播间","复杂/室内/直播间-4","复杂/室内/眼镜店","复杂/室内/社区","复杂/室内/社区中心","复杂/室内/社区菜市场50","复杂/室内/篮球馆","复杂/室内/网吧","复杂/室内/美容美甲店","复杂/室内/美术馆","复杂/室内/美甲店","复杂/室内/羽毛球场","复杂/室内/羽毛球馆","复杂/室内/聚会活动","复杂/室内/聚会活动-2","复杂/室内/舞蹈室","复杂/室内/茶馆","复杂/室内/茶馆内","复杂/室内/药店","复杂/室内/药材研制工作室","复杂/室内/菜市场","复杂/室内/菠萝地","复杂/室内/蔬菜大棚","复杂/室内/蛋糕店内","复杂/室内/警情--消防","复杂/室内/话剧场","复杂/室内/购物场所","复杂/室内/超市","复杂/室内/车内","复杂/室内/车库","复杂/室内/车辆","复杂/室内/软件教学","复杂/室内/酒吧","复杂/室内/酒店","复杂/室内/酒馆","复杂/室内/银行","复杂/室内/雕刻室","复杂/室内/零食店","复杂/室内/零食店50","复杂/室内/音响店","复杂/室内/餐厅","复杂/室内/餐饮","复杂/室内/餐饮店","复杂/室内/饭店","复杂/室内/高中课堂","复杂/室内/麻将馆","复杂/室外/乡村","复杂/室外/交通--城市公交","复杂/室外/交通--城市地铁","复杂/室外/交通--城市客运出租","复杂/室外/交通--自驾","复杂/室外/交通--自驾-81","复杂/室外/交通--轮渡","复杂/室外/交通--铁路客运","复杂/室外/交通工具维修","复杂/室外/企业--业务推广发布相关活动","复杂/室外/企业--周边-停车场-通道等","复杂/室外/企业--周边-停车场-通道等-1","复杂/室外/体育活动50","复杂/室外/公园","复杂/室外/农场","复杂/室外/农村","复杂/室外/农村生活","复杂/室外/农林牧渔--森林-1","复杂/室外/农林牧渔--渔场","复杂/室外/农林牧渔--滩涂","复杂/室外/商业街","复杂/室外/地铁站","复杂/室外/城市--公园","复杂/室外/城市--公园--湿地--口袋公园","复杂/室外/城市--公园--湿地公园下水道","复杂/室外/城市--广场","复杂/室外/室外","复杂/室外/小区","复杂/室外/山林","复杂/室外/工地","复杂/室外/工程机械","复杂/室外/市场","复杂/室外/广场","复杂/室外/庭院","复杂/室外/张掖七彩丹霞旅游景区","复杂/室外/操场","复杂/室外/施工","复杂/室外/施工噪音50","复杂/室外/施工现场","复杂/室外/景区","复杂/室外/景区--人文景区","复杂/室外/景区--自然景区","复杂/室外/枸杞地","复杂/室外/树林","复杂/室外/比赛现场","复杂/室外/比赛现场-9","复杂/室外/水上","复杂/室外/沙滩","复杂/室外/河边","复杂/室外/泳池","复杂/室外/海边","复杂/室外/涠洲岛","复杂/室外/游乐园","复杂/室外/游乐场","复杂/室外/湖边","复杂/室外/湘江边","复杂/室外/滑翔伞","复杂/室外/滑雪场","复杂/室外/球场","复杂/室外/甘蔗地","复杂/室外/田边","复杂/室外/祁连山","复杂/室外/船","复杂/室外/船上","复杂/室外/草原","复杂/室外/菜园","复杂/室外/菜市场","复杂/室外/街边","复杂/室外/警情--消防","复杂/室外/路边","复杂/室外/路边食物摊50","复杂/室外/车内","复杂/室外/集市","复杂/室外/露台","复杂/室外/青海湖二朗剑景区","复杂/室外/飞机","复杂/室外/飞机上","复杂/室外/马场","复杂/室外/马术场","复杂/室外/马路边","复杂/室外/马路边--乡村","复杂/室外/马路边--城市","复杂/室外/马路边--城郊","复杂/室外/马路边--集镇","复杂/室外/驾校","复杂/室外/驾校--交通工具教学","复杂/室外/驾校户外","复杂/室外/高铁","复杂/室外/高铁上","复杂/室外/高铁站","自然/城市环境声/大学--课后休息日常生活环境","自然/城市环境音/交通噪音-主干道十字路口东西向（有风的影响）","自然/城市环境音/交通噪音-主干道十字路口西东向（有风的影响）","自然/城市环境音/交通噪音-乡村","自然/城市环境音/交通噪音-停车场","自然/城市环境音/交通噪音-公交站","自然/城市环境音/交通噪音-公交车","自然/城市环境音/交通噪音-公交车内","自然/城市环境音/交通噪音-公交车和车站","自然/城市环境音/交通噪音-公交车站","自然/城市环境音/交通噪音-公园","自然/城市环境音/交通噪音-共享电动车","自然/城市环境音/交通噪音-动车、列车","自然/城市环境音/交通噪音-十字路口","自然/城市环境音/交通噪音-古镇","自然/城市环境音/交通噪音-商业街","自然/城市环境音/交通噪音-国道","自然/城市环境音/交通噪音-地下车库","自然/城市环境音/交通噪音-地下车库双车道","自然/城市环境音/交通噪音-地铁","自然/城市环境音/交通噪音-地铁站","自然/城市环境音/交通噪音-垃圾站","自然/城市环境音/交通噪音-城市路边人行道","自然/城市环境音/交通噪音-城郊","自然/城市环境音/交通噪音-城郊公路","自然/城市环境音/交通噪音-城郊车辆","自然/城市环境音/交通噪音-大巴车","自然/城市环境音/交通噪音-大桥","自然/城市环境音/交通噪音-大道旁","自然/城市环境音/交通噪音-学校","自然/城市环境音/交通噪音-室内","自然/城市环境音/交通噪音-室内窗边","自然/城市环境音/交通噪音-室外","自然/城市环境音/交通噪音-小区","自然/城市环境音/交通噪音-工地","自然/城市环境音/交通噪音-工地上","自然/城市环境音/交通噪音-幼儿园","自然/城市环境音/交通噪音-景区","自然/城市环境音/交通噪音-桥上","自然/城市环境音/交通噪音-水上交通","自然/城市环境音/交通噪音-江边","自然/城市环境音/交通噪音-汽车维修店","自然/城市环境音/交通噪音-湖泊边","自然/城市环境音/交通噪音-火车","自然/城市环境音/交通噪音-牧区","自然/城市环境音/交通噪音-电动车","自然/城市环境音/交通噪音-电动车上","自然/城市环境音/交通噪音-私家车内","自然/城市环境音/交通噪音-窗外","自然/城市环境音/交通噪音-网约和出租车","自然/城市环境音/交通噪音-街道","自然/城市环境音/交通噪音-货运车辆","自然/城市环境音/交通噪音-路边","自然/城市环境音/交通噪音-路边停车内休息","自然/城市环境音/交通噪音-车内","自然/城市环境音/交通噪音-车库","自然/城市环境音/交通噪音-轻轨交通","自然/城市环境音/交通噪音-轿车上","自然/城市环境音/交通噪音-轿车内","自然/城市环境音/交通噪音-酒店","自然/城市环境音/交通噪音-隧道","自然/城市环境音/交通噪音-雨天马路边","自然/城市环境音/交通噪音-露营地","自然/城市环境音/交通噪音-飞机","自然/城市环境音/交通噪音-马路边","自然/城市环境音/交通噪音-马路边交通车流胎噪声+不规律鸣笛","自然/城市环境音/交通噪音-高架","自然/城市环境音/交通噪音-高架桥","自然/城市环境音/交通噪音-高楼","自然/城市环境音/交通噪音-高铁","自然/城市环境音/人活动声-儿童乐园","自然/城市环境音/人活动声-吃东西","自然/城市环境音/人活动声-商场","自然/城市环境音/人活动声-学校","自然/城市环境音/人活动声-家庭","自然/城市环境音/人活动声-快递站","自然/城市环境音/人活动声-教育机构","自然/城市环境音/人活动声-话剧院","自然/城市环境音/人活动声-走路","自然/城市环境音/人活动声-音效","自然/城市环境音/人活动声-饭馆","自然/城市环境音/人活动音-","自然/城市环境音/人活动音-KTV","自然/城市环境音/人活动音-乒乓球馆","自然/城市环境音/人活动音-乡下","自然/城市环境音/人活动音-便利店","自然/城市环境音/人活动音-候车厅","自然/城市环境音/人活动音-停车场","自然/城市环境音/人活动音-公园","自然/城市环境音/人活动音-养殖场","自然/城市环境音/人活动音-写字楼","自然/城市环境音/人活动音-农村","自然/城市环境音/人活动音-农贸市场","自然/城市环境音/人活动音-出租房","自然/城市环境音/人活动音-办公室","自然/城市环境音/人活动音-医院","自然/城市环境音/人活动音-厨房","自然/城市环境音/人活动音-台球厅","自然/城市环境音/人活动音-咖啡店","自然/城市环境音/人活动音-商业街","自然/城市环境音/人活动音-商场","自然/城市环境音/人活动音-商店","自然/城市环境音/人活动音-地下车库","自然/城市环境音/人活动音-地下通道","自然/城市环境音/人活动音-地铁","自然/城市环境音/人活动音-地铁站","自然/城市环境音/人活动音-垃圾回收站","自然/城市环境音/人活动音-城市河道","自然/城市环境音/人活动音-夜市","自然/城市环境音/人活动音-大市场","自然/城市环境音/人活动音-奶茶店","自然/城市环境音/人活动音-学校","自然/城市环境音/人活动音-室内","自然/城市环境音/人活动音-室外","自然/城市环境音/人活动音-密室","自然/城市环境音/人活动音-寺庙","自然/城市环境音/人活动音-小区","自然/城市环境音/人活动音-小学环境音","自然/城市环境音/人活动音-小巷","自然/城市环境音/人活动音-山","自然/城市环境音/人活动音-幼儿园","自然/城市环境音/人活动音-广场","自然/城市环境音/人活动音-快递驿站","自然/城市环境音/人活动音-教室","自然/城市环境音/人活动音-景区","自然/城市环境音/人活动音-机场","自然/城市环境音/人活动音-棋牌室","自然/城市环境音/人活动音-橘子洲","自然/城市环境音/人活动音-步行街","自然/城市环境音/人活动音-民俗体验馆","自然/城市环境音/人活动音-江边","自然/城市环境音/人活动音-汽车站","自然/城市环境音/人活动音-河边","自然/城市环境音/人活动音-洗手间","自然/城市环境音/人活动音-洗车店","自然/城市环境音/人活动音-游乐场","自然/城市环境音/人活动音-湖边","自然/城市环境音/人活动音-火车","自然/城市环境音/人活动音-火车站","自然/城市环境音/人活动音-烧烤店","自然/城市环境音/人活动音-理发店","自然/城市环境音/人活动音-电动车","自然/城市环境音/人活动音-电影院","自然/城市环境音/人活动音-电梯口","自然/城市环境音/人活动音-电玩城","自然/城市环境音/人活动音-磁浮列车","自然/城市环境音/人活动音-篮球场","自然/城市环境音/人活动音-网吧","自然/城市环境音/人活动音-美术馆","自然/城市环境音/人活动音-美甲店","自然/城市环境音/人活动音-羽毛球馆","自然/城市环境音/人活动音-舞蹈室","自然/城市环境音/人活动音-花店","自然/城市环境音/人活动音-菜市场","自然/城市环境音/人活动音-菜鸟驿站","自然/城市环境音/人活动音-蔬菜大棚","自然/城市环境音/人活动音-街道边","自然/城市环境音/人活动音-超市","自然/城市环境音/人活动音-足球场","自然/城市环境音/人活动音-车内","自然/城市环境音/人活动音-酒店","自然/城市环境音/人活动音-银行","自然/城市环境音/人活动音-飞机","自然/城市环境音/人活动音-飞机场","自然/城市环境音/人活动音-餐饮店","自然/城市环境音/人活动音-马路边","自然/城市环境音/人活动音-高铁","自然/城市环境音/人活动音-高铁站","自然/城市环境音/会议室","自然/城市环境音/体育活动","自然/城市环境音/体育活动50","自然/城市环境音/公园","自然/城市环境音/剧组-","自然/城市环境音/办公室","自然/城市环境音/医院-","自然/城市环境音/商业商场","自然/城市环境音/商业娱乐-KFC","自然/城市环境音/商业娱乐-KTV","自然/城市环境音/商业娱乐-便利店","自然/城市环境音/商业娱乐-公园","自然/城市环境音/商业娱乐-写字楼","自然/城市环境音/商业娱乐-医院","自然/城市环境音/商业娱乐-台球厅","自然/城市环境音/商业娱乐-咖啡店","自然/城市环境音/商业娱乐-商业广场","自然/城市环境音/商业娱乐-商业推广","自然/城市环境音/商业娱乐-商场","自然/城市环境音/商业娱乐-商场、广场","自然/城市环境音/商业娱乐-商场嘈杂声","自然/城市环境音/商业娱乐-商店","自然/城市环境音/商业娱乐-地铁","自然/城市环境音/商业娱乐-夜宵摊","自然/城市环境音/商业娱乐-夜市","自然/城市环境音/商业娱乐-奶茶店","自然/城市环境音/商业娱乐-娱乐场所","自然/城市环境音/商业娱乐-娱乐活动","自然/城市环境音/商业娱乐-宜家","自然/城市环境音/商业娱乐-宠物乐园","自然/城市环境音/商业娱乐-室外","自然/城市环境音/商业娱乐-家具超市","自然/城市环境音/商业娱乐-密室","自然/城市环境音/商业娱乐-展馆","自然/城市环境音/商业娱乐-岳麓山","自然/城市环境音/商业娱乐-市场","自然/城市环境音/商业娱乐-幼儿园","自然/城市环境音/商业娱乐-广场","自然/城市环境音/商业娱乐-店铺","自然/城市环境音/商业娱乐-废品店","自然/城市环境音/商业娱乐-彩票店","自然/城市环境音/商业娱乐-快递站","自然/城市环境音/商业娱乐-按摩店","自然/城市环境音/商业娱乐-教育机构","自然/城市环境音/商业娱乐-景区","自然/城市环境音/商业娱乐-服装店","自然/城市环境音/商业娱乐-棋牌","自然/城市环境音/商业娱乐-水果店","自然/城市环境音/商业娱乐-洗车店","自然/城市环境音/商业娱乐-游乐场","自然/城市环境音/商业娱乐-理发店","自然/城市环境音/商业娱乐-电影院","自然/城市环境音/商业娱乐-电玩城","自然/城市环境音/商业娱乐-百货店","自然/城市环境音/商业娱乐-精品店","自然/城市环境音/商业娱乐-网吧","自然/城市环境音/商业娱乐-网吧电竞","自然/城市环境音/商业娱乐-药店","自然/城市环境音/商业娱乐-菜市场","自然/城市环境音/商业娱乐-街边商贩","自然/城市环境音/商业娱乐-超市","自然/城市环境音/商业娱乐-路边","自然/城市环境音/商业娱乐-酒馆","自然/城市环境音/商业娱乐-餐饮","自然/城市环境音/商业娱乐-餐饮店","自然/城市环境音/商业娱乐-饭馆","自然/城市环境音/商业娱乐-马路边","自然/城市环境音/商业娱乐50-","自然/城市环境音/城郊","自然/城市环境音/娱乐","自然/城市环境音/居家环境-","自然/城市环境音/居家环境50-厨房冰块","自然/城市环境音/居家环境51-餐桌","自然/城市环境音/广场","自然/城市环境音/户外日常","自然/城市环境音/文艺团体","自然/城市环境音/文艺现场","自然/城市环境音/施工噪音-","自然/城市环境音/施工噪音-交通施工","自然/城市环境音/施工噪音-公路","自然/城市环境音/施工噪音-商场","自然/城市环境音/施工噪音-商场外","自然/城市环境音/施工噪音-喷漆声","自然/城市环境音/施工噪音-园区","自然/城市环境音/施工噪音-地下车库","自然/城市环境音/施工噪音-场地维护","自然/城市环境音/施工噪音-安置小区","自然/城市环境音/施工噪音-室内","自然/城市环境音/施工噪音-室外","自然/城市环境音/施工噪音-小区","自然/城市环境音/施工噪音-工地","自然/城市环境音/施工噪音-店铺","自然/城市环境音/施工噪音-户外空地","自然/城市环境音/施工噪音-楼道","自然/城市环境音/施工噪音-汽车修理厂","自然/城市环境音/施工噪音-汽车维修店","自然/城市环境音/施工噪音-街边","自然/城市环境音/施工噪音-超市","自然/城市环境音/施工噪音-路边","自然/城市环境音/施工噪音-路面","自然/城市环境音/施工噪音-车间","自然/城市环境音/施工噪音-酒店","自然/城市环境音/校园--幼儿园","自然/城市环境音/校园-初中日常","自然/城市环境音/校园-大学日常","自然/城市环境音/校园-大学课堂","自然/城市环境音/校园-高中日常","自然/城市环境音/生活日常小件","自然/城市环境音/电脑城","自然/城市环境音/社区菜市场","自然/城市环境音/社区菜市场50","自然/城市环境音/自驾","自然/城市环境音/警报声-地铁","自然/城市环境音/警报声-提示音","自然/城市环境音/警报声-警示语音声","自然/城市环境音/赛事现场50-湘超株洲展演和比赛全程观众区八个通道","自然/城市环境音/超市","自然/城市环境音/路边菜摊-","自然/城市环境音/路边食物摊-","自然/城市环境音/路边食物摊50-","自然/城市环境音/车内","自然/城市环境音/运动场地","自然/城市环境音/酒吧歌厅-","自然/城市环境音/酒店-","自然/城市环境音/餐饮","自然/特定设备声/家电设备","自然/自然界声音/动物声音-","自然/自然界声音/动物声音-中华田园犬","自然/自然界声音/动物声音-乌鸦","自然/自然界声音/动物声音-企鹅的叫声","自然/自然界声音/动物声音-其他鸟类","自然/自然界声音/动物声音-北极熊的叫声","自然/自然界声音/动物声音-奶牛","自然/自然界声音/动物声音-家鸡","自然/自然界声音/动物声音-海鸥","自然/自然界声音/动物声音-白鹭","自然/自然界声音/动物声音-禽类聚集","自然/自然界声音/动物声音-红腹锦鸡","自然/自然界声音/动物声音-边境牧羊犬","自然/自然界声音/动物声音-金毛","自然/自然界声音/动物声音-鸭","自然/自然界声音/动物声音-鹅","自然/自然界声音/动物声音-鹅叫","自然/自然界声音/动物声音-鹦鹉","自然/自然界声音/动物声音-麻雀","自然/自然界声音/地理水文","自然/自然界声音/地理水文-人造景观、非自然类水流水滴声","自然/自然界声音/地理水文-人造设施_排水管道声","自然/自然界声音/地理水文-人造设施_水渠声","自然/自然界声音/地理水文-大块冰川断裂落水声","自然/自然界声音/地理水文-大山山口呼啸声","自然/自然界声音/地理水文-大山暴风雪后寂静的声音","自然/自然界声音/地理水文-山泉水声","自然/自然界声音/地理水文-山洞里的水滴声","自然/自然界声音/地理水文-山环境底噪","自然/自然界声音/地理水文-山谷的呼啸声","自然/自然界声音/地理水文-平原打雷的声音","自然/自然界声音/地理水文-平原环境底噪","自然/自然界声音/地理水文-无风的午后森林","自然/自然界声音/地理水文-树枝摇曳的声音","自然/自然界声音/地理水文-森林环境底噪","自然/自然界声音/地理水文-正常洞穴的声音","自然/自然界声音/地理水文-江水拍岸声","自然/自然界声音/地理水文-江水拍打亲水平台声","自然/自然界声音/地理水文-江面起伏声","自然/自然界声音/地理水文-沙丘的声音","自然/自然界声音/地理水文-沙漠峡谷的呼啸声","自然/自然界声音/地理水文-河流流水声","自然/自然界声音/地理水文-洞穴里风声","自然/自然界声音/地理水文-海底水流涌动的声音","自然/自然界声音/地理水文-海浪击打人工堤坝声","自然/自然界声音/地理水文-海浪拍打沙滩声","自然/自然界声音/地理水文-海浪拍打海岸的声音","自然/自然界声音/地理水文-海浪拍打礁石声","自然/自然界声音/地理水文-湖水冲击人工护坡声","自然/自然界声音/地理水文-湖水拍岸声","自然/自然界声音/地理水文-湖水拍打石头声","自然/自然界声音/地理水文-湖水高低落差声","自然/自然界声音/地理水文-湖面平静的水声","自然/自然界声音/地理水文-湖面水滴落声","自然/自然界声音/地理水文-湖面起伏声","自然/自然界声音/地理水文-溪水由高处跌落深潭沉闷声","自然/自然界声音/地理水文-溪流在河床转弯处激荡声","自然/自然界声音/地理水文-溪流流水声","自然/自然界声音/地理水文-田野","自然/自然界声音/地理水文-风吹过枯草的声音","自然/自然界声音/地理水文-风吹过草原的声音","自然/自然界声音/天气现象","自然/自然界声音/天气现象-中雨","自然/自然界声音/天气现象-大雨","自然/自然界声音/天气现象-大风","自然/自然界声音/天气现象-小雨","自然/自然界声音/天气现象-微风","自然/自然界声音/天气现象-雨打在尼龙雨伞面","自然/自然界声音/天气现象-雨水打在雨幕","自然/自然界声音/天气现象-雨水滴入水池","自然/自然界声音/天气现象-雨滴打在雨棚","自然/自然界声音/天气现象-雨落到帐篷","自然/自然界声音/天气现象-雨落在叶片","自然/自然界声音/天气现象-雨落在塑料面","自然/自然界声音/天气现象-雨落在塑胶跑道","自然/自然界声音/天气现象-雨落在木质面","自然/自然界声音/天气现象-雨落在水泥路面","自然/自然界声音/天气现象-雨落在汽车挡风玻璃","自然/自然界声音/天气现象-雨落在汽车顶部","自然/自然界声音/天气现象-雨落在泡沫上","自然/自然界声音/天气现象-雨落在泥土","自然/自然界声音/天气现象-雨落在石质面","自然/自然界声音/天气现象-雨落在草地","自然/自然界声音/天气现象-雨落在金属面","自然/自然界声音/天气现象-雨落在防盗窗","自然/自然界声音/天气现象-雨落在雨棚","自然/自然界声音/天气现象-雨量渐变","自然/自然界声音/天气现象-雪水融化滴落","自然/自然界声音/天气现象-雷雨声","自然/自然界声音/天气现象-风吹动帐篷声","自然/自然界声音/天气现象-风吹动管道声","自然/自然界声音/天气现象-风吹动铁索栏杆声","自然/自然界声音/天气现象-风吹塑料薄膜声","自然/自然界声音/天气现象-风吹塑料袋","自然/自然界声音/天气现象-风通过缝隙声","自然/自然界声音/植物声音","自然/自然界声音/植物声音-干竹枝叶摩擦声","自然/自然界声音/植物声音-干芭蕉树枝叶摩擦声","自然/自然界声音/植物声音-干草本植物、灌木丛摩擦声","自然/自然界声音/植物声音-混合枝叶摩擦声","自然/自然界声音/植物声音-混合枝叶踩踏声","自然/自然界声音/植物声音-湿杜鹃花枝叶摩擦声","自然/自然界声音/植物声音-湿竹枝叶摩擦声","自然/自然界声音/植物声音-湿草本植物、灌木丛摩擦声","音乐/乐器合奏/乐器合奏1","音乐/乐器演奏/中世纪六弦鲁特","音乐/乐器演奏/中世纪号","音乐/乐器演奏/中世纪小吉他","音乐/乐器演奏/中世纪小笛子","音乐/乐器演奏/中世纪小管风琴","音乐/乐器演奏/中世纪希尔博琴","音乐/乐器演奏/中世纪木质竖笛","音乐/乐器演奏/中世纪维吉那琴","音乐/乐器演奏/中世纪羽管键琴","音乐/乐器演奏/中世纪长号","音乐/乐器演奏/中世纪长颈鲁特琴","音乐/乐器演奏/中世纪高音直笛","音乐/乐器演奏/中世纪鲁特琴","音乐/乐器演奏/中提琴","音乐/乐器演奏/中胡","音乐/乐器演奏/乐器合奏","音乐/乐器演奏/二胡","音乐/乐器演奏/二胡与其他乐器","音乐/乐器演奏/低音号-50","音乐/乐器演奏/低音笛子-50","音乐/乐器演奏/低音长号-50","音乐/乐器演奏/单簧管-50","音乐/乐器演奏/印度乐器印度手风琴","音乐/乐器演奏/印度乐器桑图尔琴","音乐/乐器演奏/印度乐器班苏里笛","音乐/乐器演奏/印度乐器西塔琴","音乐/乐器演奏/双簧管","音乐/乐器演奏/口琴-49","音乐/乐器演奏/吉他--古典吉他","音乐/乐器演奏/吉他--民谣吉他","音乐/乐器演奏/哨笛-50","音乐/乐器演奏/唐布拉琴","音乐/乐器演奏/唢呐","音乐/乐器演奏/圆号","音乐/乐器演奏/坦克鼓","音乐/乐器演奏/大阮","音乐/乐器演奏/定音锣-50","音乐/乐器演奏/小号","音乐/乐器演奏/小提琴音色","音乐/乐器演奏/巴松-50","音乐/乐器演奏/巴洛克小提琴-50","音乐/乐器演奏/巴洛克琴-50","音乐/乐器演奏/弹拨--古琴","音乐/乐器演奏/弹拨--古琴-50","音乐/乐器演奏/弹拨--琵琶","音乐/乐器演奏/手摇琴","音乐/乐器演奏/手碟","音乐/乐器演奏/打击乐","音乐/乐器演奏/拨片鲁特琴-50","音乐/乐器演奏/指拨","音乐/乐器演奏/提琴--大提琴","音乐/乐器演奏/提琴--大提琴-50","音乐/乐器演奏/提琴--小提琴","音乐/乐器演奏/日本乐器SHAKUHACHI-49","音乐/乐器演奏/日本乐器TSUGARU SHAMISEN-49","音乐/乐器演奏/日本乐器日本笙-50","音乐/乐器演奏/木琴-49","音乐/乐器演奏/杜卡纳管-50","音乐/乐器演奏/民族-扬琴","音乐/乐器演奏/玻璃琴-50","音乐/乐器演奏/班博尔德笛子-50","音乐/乐器演奏/电声乐器--电吉他","音乐/乐器演奏/电声乐器--电贝司","音乐/乐器演奏/电声乐器--电颤琴-50","音乐/乐器演奏/短笛","音乐/乐器演奏/竖琴","音乐/乐器演奏/管风琴-50","音乐/乐器演奏/英国号","音乐/乐器演奏/萧","音乐/乐器演奏/萨克斯-49","音乐/乐器演奏/贝斯-50","音乐/乐器演奏/钟琴","音乐/乐器演奏/长号","音乐/乐器演奏/长笛","音乐/乐器演奏/阿拉伯乐器乌德琴-50","音乐/乐器演奏/阿拉伯乐器内伊笛子-50","音乐/乐器演奏/阿拉伯乐器卡农琴-50","音乐/乐器演奏/阿拉伯乐器卡瓦拉笛子-50","音乐/乐器演奏/阿拉伯乐器布祖基琴-50","音乐/乐器演奏/阿拉伯乐器撒兹琴-50","音乐/乐器演奏/音乐节拍器100bpm","音乐/乐器演奏/音乐节拍器105bpm","音乐/乐器演奏/音乐节拍器110bpm","音乐/乐器演奏/音乐节拍器115bpm","音乐/乐器演奏/音乐节拍器120bpm","音乐/乐器演奏/音乐节拍器125bpm","音乐/乐器演奏/音乐节拍器130bpm","音乐/乐器演奏/音乐节拍器135bpm","音乐/乐器演奏/音乐节拍器140bpm","音乐/乐器演奏/音乐节拍器145bpm","音乐/乐器演奏/音乐节拍器150bpm","音乐/乐器演奏/音乐节拍器155bpm","音乐/乐器演奏/音乐节拍器160bpm","音乐/乐器演奏/音乐节拍器165bpm","音乐/乐器演奏/音乐节拍器170bpm","音乐/乐器演奏/音乐节拍器175bpm","音乐/乐器演奏/音乐节拍器180bpm","音乐/乐器演奏/音乐节拍器185bpm","音乐/乐器演奏/音乐节拍器190bpm","音乐/乐器演奏/音乐节拍器50bpm","音乐/乐器演奏/音乐节拍器55bpm","音乐/乐器演奏/音乐节拍器60bpm","音乐/乐器演奏/音乐节拍器65bpm","音乐/乐器演奏/音乐节拍器70bpm","音乐/乐器演奏/音乐节拍器75bpm","音乐/乐器演奏/音乐节拍器75bpm 版本2","音乐/乐器演奏/音乐节拍器80bpm","音乐/乐器演奏/音乐节拍器85bpm","音乐/乐器演奏/音乐节拍器90bpm","音乐/乐器演奏/音乐节拍器95bpm","音乐/乐器演奏/马林巴-50","音乐/乐器演奏/鼓-中国鼓","音乐/乐器演奏/鼓-架子鼓-50","音乐/交响乐演出/交响乐演出实况","音乐/伴奏/伴奏1","音乐/合唱/合唱--50","音乐/唱歌/唱歌50","音乐/戏曲/戏曲50","音乐/进行曲/进行曲1","音乐/通俗唱法/通俗唱法1","音乐/音乐演奏/12.31摇滚重金属重金属","音乐/音乐演奏/12.86摇滚重金属颗粒合成音色","音乐/音乐演奏/80s合成器音色摇滚","音乐/音乐演奏/80年代合成器摇滚","音乐/音乐演奏/80年代合成器重金属","音乐/音乐演奏/90年代合成器摇滚","音乐/音乐演奏/rapKpop音色","音乐/音乐演奏/rap中频温暖合成器音色","音乐/音乐演奏/rap主奏合成器","音乐/音乐演奏/rap主奏氛围合成器","音乐/音乐演奏/rap主奏铃铛合成器","音乐/音乐演奏/rap人声合成器","音乐/音乐演奏/rap低音浑厚合成器","音乐/音乐演奏/rap低频扭曲音色","音乐/音乐演奏/rap低频水晶质感音色","音乐/音乐演奏/rap低频能量合成器音色","音乐/音乐演奏/rap八音盒音色","音乐/音乐演奏/rap吉他合成器","音乐/音乐演奏/rap圆润合成器","音乐/音乐演奏/rap圆润电子琴","音乐/音乐演奏/rap弹跳音色","音乐/音乐演奏/rap微失真合成器","音乐/音乐演奏/rap微失真明亮合成器","音乐/音乐演奏/rap微失真沉闷合成器","音乐/音乐演奏/rap微失真跳跃合成器","音乐/音乐演奏/rap拨奏类合成器音色","音乐/音乐演奏/rap摇摆合成器","音乐/音乐演奏/rap放松氛围合成器","音乐/音乐演奏/rap明亮合成器","音乐/音乐演奏/rap有侵略性的音色","音乐/音乐演奏/rap氛围合成器","音乐/音乐演奏/rap氛围明亮电钢琴","音乐/音乐演奏/rap氛围沉闷电钢琴","音乐/音乐演奏/rap氛围电钢琴","音乐/音乐演奏/rap沉闷合成器","音乐/音乐演奏/rap沉闷的钢琴","音乐/音乐演奏/rap激烈合成器","音乐/音乐演奏/rap激烈合成器2","音乐/音乐演奏/rap电子合成器","音乐/音乐演奏/rap电钢琴音色","音乐/音乐演奏/rap电钢琴音色2","音乐/音乐演奏/rap电钢琴音色3","音乐/音乐演奏/rap相对平直的音色","音乐/音乐演奏/rap空灵电钢琴","音乐/音乐演奏/rap管弦乐类型合成器音色","音乐/音乐演奏/rap超级玛丽合成器","音乐/音乐演奏/rap跳跃合成器","音乐/音乐演奏/rap跳跃合成器2","音乐/音乐演奏/rap跳跃圆润电子琴","音乐/音乐演奏/rap跳跃圆润电子琴2","音乐/音乐演奏/rap跳跃明亮合成器","音乐/音乐演奏/rap跳跃明亮合成器2","音乐/音乐演奏/rap跳跃电子琴","音乐/音乐演奏/rap铺垫合成器","音乐/音乐演奏/rap闪烁合成器","音乐/音乐演奏/rap震荡合成器音色","音乐/音乐演奏/rap高频合成器音色","音乐/音乐演奏/乡村","音乐/音乐演奏/乡村布鲁斯","音乐/音乐演奏/交响乐","音乐/音乐演奏/交响诗","音乐/音乐演奏/光滑合成器摇滚","音乐/音乐演奏/光滑合成器重金属","音乐/音乐演奏/八音盒音色","音乐/音乐演奏/凌厉合成器音色","音乐/音乐演奏/协奏曲","音乐/音乐演奏/变奏曲","音乐/音乐演奏/古典的圆舞曲","音乐/音乐演奏/合唱--50","音乐/音乐演奏/合成原声吉他","音乐/音乐演奏/合成原声木吉他2","音乐/音乐演奏/合成器摇滚","音乐/音乐演奏/合成器重金属","音乐/音乐演奏/合成电吉他拨奏感","音乐/音乐演奏/合成电吉他清音","音乐/音乐演奏/合成钢琴摇滚","音乐/音乐演奏/合成钢琴重金属","音乐/音乐演奏/吐泡泡的合成电子琴","音乐/音乐演奏/吐泡泡的合成电子琴2温暖版","音乐/音乐演奏/复兴音色","音乐/音乐演奏/复合电子琴","音乐/音乐演奏/复合电子琴2","音乐/音乐演奏/奏鸣曲","音乐/音乐演奏/学校音乐会","音乐/音乐演奏/安魂曲","音乐/音乐演奏/宗教","音乐/音乐演奏/小步舞曲","音乐/音乐演奏/工业感音色","音乐/音乐演奏/幻想曲","音乐/音乐演奏/戏曲50长沙花鼓戏","音乐/音乐演奏/拇指琴音色","音乐/音乐演奏/摇摆的电子琴","音乐/音乐演奏/摇滚--前卫摇滚","音乐/音乐演奏/摇滚--另类摇滚","音乐/音乐演奏/摇滚--后浪摇滚","音乐/音乐演奏/摇滚--情绪摇滚","音乐/音乐演奏/摇滚--数字摇滚","音乐/音乐演奏/摇滚--朋克摇滚","音乐/音乐演奏/摇滚--硬核摇滚","音乐/音乐演奏/摇滚--英伦摇滚","音乐/音乐演奏/摇滚--迷幻摇滚","音乐/音乐演奏/摇滚--重金属摇滚","音乐/音乐演奏/明亮合成器","音乐/音乐演奏/明亮跳跃的电钢琴","音乐/音乐演奏/梦幻电钢琴","音乐/音乐演奏/民族","音乐/音乐演奏/民谣","音乐/音乐演奏/氛围音色","音乐/音乐演奏/沉闷跳跃的电钢琴","音乐/音乐演奏/流行","音乐/音乐演奏/温暖合成器2摇滚","音乐/音乐演奏/温暖合成器3重金属","音乐/音乐演奏/温暖合成器摇滚","音乐/音乐演奏/温暖合成器重金属","音乐/音乐演奏/温暖火焰音色","音乐/音乐演奏/温暖的电子琴","音乐/音乐演奏/温暖闪烁的电钢琴","音乐/音乐演奏/爵士--传统爵士","音乐/音乐演奏/爵士--冷爵士","音乐/音乐演奏/爵士--大摇摆","音乐/音乐演奏/爵士--比波普","音乐/音乐演奏/爵士--硬波普","音乐/音乐演奏/爵士--融合爵士","音乐/音乐演奏/爵士--调式爵士","音乐/音乐演奏/特艺彩色合成器音色","音乐/音乐演奏/电子--EDM","音乐/音乐演奏/电子--Progressive House","音乐/音乐演奏/电子--dubstep","音乐/音乐演奏/电子--house","音乐/音乐演奏/电子--trance","音乐/音乐演奏/电子合成器2摇滚","音乐/音乐演奏/电子合成器3重金属","音乐/音乐演奏/电子合成器摇滚","音乐/音乐演奏/电子合成器重金属","音乐/音乐演奏/电钢琴","音乐/音乐演奏/电钢琴2","音乐/音乐演奏/空灵的合成器音色","音乐/音乐演奏/经典合成器音色","音乐/音乐演奏/脆裂钢琴音色","音乐/音乐演奏/说唱--G funk","音乐/音乐演奏/说唱--alternative hip hop","音乐/音乐演奏/说唱--boombap","音乐/音乐演奏/说唱--cloud rap","音乐/音乐演奏/说唱--conscious political rap","音乐/音乐演奏/说唱--conscious rap","音乐/音乐演奏/说唱--drill","音乐/音乐演奏/说唱--emo","音乐/音乐演奏/说唱--gangsta rap","音乐/音乐演奏/说唱--gospel rap","音乐/音乐演奏/说唱--horror core","音乐/音乐演奏/说唱--hyperpop pc music-influence","音乐/音乐演奏/说唱--jazz rap","音乐/音乐演奏/说唱--mumble rap","音乐/音乐演奏/说唱--southern hip hop","音乐/音乐演奏/说唱--trap","音乐/音乐演奏/跳跃的电子琴","音乐/音乐演奏/金属80s合成器音色","音乐/音乐演奏/金属八音盒音色","音乐/音乐演奏/金属合成原声吉他","音乐/音乐演奏/金属合成原声木吉他2","音乐/音乐演奏/金属合成电吉他拨奏感","音乐/音乐演奏/金属合成电吉他清音","音乐/音乐演奏/金属拇指琴音色","音乐/音乐演奏/金属空灵的合成器音色","音乐/音乐演奏/金属经典合成器音色","音乐/音乐盒/音乐盒1","音乐/音效合成/XXSC-音频制作-古典明亮电子钢琴弹奏流行风格乐曲","音乐/音效合成/XXSC-音频制作-古典轻快的钢琴弹流行风格乐曲","音乐/音效合成/XXSC-音频制作-古典音色偏暗的电钢琴弹流行风格乐曲","音乐/音效合成/仪式音效垫乐","音乐/音效合成/偏亮的钢琴演奏古典音乐","音乐/音效合成/偏薄的钢琴演奏古典音乐","音乐/音效合成/动物音效--昆虫","音乐/音效合成/动物音效--牛","音乐/音效合成/动物音效--狗","音乐/音效合成/动物音效--狼","音乐/音效合成/动物音效--猪","音乐/音效合成/动物音效--猫","音乐/音效合成/动物音效--羊","音乐/音效合成/动物音效--老鹰","音乐/音效合成/动物音效--蛙","音乐/音效合成/动物音效--马","音乐/音效合成/动物音效--鸡","音乐/音效合成/合成原声木吉他演奏古典音乐","音乐/音效合成/合成器音色--中提琴","音乐/音效合成/合成器音色--吉他","音乐/音效合成/合成器音色--大提琴","音乐/音效合成/合成器音色--小提琴","音乐/音效合成/合成器音色--经典三角波","音乐/音效合成/合成器音色--经典方波","音乐/音效合成/合成器音色--经典正弦波","音乐/音效合成/合成器音色--贝斯","音乐/音效合成/合成器音色--钢琴","音乐/音效合成/合成器音色--鼓组","音乐/音效合成/合成大厅弦乐演奏古典音乐","音乐/音效合成/合成大钢琴音色演奏古典音乐","音乐/音效合成/合成弦乐演奏古典音乐","音乐/音效合成/合成明亮电钢琴演奏古典","音乐/音效合成/合成温暖电吉他演奏古典音乐","音乐/音效合成/合成的明亮木吉他演奏古典音乐","音乐/音效合成/合成的明亮电吉他演奏古典音乐","音乐/音效合成/合成贝斯1","音乐/音效合成/合成贝斯10","音乐/音效合成/合成贝斯11","音乐/音效合成/合成贝斯12","音乐/音效合成/合成贝斯13","音乐/音效合成/合成贝斯14","音乐/音效合成/合成贝斯15","音乐/音效合成/合成贝斯16","音乐/音效合成/合成贝斯17","音乐/音效合成/合成贝斯18","音乐/音效合成/合成贝斯19","音乐/音效合成/合成贝斯2","音乐/音效合成/合成贝斯20","音乐/音效合成/合成贝斯21","音乐/音效合成/合成贝斯22","音乐/音效合成/合成贝斯23","音乐/音效合成/合成贝斯24","音乐/音效合成/合成贝斯25","音乐/音效合成/合成贝斯26","音乐/音效合成/合成贝斯27","音乐/音效合成/合成贝斯28","音乐/音效合成/合成贝斯29","音乐/音效合成/合成贝斯3","音乐/音效合成/合成贝斯30","音乐/音效合成/合成贝斯31","音乐/音效合成/合成贝斯32","音乐/音效合成/合成贝斯33","音乐/音效合成/合成贝斯34","音乐/音效合成/合成贝斯35","音乐/音效合成/合成贝斯36","音乐/音效合成/合成贝斯37","音乐/音效合成/合成贝斯38","音乐/音效合成/合成贝斯39","音乐/音效合成/合成贝斯4","音乐/音效合成/合成贝斯40","音乐/音效合成/合成贝斯41","音乐/音效合成/合成贝斯42","音乐/音效合成/合成贝斯43","音乐/音效合成/合成贝斯5","音乐/音效合成/合成贝斯6","音乐/音效合成/合成贝斯7","音乐/音效合成/合成贝斯8","音乐/音效合成/合成贝斯9","音乐/音效合成/圆润的钢琴演奏古典音乐","音乐/音效合成/夏日钢琴演奏古典音乐","音乐/音效合成/失真钢琴演奏古典音乐","音乐/音效合成/强颗粒的钢琴演奏古典音乐","音乐/音效合成/打斗音效--中伤","音乐/音效合成/打斗音效--刀","音乐/音效合成/打斗音效--匕首","音乐/音效合成/打斗音效--呼啸声","音乐/音效合成/打斗音效--弓箭","音乐/音效合成/打斗音效--弩箭","音乐/音效合成/打斗音效--投石机","音乐/音效合成/打斗音效--拳","音乐/音效合成/打斗音效--斧头","音乐/音效合成/打斗音效--暗器","音乐/音效合成/打斗音效--木头","音乐/音效合成/打斗音效--棍子","音乐/音效合成/打斗音效--皮革盔甲","音乐/音效合成/打斗音效--盾牌","音乐/音效合成/打斗音效--金属盔甲","音乐/音效合成/打斗音效--金属齿轮链条","音乐/音效合成/打斗音效--锤","音乐/音效合成/拇指琴演奏古典音乐","音乐/音效合成/明亮电子钢琴演奏古典乐","音乐/音效合成/明亮电子钢琴演奏古典音","音乐/音效合成/明亮电子钢琴演奏古典音乐","音乐/音效合成/明亮的钢琴演奏古典音乐","音乐/音效合成/明亮的魔幻钢琴演奏古典音乐","音乐/音效合成/极简钢琴演奏古典音乐","音乐/音效合成/梦幻的钢琴演奏古典音乐","音乐/音效合成/氛围钢琴演奏古典乐","音乐/音效合成/沉闷的钢琴演奏古典音乐","音乐/音效合成/流动钢琴演奏古典音乐","音乐/音效合成/温暖的电钢琴演奏古典乐","音乐/音效合成/温暖的电钢琴演奏古典音乐","音乐/音效合成/游戏背景","音乐/音效合成/电子钢琴演奏古典乐","音乐/音效合成/电子钢琴演奏古典音乐","音乐/音效合成/电视合成--低音特效","音乐/音效合成/电视音效--农村","音乐/音效合成/电视音效--冷风-空气","音乐/音效合成/电视音效--史诗上升","音乐/音效合成/电视音效--史诗打击","音乐/音效合成/电视音效--恐怖音效","音乐/音效合成/电视音效--未来感氛围","音乐/音效合成/电视音效--海滨","音乐/音效合成/电视音效--短暂呼啸","音乐/音效合成/电视音效--金属上升","音乐/音效合成/电视音效--飞船音效","音乐/音效合成/电视音效2871","音乐/音效合成/科幻钢琴演奏古典音乐","音乐/音效合成/绒毛钢琴演奏古典音乐","音乐/音效合成/舒展钢琴演奏古典音乐","音乐/音效合成/舞曲钢琴演奏古典音乐","音乐/音效合成/节拍钢琴演奏古典音乐","音乐/音效合成/说唱歌曲","音乐/音效合成/赛西尔钢琴演奏古典音乐","音乐/音效合成/键盘音色1演奏古典音乐","音乐/音效合成/闪亮钢琴演奏古典音乐","音乐/音效合成/闷响钢琴演奏古典音乐","音乐/音效合成/颗粒钢琴演奏古典音乐","音乐/音效合成/魔幻的钢琴演奏古典音乐","音乐/音效合成/魔法闪烁"],
        labels: ["人声","复杂","自然","音乐","“不好”的声音","“不屑”的声音","“亲嘴”的声音","“切”的声音","“口吃”的声音","“叫喊”声","“叹气”声","“吃东西”的声音","“吞咽”声","“吸气”声","“吸溜”声","“吹口哨”的声音","“吹气”的声音","“吼”的声音","“呕吐”声","“呱”的声音","“呵”的声音","“呼吸”声","“呼气”声","“咀嚼”声","“咦”的声音","“咯咯”声","“咳嗽”声","“咳痰”声音","“咻”的声音","“哀嚎”声","“哆嗦”的声音","“哈欠”声","“哭”的声音","“哽咽”声","“喏”声","“喘气”的声音","“喝东西”的声音","“嘟”的声音","“嘲讽”声","“嘶”声","“嘶哈”声","“嘿”的声音","“嚯”的声音","“奥”的声音","“好”的声音","“尖叫”的声音","“干杯”的声音","“应和”声","“开心”的声音","“弹舌”的声音","“惊叹”声","“打响指”的声音","“打喷嚏”的声音","“打嗝”的声音","“打招呼”的声音","“打气”声","“打耳光”的声音","“打鼾”的声音","“抖腿”声","“抽泣”的声音","“拍打”的声音","“搓手”的声音","“摩擦”的声音","“摸索”声","“撒娇”声","“欢呼”的声音","“气泡”声","“漱口”声音","“生气”的声音","“略略”声","“疑惑”声","“疑问”声","“疼痛”的声音","“磨牙”声","“突突”声","“笑”声","“练气”声","“自我介绍”声","“赶动物”声音","“跺脚”的声音","“逗小孩”声音","“闻”的声音","“额”的声音","“鼓掌”声","”吞咽“声","发出“OK”的声音","发出“吧唧”的声音","发出“呲”的声音","发出“哇”的声音","发出“哦”的声音","发出“哼”的声音","发出“唉”的声音","发出“唉呀”的声音","发出“唤动物”声音","发出“啊”的声音","发出“喂”的声音","发出“嗨”的声音","发出“嗯”的声音","发出“嘘”的声音","发出“噗”的声音","发出“尴尬”的声音","发出“擤鼻涕”的声音","发出“颤音”","发出“鼻音”","学动物叫声","小声说话","长音","室内","室外","城市环境声","城市环境音","特定设备声","自然界声音","乐器合奏","乐器演奏","交响乐演出","伴奏","合唱","唱歌","戏曲","进行曲","通俗唱法","音乐演奏","音乐盒","音效合成","否定不好","淡漠不屑声","亲昵亲嘴","细碎亲嘴声","轻吻亲吻","不屑切","冷淡切声","滞涩口吃声","结巴口吃","娇柔喊妈妈","朦胧迷糊时的叫喊","激昂呐喊声","稚嫩喊爸爸","低沉叹息声","怅然惋惜声","意外惊叹声","沉闷叹气声","落寞叹气","轻缓叹息","咀嚼吃食物","慢咽吃东西声音","细品吃东西的声音","细嚼吃东西","厚重吞咽声","自然吞咽","馋人咽口水声","绵长吸气声","轻缓吸气","软糯吸溜声","婉转口哨声","悠扬吹口哨","清亮口哨","徐缓吹气声","轻送吹气","仿声模仿摩托车","凄厉嘶吼声","暴怒怒吼声","沉闷低吼声","浑厚低泡声","粗狂吼","震鸣吼声","作呕呕吐","反胃呕吐","低沉呱声","淡然呵声","轻缓呵气","匀净呼吸","平缓呼吸声","悠然呼声","绵长呼气声","轻吐呼气","沉稳咀嚼声","鲜香咀嚼","娇软咦呀","婉转咦呀","惊奇咦","柔和咦音","轻细咦声","清脆咯咯声","低沉清嗓子","利落清嗓子声","沉实咳嗽声","粗哑口噪声","轻浅咳嗽","浊重咯痰","破空咻声","连绵咻咻声","凄切哀嚎","悲凉哀嚎声","发颤哆嗦","微抖哆嗦声","瑟缩打哆嗦","低柔哈声","倦意哈气声","倦闷斯哈","困倦哈欠","慵懒哈","松弛哈气","沉缓哈欠声","绵长哈气声","低沉呜咽声","凄切哭声","哽咽呜咽","喜极边笑边哭","委屈哭","闷郁唔声","酸涩哽咽声","应声喏声","低吟喘息声","微喘喘息","急促喘气","粗重喘气声","清冽喝水声","畅快喝东西","低沉嘟噜声","圆润打嘟","抿嘴嘟嘴声","碎念嘟囔声","绵软打嘟噜","绵长打嘟噜声","轻响打嘟声","轻扬嘟声","连环嘟嘟声","冷言讥讽声","厌弃呸声","嗤笑哧哧声","疏离嫌弃声","轻鄙呸","倒吸嘶","冷嘶嘶声","忍痛嘶哈","抽气嘶哈","利落嘿","昂扬嘿呀","清亮嘿声","爽朗嘿嘿","惊觉嚯","短促嚯声","诧异嚯咦声","恍然奥声","爽快好","刺耳尖叫","尖锐尖叫声","清亮叫声","碰杯干杯声","利落应和声","随和应和声","热忱恭喜","舒展放松声","舒心愉悦","雀跃耶","高扬耶声","利落咋舌","利落弹舌","利落弹舌声","清越弹舌声","脆响弹舌","恍然惊讶哦豁","愕然惊叹声","扬调惊讶声调上扬声","由衷赞叹声","讶异惊讶","诧异惊讶声","脆亮打响指","低哑啧声","断续啧啧声","猝然打喷嚏","短促喷嚏","轻抿啧","闷响打喷嚏声","突兀打嗝声","轻顿嗝","闷逆打嗝","温和打招呼声","随和打招呼","沉厚用力声","激昂喝彩声","雄浑劳动号子","鼓劲加油","凌厉耳光","清亮打耳光声","脆响打耳光","震响耳光声","厚重打鼾","悠远鼾声","沉缓打鼾声","沉闷打呼噜声","酣然打呼噜","轻晃抖腿声","低泣抽噎声","哽咽抽噎","心酸抽泣","悲切抽泣声","断续抽气声","厚实胸脯声","沉稳敲门声","清脆敲打声","笃定拍胸脯声","轻拍护肤","轻缓身体拍打声","重拍桌子","干涩搓手声","摩擦搓手","干涩摩擦声","粗砺刮擦声","细碎悉悉索索","脆响掰手指","甜柔撒娇声","软媚撒娇","热烈欢呼声","雀跃欢呼","轻盈气泡声","清爽漱口","轻响漱口声","怒吼咆哮","暴怒咆哮","俏皮吐舌头略","调皮略略声","不解质疑声","困惑疑问声","刺痛痛感声","痛苦呻吟声","难忍疼痛声","沉震磨牙声","磨动齿音","紧咬磨牙","轻叩叩齿声","急促突突声","开怀笑","清甜笑声","凝神练功声","聚气练气声","大方自我介绍","厉声驱赶动物","呵斥赶动物","厚重跺脚声","沉稳脚部声音","用力跺脚","亲昵逗孩子","童趣小孩互动","凑近嗅闻","淡淡嗅闻声","清幽嗅声","细碎闻嗅声","轻浅闻嗅","沉吟额声","迟疑额","顿住额音","合拍手掌拍打","洪亮掌声","热烈鼓掌声","节奏鼓点声","沉闷咽吞声","顺滑咽水","爽快OK","慵懒咂嘴声","满足吧唧嘴","玩味咂舌","贪吃吧唧","轻弹咂舌声","冷厉呲声","憋笑噗呲","细碎呲呲声","轻嗤呲呲","呆萌的哇偶","响亮的哇塞","夸张的哇塞","委屈的哇哇","小声的哇唔","悠长的哇","惊喜的哇","惊讶的哇","慌张的哇呀","爽朗的哇","突然的打","调皮的哇","软萌的哇呜","轻轻的哇声","难过的呜哇","恍然哦","惊喜哦吼","惋惜哦豁","无奈哦豁声","清淡哦声","不屑哼","冷淡哼声","愉悦哼唱","温柔哼唱声","赌气哼气","软萌哼唧","轻快哼唱","低沉唉声","无奈唉","柔和唉","轻叹唉声","轻细唉声","娇俏唉呀","娇呼唉呀","婉转唉呀声","惊呼唉呀","清甜唉呀","轻缓唉呀","呼唤动物","投喂喂动物","招呼动物","温柔啰啰声","轻唤嘬声","哽咽呜啊","婉转啊呀声","平淡啊声","微弱低啊声","恍然啊哦","惊呀啊","柔和啊哦声","欢快啊哈","爽朗啊哈声","高亢啊叫声","大声喂","小声喂","开朗嗨","清爽嗨声","低沉嗯声","娇软嗯哼声","宠溺嗯哼","应诺嗯","软糯嗯嗯声","低声嘘","大声嘘","短嘘","长嘘","不屑噗 撇唇声","可爱噗 打噗噜","含糊噗 秃噜声","委屈噗 瘪嘴声","安静噗 噤声","尴尬噗 屁声","短促噗 噗声","细微噗 噗噗声","细碎噗 嘴部口腔声","轻快噗 噗噗","窘迫尴尬声","轻擤鼻涕","重擤鼻涕","微抖颤声","惊惧颤抖","柔转颤音","瑟缩打寒颤","绵长颤音声","慵懒鼻息声","软糯鼻音","闷沉鼻声","情绪高涨的模仿声","蛙鸣","骑马","呓语声","呢喃声","悄悄话声","很长的拖音","KTV","中医馆","乐器店","人活动音50","企业--团建","企业--大厅","休闲","会议室","会议室-95","便利店","停车场","健身房","写字楼","冰块厂","别墅","剧组--剧目","剧组--影视","剧院","办公室","动物园","包子铺","医院","卫生院","台球厅","台球店","咖啡店","商业","商业娱乐50","商场","商店","地下车库","场馆","大头贴店","奶茶店","娱乐场所","学校","室内","室内-49","家庭","家庭-1","密室逃脱","寺庙","小酒馆","居家","居家环境","展厅","展厅-4","展览","工作室","工厂--室内厂房","工厂--户外厂房","工厂--户外厂房-1","幼儿园","幼儿园--校园环境50","彩票店","快递服务站","戏院","扎染房","拳击店","按摩店","教育机构","文体活动","文化学习","文娱活动","文艺活动","文艺活动50","日常活动","服装店","服饰店","机场","校园--初中日常","校园--初中课堂","校园--大学上课","校园--大学日常","校园--大学生活日常","校园--大学课堂","校园--小学","校园--小学日常","校园--小学课堂","校园--小学课堂-1","校园--幼儿园日常","校园--幼儿园课堂","校园--高中","校园--高中日常","校园--高中课堂","棋牌室","民宿","汽修店","活动大厅","游戏体验馆","游戏厅","演唱会","演播厅","火锅店","照相馆","猫粮店","理发店","理疗店、中医馆","甜品店","生态农场","生活日常","生活日常小件","电梯","电梯间","电竞酒店","直播间","直播间-4","眼镜店","社区","社区中心","社区菜市场50","篮球馆","网吧","美容美甲店","美术馆","美甲店","羽毛球场","羽毛球馆","聚会活动","聚会活动-2","舞蹈室","茶馆","茶馆内","药店","药材研制工作室","菜市场","菠萝地","蔬菜大棚","蛋糕店内","警情--消防","话剧场","购物场所","超市","车内","车库","车辆","软件教学","酒吧","酒店","酒馆","银行","雕刻室","零食店","零食店50","音响店","餐厅","餐饮","餐饮店","饭店","高中课堂","麻将馆","乡村","交通--城市公交","交通--城市地铁","交通--城市客运出租","交通--自驾","交通--自驾-81","交通--轮渡","交通--铁路客运","交通工具维修","企业--业务推广发布相关活动","企业--周边-停车场-通道等","企业--周边-停车场-通道等-1","体育活动50","公园","农场","农村","农村生活","农林牧渔--森林-1","农林牧渔--渔场","农林牧渔--滩涂","商业街","地铁站","城市--公园","城市--公园--湿地--口袋公园","城市--公园--湿地公园下水道","城市--广场","室外","小区","山林","工地","工程机械","市场","广场","庭院","张掖七彩丹霞旅游景区","操场","施工","施工噪音50","施工现场","景区","景区--人文景区","景区--自然景区","枸杞地","树林","比赛现场","比赛现场-9","水上","沙滩","河边","泳池","海边","涠洲岛","游乐园","游乐场","湖边","湘江边","滑翔伞","滑雪场","球场","甘蔗地","田边","祁连山","船","船上","草原","菜园","菜市场","街边","警情--消防","路边","路边食物摊50","车内","集市","露台","青海湖二朗剑景区","飞机","飞机上","马场","马术场","马路边","马路边--乡村","马路边--城市","马路边--城郊","马路边--集镇","驾校","驾校--交通工具教学","驾校户外","高铁","高铁上","高铁站","大学--课后休息日常生活环境","交通噪音-主干道十字路口东西向（有风的影响）","交通噪音-主干道十字路口西东向（有风的影响）","交通噪音-乡村","交通噪音-停车场","交通噪音-公交站","交通噪音-公交车","交通噪音-公交车内","交通噪音-公交车和车站","交通噪音-公交车站","交通噪音-公园","交通噪音-共享电动车","交通噪音-动车、列车","交通噪音-十字路口","交通噪音-古镇","交通噪音-商业街","交通噪音-国道","交通噪音-地下车库","交通噪音-地下车库双车道","交通噪音-地铁","交通噪音-地铁站","交通噪音-垃圾站","交通噪音-城市路边人行道","交通噪音-城郊","交通噪音-城郊公路","交通噪音-城郊车辆","交通噪音-大巴车","交通噪音-大桥","交通噪音-大道旁","交通噪音-学校","交通噪音-室内","交通噪音-室内窗边","交通噪音-室外","交通噪音-小区","交通噪音-工地","交通噪音-工地上","交通噪音-幼儿园","交通噪音-景区","交通噪音-桥上","交通噪音-水上交通","交通噪音-江边","交通噪音-汽车维修店","交通噪音-湖泊边","交通噪音-火车","交通噪音-牧区","交通噪音-电动车","交通噪音-电动车上","交通噪音-私家车内","交通噪音-窗外","交通噪音-网约和出租车","交通噪音-街道","交通噪音-货运车辆","交通噪音-路边","交通噪音-路边停车内休息","交通噪音-车内","交通噪音-车库","交通噪音-轻轨交通","交通噪音-轿车上","交通噪音-轿车内","交通噪音-酒店","交通噪音-隧道","交通噪音-雨天马路边","交通噪音-露营地","交通噪音-飞机","交通噪音-马路边","交通噪音-马路边交通车流胎噪声+不规律鸣笛","交通噪音-高架","交通噪音-高架桥","交通噪音-高楼","交通噪音-高铁","人活动声-儿童乐园","人活动声-吃东西","人活动声-商场","人活动声-学校","人活动声-家庭","人活动声-快递站","人活动声-教育机构","人活动声-话剧院","人活动声-走路","人活动声-音效","人活动声-饭馆","人活动音-","人活动音-KTV","人活动音-乒乓球馆","人活动音-乡下","人活动音-便利店","人活动音-候车厅","人活动音-停车场","人活动音-公园","人活动音-养殖场","人活动音-写字楼","人活动音-农村","人活动音-农贸市场","人活动音-出租房","人活动音-办公室","人活动音-医院","人活动音-厨房","人活动音-台球厅","人活动音-咖啡店","人活动音-商业街","人活动音-商场","人活动音-商店","人活动音-地下车库","人活动音-地下通道","人活动音-地铁","人活动音-地铁站","人活动音-垃圾回收站","人活动音-城市河道","人活动音-夜市","人活动音-大市场","人活动音-奶茶店","人活动音-学校","人活动音-室内","人活动音-室外","人活动音-密室","人活动音-寺庙","人活动音-小区","人活动音-小学环境音","人活动音-小巷","人活动音-山","人活动音-幼儿园","人活动音-广场","人活动音-快递驿站","人活动音-教室","人活动音-景区","人活动音-机场","人活动音-棋牌室","人活动音-橘子洲","人活动音-步行街","人活动音-民俗体验馆","人活动音-江边","人活动音-汽车站","人活动音-河边","人活动音-洗手间","人活动音-洗车店","人活动音-游乐场","人活动音-湖边","人活动音-火车","人活动音-火车站","人活动音-烧烤店","人活动音-理发店","人活动音-电动车","人活动音-电影院","人活动音-电梯口","人活动音-电玩城","人活动音-磁浮列车","人活动音-篮球场","人活动音-网吧","人活动音-美术馆","人活动音-美甲店","人活动音-羽毛球馆","人活动音-舞蹈室","人活动音-花店","人活动音-菜市场","人活动音-菜鸟驿站","人活动音-蔬菜大棚","人活动音-街道边","人活动音-超市","人活动音-足球场","人活动音-车内","人活动音-酒店","人活动音-银行","人活动音-飞机","人活动音-飞机场","人活动音-餐饮店","人活动音-马路边","人活动音-高铁","人活动音-高铁站","会议室","体育活动","体育活动50","公园","剧组-","办公室","医院-","商业商场","商业娱乐-KFC","商业娱乐-KTV","商业娱乐-便利店","商业娱乐-公园","商业娱乐-写字楼","商业娱乐-医院","商业娱乐-台球厅","商业娱乐-咖啡店","商业娱乐-商业广场","商业娱乐-商业推广","商业娱乐-商场","商业娱乐-商场、广场","商业娱乐-商场嘈杂声","商业娱乐-商店","商业娱乐-地铁","商业娱乐-夜宵摊","商业娱乐-夜市","商业娱乐-奶茶店","商业娱乐-娱乐场所","商业娱乐-娱乐活动","商业娱乐-宜家","商业娱乐-宠物乐园","商业娱乐-室外","商业娱乐-家具超市","商业娱乐-密室","商业娱乐-展馆","商业娱乐-岳麓山","商业娱乐-市场","商业娱乐-幼儿园","商业娱乐-广场","商业娱乐-店铺","商业娱乐-废品店","商业娱乐-彩票店","商业娱乐-快递站","商业娱乐-按摩店","商业娱乐-教育机构","商业娱乐-景区","商业娱乐-服装店","商业娱乐-棋牌","商业娱乐-水果店","商业娱乐-洗车店","商业娱乐-游乐场","商业娱乐-理发店","商业娱乐-电影院","商业娱乐-电玩城","商业娱乐-百货店","商业娱乐-精品店","商业娱乐-网吧","商业娱乐-网吧电竞","商业娱乐-药店","商业娱乐-菜市场","商业娱乐-街边商贩","商业娱乐-超市","商业娱乐-路边","商业娱乐-酒馆","商业娱乐-餐饮","商业娱乐-餐饮店","商业娱乐-饭馆","商业娱乐-马路边","商业娱乐50-","城郊","娱乐","居家环境-","居家环境50-厨房冰块","居家环境51-餐桌","广场","户外日常","文艺团体","文艺现场","施工噪音-","施工噪音-交通施工","施工噪音-公路","施工噪音-商场","施工噪音-商场外","施工噪音-喷漆声","施工噪音-园区","施工噪音-地下车库","施工噪音-场地维护","施工噪音-安置小区","施工噪音-室内","施工噪音-室外","施工噪音-小区","施工噪音-工地","施工噪音-店铺","施工噪音-户外空地","施工噪音-楼道","施工噪音-汽车修理厂","施工噪音-汽车维修店","施工噪音-街边","施工噪音-超市","施工噪音-路边","施工噪音-路面","施工噪音-车间","施工噪音-酒店","校园--幼儿园","校园-初中日常","校园-大学日常","校园-大学课堂","校园-高中日常","生活日常小件","电脑城","社区菜市场","社区菜市场50","自驾","警报声-地铁","警报声-提示音","警报声-警示语音声","赛事现场50-湘超株洲展演和比赛全程观众区八个通道","超市","路边菜摊-","路边食物摊-","路边食物摊50-","车内","运动场地","酒吧歌厅-","酒店-","餐饮","家电设备","动物声音-","动物声音-中华田园犬","动物声音-乌鸦","动物声音-企鹅的叫声","动物声音-其他鸟类","动物声音-北极熊的叫声","动物声音-奶牛","动物声音-家鸡","动物声音-海鸥","动物声音-白鹭","动物声音-禽类聚集","动物声音-红腹锦鸡","动物声音-边境牧羊犬","动物声音-金毛","动物声音-鸭","动物声音-鹅","动物声音-鹅叫","动物声音-鹦鹉","动物声音-麻雀","地理水文","地理水文-人造景观、非自然类水流水滴声","地理水文-人造设施_排水管道声","地理水文-人造设施_水渠声","地理水文-大块冰川断裂落水声","地理水文-大山山口呼啸声","地理水文-大山暴风雪后寂静的声音","地理水文-山泉水声","地理水文-山洞里的水滴声","地理水文-山环境底噪","地理水文-山谷的呼啸声","地理水文-平原打雷的声音","地理水文-平原环境底噪","地理水文-无风的午后森林","地理水文-树枝摇曳的声音","地理水文-森林环境底噪","地理水文-正常洞穴的声音","地理水文-江水拍岸声","地理水文-江水拍打亲水平台声","地理水文-江面起伏声","地理水文-沙丘的声音","地理水文-沙漠峡谷的呼啸声","地理水文-河流流水声","地理水文-洞穴里风声","地理水文-海底水流涌动的声音","地理水文-海浪击打人工堤坝声","地理水文-海浪拍打沙滩声","地理水文-海浪拍打海岸的声音","地理水文-海浪拍打礁石声","地理水文-湖水冲击人工护坡声","地理水文-湖水拍岸声","地理水文-湖水拍打石头声","地理水文-湖水高低落差声","地理水文-湖面平静的水声","地理水文-湖面水滴落声","地理水文-湖面起伏声","地理水文-溪水由高处跌落深潭沉闷声","地理水文-溪流在河床转弯处激荡声","地理水文-溪流流水声","地理水文-田野","地理水文-风吹过枯草的声音","地理水文-风吹过草原的声音","天气现象","天气现象-中雨","天气现象-大雨","天气现象-大风","天气现象-小雨","天气现象-微风","天气现象-雨打在尼龙雨伞面","天气现象-雨水打在雨幕","天气现象-雨水滴入水池","天气现象-雨滴打在雨棚","天气现象-雨落到帐篷","天气现象-雨落在叶片","天气现象-雨落在塑料面","天气现象-雨落在塑胶跑道","天气现象-雨落在木质面","天气现象-雨落在水泥路面","天气现象-雨落在汽车挡风玻璃","天气现象-雨落在汽车顶部","天气现象-雨落在泡沫上","天气现象-雨落在泥土","天气现象-雨落在石质面","天气现象-雨落在草地","天气现象-雨落在金属面","天气现象-雨落在防盗窗","天气现象-雨落在雨棚","天气现象-雨量渐变","天气现象-雪水融化滴落","天气现象-雷雨声","天气现象-风吹动帐篷声","天气现象-风吹动管道声","天气现象-风吹动铁索栏杆声","天气现象-风吹塑料薄膜声","天气现象-风吹塑料袋","天气现象-风通过缝隙声","植物声音","植物声音-干竹枝叶摩擦声","植物声音-干芭蕉树枝叶摩擦声","植物声音-干草本植物、灌木丛摩擦声","植物声音-混合枝叶摩擦声","植物声音-混合枝叶踩踏声","植物声音-湿杜鹃花枝叶摩擦声","植物声音-湿竹枝叶摩擦声","植物声音-湿草本植物、灌木丛摩擦声","乐器合奏1","中世纪六弦鲁特","中世纪号","中世纪小吉他","中世纪小笛子","中世纪小管风琴","中世纪希尔博琴","中世纪木质竖笛","中世纪维吉那琴","中世纪羽管键琴","中世纪长号","中世纪长颈鲁特琴","中世纪高音直笛","中世纪鲁特琴","中提琴","中胡","乐器合奏","二胡","二胡与其他乐器","低音号-50","低音笛子-50","低音长号-50","单簧管-50","印度乐器印度手风琴","印度乐器桑图尔琴","印度乐器班苏里笛","印度乐器西塔琴","双簧管","口琴-49","吉他--古典吉他","吉他--民谣吉他","哨笛-50","唐布拉琴","唢呐","圆号","坦克鼓","大阮","定音锣-50","小号","小提琴音色","巴松-50","巴洛克小提琴-50","巴洛克琴-50","弹拨--古琴","弹拨--古琴-50","弹拨--琵琶","手摇琴","手碟","打击乐","拨片鲁特琴-50","指拨","提琴--大提琴","提琴--大提琴-50","提琴--小提琴","日本乐器SHAKUHACHI-49","日本乐器TSUGARU SHAMISEN-49","日本乐器日本笙-50","木琴-49","杜卡纳管-50","民族-扬琴","玻璃琴-50","班博尔德笛子-50","电声乐器--电吉他","电声乐器--电贝司","电声乐器--电颤琴-50","短笛","竖琴","管风琴-50","英国号","萧","萨克斯-49","贝斯-50","钟琴","长号","长笛","阿拉伯乐器乌德琴-50","阿拉伯乐器内伊笛子-50","阿拉伯乐器卡农琴-50","阿拉伯乐器卡瓦拉笛子-50","阿拉伯乐器布祖基琴-50","阿拉伯乐器撒兹琴-50","音乐节拍器100bpm","音乐节拍器105bpm","音乐节拍器110bpm","音乐节拍器115bpm","音乐节拍器120bpm","音乐节拍器125bpm","音乐节拍器130bpm","音乐节拍器135bpm","音乐节拍器140bpm","音乐节拍器145bpm","音乐节拍器150bpm","音乐节拍器155bpm","音乐节拍器160bpm","音乐节拍器165bpm","音乐节拍器170bpm","音乐节拍器175bpm","音乐节拍器180bpm","音乐节拍器185bpm","音乐节拍器190bpm","音乐节拍器50bpm","音乐节拍器55bpm","音乐节拍器60bpm","音乐节拍器65bpm","音乐节拍器70bpm","音乐节拍器75bpm","音乐节拍器75bpm 版本2","音乐节拍器80bpm","音乐节拍器85bpm","音乐节拍器90bpm","音乐节拍器95bpm","马林巴-50","鼓-中国鼓","鼓-架子鼓-50","交响乐演出实况","伴奏1","合唱--50","唱歌50","戏曲50","进行曲1","通俗唱法1","12.31摇滚重金属重金属","12.86摇滚重金属颗粒合成音色","80s合成器音色摇滚","80年代合成器摇滚","80年代合成器重金属","90年代合成器摇滚","rapKpop音色","rap中频温暖合成器音色","rap主奏合成器","rap主奏氛围合成器","rap主奏铃铛合成器","rap人声合成器","rap低音浑厚合成器","rap低频扭曲音色","rap低频水晶质感音色","rap低频能量合成器音色","rap八音盒音色","rap吉他合成器","rap圆润合成器","rap圆润电子琴","rap弹跳音色","rap微失真合成器","rap微失真明亮合成器","rap微失真沉闷合成器","rap微失真跳跃合成器","rap拨奏类合成器音色","rap摇摆合成器","rap放松氛围合成器","rap明亮合成器","rap有侵略性的音色","rap氛围合成器","rap氛围明亮电钢琴","rap氛围沉闷电钢琴","rap氛围电钢琴","rap沉闷合成器","rap沉闷的钢琴","rap激烈合成器","rap激烈合成器2","rap电子合成器","rap电钢琴音色","rap电钢琴音色2","rap电钢琴音色3","rap相对平直的音色","rap空灵电钢琴","rap管弦乐类型合成器音色","rap超级玛丽合成器","rap跳跃合成器","rap跳跃合成器2","rap跳跃圆润电子琴","rap跳跃圆润电子琴2","rap跳跃明亮合成器","rap跳跃明亮合成器2","rap跳跃电子琴","rap铺垫合成器","rap闪烁合成器","rap震荡合成器音色","rap高频合成器音色","乡村","乡村布鲁斯","交响乐","交响诗","光滑合成器摇滚","光滑合成器重金属","八音盒音色","凌厉合成器音色","协奏曲","变奏曲","古典的圆舞曲","合唱--50","合成原声吉他","合成原声木吉他2","合成器摇滚","合成器重金属","合成电吉他拨奏感","合成电吉他清音","合成钢琴摇滚","合成钢琴重金属","吐泡泡的合成电子琴","吐泡泡的合成电子琴2温暖版","复兴音色","复合电子琴","复合电子琴2","奏鸣曲","学校音乐会","安魂曲","宗教","小步舞曲","工业感音色","幻想曲","戏曲50长沙花鼓戏","拇指琴音色","摇摆的电子琴","摇滚--前卫摇滚","摇滚--另类摇滚","摇滚--后浪摇滚","摇滚--情绪摇滚","摇滚--数字摇滚","摇滚--朋克摇滚","摇滚--硬核摇滚","摇滚--英伦摇滚","摇滚--迷幻摇滚","摇滚--重金属摇滚","明亮合成器","明亮跳跃的电钢琴","梦幻电钢琴","民族","民谣","氛围音色","沉闷跳跃的电钢琴","流行","温暖合成器2摇滚","温暖合成器3重金属","温暖合成器摇滚","温暖合成器重金属","温暖火焰音色","温暖的电子琴","温暖闪烁的电钢琴","爵士--传统爵士","爵士--冷爵士","爵士--大摇摆","爵士--比波普","爵士--硬波普","爵士--融合爵士","爵士--调式爵士","特艺彩色合成器音色","电子--EDM","电子--Progressive House","电子--dubstep","电子--house","电子--trance","电子合成器2摇滚","电子合成器3重金属","电子合成器摇滚","电子合成器重金属","电钢琴","电钢琴2","空灵的合成器音色","经典合成器音色","脆裂钢琴音色","说唱--G funk","说唱--alternative hip hop","说唱--boombap","说唱--cloud rap","说唱--conscious political rap","说唱--conscious rap","说唱--drill","说唱--emo","说唱--gangsta rap","说唱--gospel rap","说唱--horror core","说唱--hyperpop pc music-influence","说唱--jazz rap","说唱--mumble rap","说唱--southern hip hop","说唱--trap","跳跃的电子琴","金属80s合成器音色","金属八音盒音色","金属合成原声吉他","金属合成原声木吉他2","金属合成电吉他拨奏感","金属合成电吉他清音","金属拇指琴音色","金属空灵的合成器音色","金属经典合成器音色","音乐盒1","XXSC-音频制作-古典明亮电子钢琴弹奏流行风格乐曲","XXSC-音频制作-古典轻快的钢琴弹流行风格乐曲","XXSC-音频制作-古典音色偏暗的电钢琴弹流行风格乐曲","仪式音效垫乐","偏亮的钢琴演奏古典音乐","偏薄的钢琴演奏古典音乐","动物音效--昆虫","动物音效--牛","动物音效--狗","动物音效--狼","动物音效--猪","动物音效--猫","动物音效--羊","动物音效--老鹰","动物音效--蛙","动物音效--马","动物音效--鸡","合成原声木吉他演奏古典音乐","合成器音色--中提琴","合成器音色--吉他","合成器音色--大提琴","合成器音色--小提琴","合成器音色--经典三角波","合成器音色--经典方波","合成器音色--经典正弦波","合成器音色--贝斯","合成器音色--钢琴","合成器音色--鼓组","合成大厅弦乐演奏古典音乐","合成大钢琴音色演奏古典音乐","合成弦乐演奏古典音乐","合成明亮电钢琴演奏古典","合成温暖电吉他演奏古典音乐","合成的明亮木吉他演奏古典音乐","合成的明亮电吉他演奏古典音乐","合成贝斯1","合成贝斯10","合成贝斯11","合成贝斯12","合成贝斯13","合成贝斯14","合成贝斯15","合成贝斯16","合成贝斯17","合成贝斯18","合成贝斯19","合成贝斯2","合成贝斯20","合成贝斯21","合成贝斯22","合成贝斯23","合成贝斯24","合成贝斯25","合成贝斯26","合成贝斯27","合成贝斯28","合成贝斯29","合成贝斯3","合成贝斯30","合成贝斯31","合成贝斯32","合成贝斯33","合成贝斯34","合成贝斯35","合成贝斯36","合成贝斯37","合成贝斯38","合成贝斯39","合成贝斯4","合成贝斯40","合成贝斯41","合成贝斯42","合成贝斯43","合成贝斯5","合成贝斯6","合成贝斯7","合成贝斯8","合成贝斯9","圆润的钢琴演奏古典音乐","夏日钢琴演奏古典音乐","失真钢琴演奏古典音乐","强颗粒的钢琴演奏古典音乐","打斗音效--中伤","打斗音效--刀","打斗音效--匕首","打斗音效--呼啸声","打斗音效--弓箭","打斗音效--弩箭","打斗音效--投石机","打斗音效--拳","打斗音效--斧头","打斗音效--暗器","打斗音效--木头","打斗音效--棍子","打斗音效--皮革盔甲","打斗音效--盾牌","打斗音效--金属盔甲","打斗音效--金属齿轮链条","打斗音效--锤","拇指琴演奏古典音乐","明亮电子钢琴演奏古典乐","明亮电子钢琴演奏古典音","明亮电子钢琴演奏古典音乐","明亮的钢琴演奏古典音乐","明亮的魔幻钢琴演奏古典音乐","极简钢琴演奏古典音乐","梦幻的钢琴演奏古典音乐","氛围钢琴演奏古典乐","沉闷的钢琴演奏古典音乐","流动钢琴演奏古典音乐","温暖的电钢琴演奏古典乐","温暖的电钢琴演奏古典音乐","游戏背景","电子钢琴演奏古典乐","电子钢琴演奏古典音乐","电视合成--低音特效","电视音效--农村","电视音效--冷风-空气","电视音效--史诗上升","电视音效--史诗打击","电视音效--恐怖音效","电视音效--未来感氛围","电视音效--海滨","电视音效--短暂呼啸","电视音效--金属上升","电视音效--飞船音效","电视音效2871","科幻钢琴演奏古典音乐","绒毛钢琴演奏古典音乐","舒展钢琴演奏古典音乐","舞曲钢琴演奏古典音乐","节拍钢琴演奏古典音乐","说唱歌曲","赛西尔钢琴演奏古典音乐","键盘音色1演奏古典音乐","闪亮钢琴演奏古典音乐","闷响钢琴演奏古典音乐","颗粒钢琴演奏古典音乐","魔幻的钢琴演奏古典音乐","魔法闪烁"],
        marker: {"colors": ["#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf","#636efa","#EF553B","#00cc96","#ab63fa","#FFA15A","#19d3f3","#FF6692","#B6E880","#FF97FF","#FECB52","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"]},
        parents: ["","","","","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","人声","复杂","复杂","自然","自然","自然","自然","音乐","音乐","音乐","音乐","音乐","音乐","音乐","音乐","音乐","音乐","音乐","音乐","人声/“不好”的声音","人声/“不屑”的声音","人声/“亲嘴”的声音","人声/“亲嘴”的声音","人声/“亲嘴”的声音","人声/“切”的声音","人声/“切”的声音","人声/“口吃”的声音","人声/“口吃”的声音","人声/“叫喊”声","人声/“叫喊”声","人声/“叫喊”声","人声/“叫喊”声","人声/“叹气”声","人声/“叹气”声","人声/“叹气”声","人声/“叹气”声","人声/“叹气”声","人声/“叹气”声","人声/“吃东西”的声音","人声/“吃东西”的声音","人声/“吃东西”的声音","人声/“吃东西”的声音","人声/“吞咽”声","人声/“吞咽”声","人声/“吞咽”声","人声/“吸气”声","人声/“吸气”声","人声/“吸溜”声","人声/“吹口哨”的声音","人声/“吹口哨”的声音","人声/“吹口哨”的声音","人声/“吹气”的声音","人声/“吹气”的声音","人声/“吼”的声音","人声/“吼”的声音","人声/“吼”的声音","人声/“吼”的声音","人声/“吼”的声音","人声/“吼”的声音","人声/“吼”的声音","人声/“呕吐”声","人声/“呕吐”声","人声/“呱”的声音","人声/“呵”的声音","人声/“呵”的声音","人声/“呼吸”声","人声/“呼吸”声","人声/“呼气”声","人声/“呼气”声","人声/“呼气”声","人声/“咀嚼”声","人声/“咀嚼”声","人声/“咦”的声音","人声/“咦”的声音","人声/“咦”的声音","人声/“咦”的声音","人声/“咦”的声音","人声/“咯咯”声","人声/“咳嗽”声","人声/“咳嗽”声","人声/“咳嗽”声","人声/“咳嗽”声","人声/“咳嗽”声","人声/“咳痰”声音","人声/“咻”的声音","人声/“咻”的声音","人声/“哀嚎”声","人声/“哀嚎”声","人声/“哆嗦”的声音","人声/“哆嗦”的声音","人声/“哆嗦”的声音","人声/“哈欠”声","人声/“哈欠”声","人声/“哈欠”声","人声/“哈欠”声","人声/“哈欠”声","人声/“哈欠”声","人声/“哈欠”声","人声/“哈欠”声","人声/“哭”的声音","人声/“哭”的声音","人声/“哭”的声音","人声/“哭”的声音","人声/“哭”的声音","人声/“哭”的声音","人声/“哽咽”声","人声/“喏”声","人声/“喘气”的声音","人声/“喘气”的声音","人声/“喘气”的声音","人声/“喘气”的声音","人声/“喝东西”的声音","人声/“喝东西”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘟”的声音","人声/“嘲讽”声","人声/“嘲讽”声","人声/“嘲讽”声","人声/“嘲讽”声","人声/“嘲讽”声","人声/“嘶”声","人声/“嘶”声","人声/“嘶哈”声","人声/“嘶哈”声","人声/“嘿”的声音","人声/“嘿”的声音","人声/“嘿”的声音","人声/“嘿”的声音","人声/“嚯”的声音","人声/“嚯”的声音","人声/“嚯”的声音","人声/“奥”的声音","人声/“好”的声音","人声/“尖叫”的声音","人声/“尖叫”的声音","人声/“尖叫”的声音","人声/“干杯”的声音","人声/“应和”声","人声/“应和”声","人声/“开心”的声音","人声/“开心”的声音","人声/“开心”的声音","人声/“开心”的声音","人声/“开心”的声音","人声/“弹舌”的声音","人声/“弹舌”的声音","人声/“弹舌”的声音","人声/“弹舌”的声音","人声/“弹舌”的声音","人声/“惊叹”声","人声/“惊叹”声","人声/“惊叹”声","人声/“惊叹”声","人声/“惊叹”声","人声/“惊叹”声","人声/“打响指”的声音","人声/“打喷嚏”的声音","人声/“打喷嚏”的声音","人声/“打喷嚏”的声音","人声/“打喷嚏”的声音","人声/“打喷嚏”的声音","人声/“打喷嚏”的声音","人声/“打嗝”的声音","人声/“打嗝”的声音","人声/“打嗝”的声音","人声/“打招呼”的声音","人声/“打招呼”的声音","人声/“打气”声","人声/“打气”声","人声/“打气”声","人声/“打气”声","人声/“打耳光”的声音","人声/“打耳光”的声音","人声/“打耳光”的声音","人声/“打耳光”的声音","人声/“打鼾”的声音","人声/“打鼾”的声音","人声/“打鼾”的声音","人声/“打鼾”的声音","人声/“打鼾”的声音","人声/“抖腿”声","人声/“抽泣”的声音","人声/“抽泣”的声音","人声/“抽泣”的声音","人声/“抽泣”的声音","人声/“抽泣”的声音","人声/“拍打”的声音","人声/“拍打”的声音","人声/“拍打”的声音","人声/“拍打”的声音","人声/“拍打”的声音","人声/“拍打”的声音","人声/“拍打”的声音","人声/“搓手”的声音","人声/“搓手”的声音","人声/“摩擦”的声音","人声/“摩擦”的声音","人声/“摸索”声","人声/“摸索”声","人声/“撒娇”声","人声/“撒娇”声","人声/“欢呼”的声音","人声/“欢呼”的声音","人声/“气泡”声","人声/“漱口”声音","人声/“漱口”声音","人声/“生气”的声音","人声/“生气”的声音","人声/“略略”声","人声/“略略”声","人声/“疑惑”声","人声/“疑问”声","人声/“疼痛”的声音","人声/“疼痛”的声音","人声/“疼痛”的声音","人声/“磨牙”声","人声/“磨牙”声","人声/“磨牙”声","人声/“磨牙”声","人声/“突突”声","人声/“笑”声","人声/“笑”声","人声/“练气”声","人声/“练气”声","人声/“自我介绍”声","人声/“赶动物”声音","人声/“赶动物”声音","人声/“跺脚”的声音","人声/“跺脚”的声音","人声/“跺脚”的声音","人声/“逗小孩”声音","人声/“逗小孩”声音","人声/“闻”的声音","人声/“闻”的声音","人声/“闻”的声音","人声/“闻”的声音","人声/“闻”的声音","人声/“额”的声音","人声/“额”的声音","人声/“额”的声音","人声/“鼓掌”声","人声/“鼓掌”声","人声/“鼓掌”声","人声/“鼓掌”声","人声/”吞咽“声","人声/”吞咽“声","人声/发出“OK”的声音","人声/发出“吧唧”的声音","人声/发出“吧唧”的声音","人声/发出“吧唧”的声音","人声/发出“吧唧”的声音","人声/发出“吧唧”的声音","人声/发出“呲”的声音","人声/发出“呲”的声音","人声/发出“呲”的声音","人声/发出“呲”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哇”的声音","人声/发出“哦”的声音","人声/发出“哦”的声音","人声/发出“哦”的声音","人声/发出“哦”的声音","人声/发出“哦”的声音","人声/发出“哼”的声音","人声/发出“哼”的声音","人声/发出“哼”的声音","人声/发出“哼”的声音","人声/发出“哼”的声音","人声/发出“哼”的声音","人声/发出“哼”的声音","人声/发出“唉”的声音","人声/发出“唉”的声音","人声/发出“唉”的声音","人声/发出“唉”的声音","人声/发出“唉”的声音","人声/发出“唉呀”的声音","人声/发出“唉呀”的声音","人声/发出“唉呀”的声音","人声/发出“唉呀”的声音","人声/发出“唉呀”的声音","人声/发出“唉呀”的声音","人声/发出“唤动物”声音","人声/发出“唤动物”声音","人声/发出“唤动物”声音","人声/发出“唤动物”声音","人声/发出“唤动物”声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“啊”的声音","人声/发出“喂”的声音","人声/发出“喂”的声音","人声/发出“嗨”的声音","人声/发出“嗨”的声音","人声/发出“嗯”的声音","人声/发出“嗯”的声音","人声/发出“嗯”的声音","人声/发出“嗯”的声音","人声/发出“嗯”的声音","人声/发出“嘘”的声音","人声/发出“嘘”的声音","人声/发出“嘘”的声音","人声/发出“嘘”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“噗”的声音","人声/发出“尴尬”的声音","人声/发出“擤鼻涕”的声音","人声/发出“擤鼻涕”的声音","人声/发出“颤音”","人声/发出“颤音”","人声/发出“颤音”","人声/发出“颤音”","人声/发出“颤音”","人声/发出“鼻音”","人声/发出“鼻音”","人声/发出“鼻音”","人声/学动物叫声","人声/学动物叫声","人声/学动物叫声","人声/小声说话","人声/小声说话","人声/小声说话","人声/长音","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室内","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","复杂/室外","自然/城市环境声","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/城市环境音","自然/特定设备声","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","自然/自然界声音","音乐/乐器合奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/乐器演奏","音乐/交响乐演出","音乐/伴奏","音乐/合唱","音乐/唱歌","音乐/戏曲","音乐/进行曲","音乐/通俗唱法","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐演奏","音乐/音乐盒","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成","音乐/音效合成"],
        values: [3974.818999,3921.339409,1420.855946,2026.855122,0.072297,0.065724,23.952961,1.039283,3.390229,0.816198,100.775406,116.405949,4.340823,128.52667,4.229568,66.681949,15.985632,10.531132,75.491413,0.020901,39.719006,16.569347,81.756674,27.347384,12.109841,0.091233,330.778457,0.015593,4.008268,9.551351,1.381483,88.856236,270.147974,3.93614,0.053833,46.780645,0.272793,21.373379,0.791486,145.229712,1.005723,12.340704,7.777383,0.796957,0.094442,52.138903,0.142304,21.164729,8.304765,26.905949,56.512938,1.900408,181.890655,43.455213,0.737678,0.959851,0.87259,137.462984,0.089253,18.552237,1.517427,0.511989,0.537316,0.0464,23.174278,81.918794,0.008563,3.975779,3.794683,0.64645,14.887917,0.563756,0.982119,9.051053,0.05849,240.47509,0.239207,0.005172,2.966232,3.002179,0.189454,31.007592,6.628481,135.247044,0.050042,0.107614,40.879422,3.347141,71.592669,22.0539,768.851714,2.553187,7.30596,73.799357,39.811011,0.904262,2.443704,26.332646,69.674743,10.953985,0.066809,6.266775,15.405428,7.975301,10.614094,1.620613,4.570521,3015.481787,905.857622,5.737472,1367.192029,0.056361,47.870084,1.131595,866.187969,2.071022,1.489545,1.295002,0.430877,15.210866,0.536658,3.633652,703.929538,0.081559,430.856839,0.072297,0.065724,0.281288,22.540673,1.131,0.132766,0.906517,0.970239,2.41999,0.041956,0.269958,0.468956,0.035328,17.027513,0.051271,2.178459,15.143947,8.365521,58.008695,46.990625,60.613169,3.864,4.938155,3.94753,0.286654,0.106639,16.400424,112.126246,4.229568,14.008884,8.808269,43.864796,11.392732,4.5929,0.104461,0.065695,2.285396,0.938728,0.029256,0.044804,7.062792,6.504641,68.986772,0.020901,39.5067,0.212306,14.943572,1.625775,0.288517,29.434879,52.033278,24.990966,2.356418,1.741126,0.693146,2.20564,1.384719,6.08521,0.091233,129.429588,16.747524,40.587371,0.331151,143.682823,0.015593,2.783795,1.224473,1.967144,7.584207,0.619641,0.75067,0.011172,6.356092,0.093098,0.037783,45.268715,8.860205,3.599879,14.818661,9.821803,4.197164,209.835807,0.26332,0.070479,55.770941,0.010263,3.93614,0.053833,10.255748,6.546837,26.453984,3.524076,0.089185,0.183608,0.203915,0.171703,1.303053,0.107428,7.448789,0.913146,6.089926,1.200233,3.935186,0.405314,0.064085,0.030465,0.068356,0.223266,17.563994,127.665718,0.407065,0.598658,3.525814,0.707578,8.063831,0.043481,1.424588,2.880389,3.472406,0.796957,0.094442,31.029882,13.444875,7.664146,0.142304,20.835316,0.329413,0.024683,0.03344,0.0484,7.238215,0.960027,0.098031,0.357511,8.921684,2.338222,15.190501,1.608122,0.128048,1.887078,14.749968,0.158276,37.981446,1.900408,0.553081,3.404849,115.898628,47.156826,0.043767,14.833504,10.110546,20.496998,12.847669,0.257848,0.47983,0.134441,0.221399,0.489297,0.114714,0.130254,0.263694,0.073928,0.404714,18.214014,58.643893,8.802615,9.024756,42.777706,0.089253,4.645377,0.524229,0.317658,7.11723,5.947743,0.261385,0.033714,0.60231,0.133445,0.083836,0.131679,0.271058,0.44337,0.068619,0.503455,0.033861,0.03865,0.00775,18.952407,4.221871,30.736448,51.182346,0.008563,0.486638,3.489141,3.034704,0.759979,0.07552,0.57093,14.887917,0.563756,0.091845,0.451204,0.43907,7.056943,0.015127,1.962523,0.01646,0.05849,68.991367,171.483723,0.173191,0.066016,0.005172,0.311685,2.654547,2.589718,0.145033,0.267428,0.05779,0.131664,2.471987,0.909847,9.616108,4.991226,13.018424,3.080832,3.470379,0.07727,0.95077,105.908469,28.353986,0.033819,0.022388,0.027654,0.107614,8.453811,20.248577,0.177481,0.012559,11.986994,0.707414,0.09709,1.886905,0.655732,2.18561,0.173293,0.01165,6.333392,0.069139,0.319369,9.048041,41.824391,0.792834,0.054654,4.551754,0.659257,0.668025,3.762424,1.138836,12.378427,0.241352,1.776056,0.097437,7.560628,0.435881,44.755979,318.990015,20.379809,0.20748,0.223255,383.859295,0.499823,0.458405,0.126878,1.358196,0.109885,2.412598,0.135055,0.021118,0.1519,3.24866,1.336629,0.404692,0.544196,72.711814,0.117029,0.021626,0.002093,0.131895,17.562772,0.256114,2.766413,18.488135,0.107568,0.293493,0.094611,0.107917,0.423753,0.480509,2.355334,0.08837,6.090959,0.544304,0.345019,19.090727,0.261637,3.251241,61.183887,3.628337,1.611278,0.130787,0.169029,0.204642,0.033533,0.23427,0.060081,2.741237,5.09875,0.617733,1.663923,0.066809,0.139441,6.127334,0.101166,1.608826,3.891821,0.217768,9.585847,7.633682,0.086993,0.254626,10.455386,0.067258,0.09145,0.934184,0.652035,0.034394,4.570521,3.043933,1.537322,1.329333,3.126059,2.531761,0.046861,6.458228,121.994875,21.650224,0.883442,0.035744,2.200356,1.109167,0.406633,1.706989,11.860795,3.928934,0.497656,131.232441,4.476356,0.396389,98.108612,0.389444,1.402433,0.332333,4.225667,216.068176,1.029018,39.107507,3.398944,0.428756,3.216156,0.730356,0.8875,5.694905,6.017256,44.777011,1.38186,238.513455,0.23012,0.981867,0.082622,6.149711,22.311633,4.708168,32.279888,0.921843,0.787356,532.059547,23.557526,0.364412,0.173442,7.516711,1.581326,0.265248,0.297889,1.763211,0.979378,0.948544,2.958544,0.18875,4.199235,34.473498,38.645833,59.865846,9.855701,0.842187,5.864369,2.651256,1.997367,1.638059,170.691941,14.137964,141.977422,0.700513,90.875423,0.276187,0.461768,59.279755,0.228477,0.203344,0.257723,0.102141,1.039658,57.623006,10.2594,3.666733,3.813518,0.404589,2.917489,2.164167,0.162818,6.915889,1.463489,4.329056,0.166622,0.240756,1.948933,0.373056,2.524189,15.481089,0.15876,0.080167,0.042411,1.493711,78.33365,0.895674,0.154844,7.425355,0.11582,2.292547,2.284833,4.994011,1.464578,0.636272,1.870878,1.643544,1.481867,72.594364,0.388644,4.589878,1.158478,1.809911,0.134867,1.445164,4.188014,1.916944,4.872611,3.398656,0.741212,22.871387,59.87498,3.57473,9.429933,0.500833,0.495811,35.576993,1.922133,20.585339,0.305278,0.184547,1.428933,0.5818,0.002039,49.663397,5.319522,58.265976,5.7338,4.066487,144.743293,5.755822,0.13645,39.672762,70.083966,10.81143,11.770283,18.558909,0.1659,0.334287,4.088259,10.267906,3.557991,0.237722,6.106838,18.55037,6.1182,4.223144,8.423468,0.005844,0.173657,0.100772,0.659589,5.405696,12.167959,37.298924,0.067624,17.772805,26.125979,0.290358,5.403278,0.539387,90.43553,7.973556,0.950733,3.199433,3.212389,2.399806,39.871288,0.484663,4.232754,8.155611,4.384859,6.433068,1.456567,0.666556,34.632734,0.042466,1.670689,15.002756,0.685622,1.973367,8.197989,8.343122,1.949122,7.109222,8.011589,0.625433,2.374844,2.398556,26.775178,5.745622,0.649644,9.300156,1.321644,1.829556,1.472022,0.651889,0.811544,3.573356,0.669394,4.788067,2.567828,1.368047,1.816422,1.152533,1.900311,0.165232,0.499444,0.240833,1.296711,5.54826,0.210278,116.733219,6.659663,7.283419,37.691729,61.298184,8.491422,3.0084,2.320567,2.022967,5.737472,5.149639,3.187917,0.350917,0.215222,0.755389,26.69025,1.158833,1.268306,1.068139,1.383333,0.191444,0.832667,0.931472,0.109056,0.048778,0.394639,0.840639,0.002611,51.66825,2.624222,0.158639,1.337778,1.249861,0.409194,0.0545,0.735611,0.326306,2.175944,0.053611,1.657667,1.708028,2.39175,3.56225,0.012806,0.042333,0.067278,0.776444,1.18625,0.713111,0.236889,0.162972,0.148167,0.591444,0.434306,0.015667,2.152278,3.119333,0.248472,0.836333,4.872,0.028611,5.929944,4.712278,5.621,0.222139,0.491194,2.107,4.909028,0.161778,0.201056,1.183222,0.072333,1.26625,38.255222,0.005,4.101722,2.369611,0.824861,1.810417,0.898556,0.346056,1.230083,0.71025,8.17825,18.540361,8.230694,3.014139,1.07825,1.273083,15.82225,2.219611,2.114361,2.030139,0.224667,0.033917,0.605861,0.064778,9.59125,0.274444,0.734444,1.141583,0.645583,9.174806,0.336417,0.263611,0.21125,0.459806,0.943083,0.713417,4.300694,2.3255,0.559167,0.25,3.806278,2.936639,0.310139,0.460194,1.070389,0.761889,0.722944,1.988861,72.39025,2.197861,1.480806,1.03975,9.926139,58.623389,0.212056,1.884778,1.66225,0.794,0.573833,0.179917,3.529556,1.68225,3.145111,2.252639,0.431944,0.404556,0.093361,0.503111,0.292861,0.560167,0.675444,0.911167,1.255611,8.066111,3.116139,0.519833,1.446417,0.090917,0.242667,0.175,1.107972,0.345056,0.971694,2.028528,0.812972,1.34,1.832611,1.024639,0.743972,0.846056,0.311806,0.25,1.185222,5.451194,0.397278,5.654194,1.011,0.125083,0.344361,0.704667,14.712722,4.761583,2.298028,0.466361,1.469444,1.411361,17.992111,32.723833,1.695444,6.257944,5.383611,37.572139,0.748417,4.173694,3.58725,6.547056,0.134917,0.118111,1.364472,1.487972,0.591917,0.961056,10.174444,8.404361,24.708389,1.964,0.70675,0.393167,3.677889,0.402861,13.321806,8.385611,1.158556,0.43475,0.495667,0.989361,0.173667,4.491778,0.158806,0.174278,0.2385,3.965667,0.17125,0.119,1.457833,6.500278,0.225417,1.0705,0.079583,2.046222,3.183083,0.309222,0.252833,0.446417,1.416667,0.669472,1.393083,0.100556,0.503,1.578833,1.08575,0.927222,5.914417,0.34375,32.178361,0.733667,2.912833,4.900278,13.576917,10.951611,0.9115,16.021194,3.741417,13.279056,69.69,0.473194,0.202778,17.776583,37.897722,13.739667,14.20575,15.632889,0.439194,0.030667,0.28725,0.238139,0.209806,0.297028,0.182333,1.295917,0.211056,0.318083,3.170194,3.716222,0.868778,1.576444,0.247111,0.059167,1.406,0.212194,0.830111,0.123417,0.598417,0.085222,3.407,0.334917,1.243111,1.786139,139.007972,4.845944,5.110528,10.355806,0.674472,1.136139,45.240833,0.515556,0.002056,0.221833,1.6605,15.664722,7.915944,1.304111,0.148417,3.647611,1.410139,13.455444,3.331583,1.731056,35.110389,0.056361,1.187278,0.170333,0.017861,0.011083,5.82675,0.014611,0.180167,0.290972,0.320917,0.112917,0.117944,0.034556,0.002528,0.007056,0.036028,0.156583,0.039444,0.609861,0.222667,2.000944,6.6185,4.538861,0.260972,0.0105,0.01225,0.00525,0.290861,0.018056,0.765278,0.0105,0.01225,0.418667,0.001778,0.001861,0.075972,0.007,0.177194,0.273278,0.034194,0.00175,0.00175,0.379111,0.001861,0.001833,0.477583,0.2,0.0035,0.214389,0.7095,0.629778,0.372611,1.352,0.02275,0.545806,0.844389,0.4695,0.525444,0.457889,0.346194,0.0035,0.021,0.419611,0.149472,1.108306,1.295944,0.433,0.912889,0.740806,0.192972,0.172056,0.069694,0.395694,0.481306,0.260861,0.090556,0.019667,0.034056,0.026056,0.075389,0.036083,0.188361,0.114639,0.086111,1.07725,0.405278,1.254944,0.289028,0.211389,1.755778,0.279444,0.079556,0.045833,0.034361,0.360861,0.241667,0.004167,0.346778,0.092917,0.472222,0.597417,0.177361,0.038444,0.195778,0.130222,1.131595,12.487688,12.488449,12.470014,9.875312,12.047904,7.520588,9.803728,8.866165,12.035812,12.045874,12.202403,12.488471,12.419402,12.070849,4.174406,1.007839,15.187986,3.006078,10.3844,9.693963,10.114695,9.766111,12.226112,12.465486,12.274003,12.446515,12.167508,8.200308,0.449251,0.246962,8.184838,12.313666,12.3037,12.170051,12.333494,4.536905,12.296019,12.166332,12.173399,12.241978,12.307949,11.956744,0.437968,10.163412,7.318741,11.804325,12.489071,0.489878,7.175818,12.488088,6.06663,9.549609,0.190893,8.63979,3.276595,8.566342,4.972349,9.598338,7.85014,12.416599,12.199134,0.817633,0.458782,9.392775,12.495879,12.150796,10.855984,12.167169,12.186608,7.819605,8.689047,12.084328,12.463967,12.455282,11.355605,12.374854,12.396586,12.268353,11.908401,12.077729,3.266931,3.301833,3.273042,3.246681,3.111403,3.093611,3.282319,3.259514,3.238347,0.130584,3.244681,3.204528,3.187778,3.272986,3.294375,3.314528,3.296542,3.279514,3.263389,2.025549,2.029286,2.032403,2.035124,2.037372,2.039326,1.24991,3.291986,3.294431,3.296583,3.263431,5.645394,0.07607,5.576058,2.071022,1.489545,1.295002,0.430877,15.210866,0.536658,3.633652,5.657875,11.01069,5.652585,5.63781,5.66726,5.658213,3.809083,3.820689,3.853204,3.849983,3.860008,3.818917,3.832093,3.857442,2.31433,3.857758,3.865717,7.661709,7.703846,3.863038,3.770293,3.863875,3.788882,3.857238,3.698629,3.857329,3.863112,3.805017,3.688467,3.759612,3.857217,3.821474,3.858751,3.865842,3.832856,3.600952,3.852147,3.760311,3.803713,3.820929,3.743564,3.735226,3.501994,3.857625,2.49561,6.812413,3.773412,4.076494,3.790868,3.806516,3.741612,3.713544,3.798516,3.858258,3.863912,3.842195,3.737395,0.101993,18.554166,0.101961,0.101979,5.645679,5.639948,5.655422,11.040638,0.102011,0.10027,0.102029,0.091428,5.623679,5.655585,5.650558,5.434664,5.613083,5.655592,5.647666,5.654769,10.37162,10.364517,11.053082,10.117601,9.888119,0.102029,1.024078,0.102029,0.102029,0.10192,11.18269,0.102016,36.720629,5.575066,10.377618,0.101838,0.101838,0.10202,0.101838,0.101838,0.102029,0.102029,0.102029,0.101838,0.101993,10.143494,10.164544,10.36286,0.102025,0.102029,11.054187,10.357763,0.102007,5.635042,5.649325,5.657308,5.661376,11.042727,9.442636,10.364606,0.101947,0.102827,0.102007,0.102121,0.102075,0.102089,0.102025,10.990225,0.102029,0.101975,0.102034,0.102016,0.10027,5.626151,5.626455,4.721122,4.303634,8.325684,10.085011,5.643108,16.954399,11.090248,0.101984,0.102025,0.101769,0.102007,0.101769,0.102025,0.101769,0.102025,0.101769,0.101769,0.101769,0.101769,0.101769,0.001755,0.102029,0.102025,10.119907,5.646242,5.640136,5.198437,5.654864,5.621342,5.584207,5.620193,5.649297,5.428002,0.081559,0.176652,9.434388,9.347814,0.369732,9.170809,9.347196,0.14603,0.139193,0.14404,0.139444,0.143967,0.141653,0.144889,0.136468,0.149645,0.137043,0.145733,9.000034,0.136094,0.102021,0.104578,0.10042,0.103821,0.102064,0.102064,0.102092,0.102182,0.103838,9.40673,8.987106,9.173959,9.287267,9.33486,9.050448,9.123862,0.420269,0.422687,0.425378,0.42049,0.422743,0.428505,0.41966,0.434357,0.426054,0.428164,0.433896,0.434212,0.415623,0.430421,0.431135,0.436718,0.433301,0.404737,0.430393,0.434603,0.23344,0.425246,0.417645,0.216737,0.216984,0.215442,0.216509,0.195972,0.206205,0.212134,0.216772,0.216772,0.216702,0.429274,0.20572,0.217266,0.18913,0.217617,0.432342,0.418565,0.403956,0.423456,0.429582,9.347458,9.172148,9.347928,9.169756,0.099946,0.211309,0.127368,0.303382,0.266121,0.102337,0.113469,0.10042,0.111443,0.127345,0.111247,0.102114,0.201237,0.102137,0.109416,0.094857,0.159455,9.350098,8.988744,8.052958,9.487522,9.33347,9.342836,8.519952,9.337478,9.331791,9.5252,9.341524,8.992667,9.163459,5.838225,9.342898,9.013586,0.11142,0.10953,0.130325,0.103483,0.106665,0.119038,0.121726,0.103538,0.132182,0.096062,0.105172,7.052343,9.454374,9.337026,9.168776,9.4003,9.160885,1.222803,9.222603,9.356428,9.29934,9.348483,7.280885,9.479814,9.445387]
        // branchvalues: "total",
        // customdata: [["Library"], ["Corridor"], ["Cafe"], ["Courtyard"], ["Square"], ["Square"], ["Cafe"], ["Square"], ["Platform"], ["Library"], ["Square"], ["Courtyard"], ["Cafe"], ["Library"], ["Square"], ["Library"], ["Sport Court"], ["Library"], ["Square"], ["Square"], ["Courtyard"], ["Square"], ["Corridor"], ["Square"], ["Platform"], ["Courtyard"], ["Courtyard"], ["Square"], ["Courtyard"], ["Platform"], ["Courtyard"], ["Square"], ["Sport Court"], ["Corridor"], ["Courtyard"], ["Square"], ["Library"], ["Square"], ["Cafe"], ["Corridor"], ["Library"], ["Library"], ["Square"], ["Library"], ["Platform"], ["Corridor"], ["Sport Court"], ["Platform"], ["Park"], ["Dance Room"], ["Platform"], ["Square"], ["Sport Court"], ["Library"], ["Corridor"], ["Platform"], ["Cafe"], ["Square"], ["Sport Court"], ["Corridor"], ["Platform"], ["Platform"], ["Square"], ["Square"], ["Library"], ["Library"], ["Square"], ["Sport Court"], ["Library"], ["Corridor"], ["Square"], ["Sport Court"], ["Library"], ["Corridor"], ["Cafe"], ["Corridor"], ["Square"], ["Square"], ["Courtyard"], ["Courtyard"], ["Dance Room"], ["Park"], ["Platform"], ["Square"], ["Platform"], ["Dance Room"], ["Square"], ["Corridor"], ["Sport Court"], ["Square"], ["Dance Room"], ["Square"], ["Library"], ["Square"], ["Sport Court"], ["Library"], ["Courtyard"], ["Corridor"], ["Sport Court"], ["Square"], ["Library"], ["Square"], ["Square"], ["Square"], ["Platform"], ["Courtyard"], ["Square"], ["Square"], ["Square"], ["Sport Court"], ["Sport Court"], ["Sport Court"], ["Square"], ["Corridor"], ["Cafe"], ["Platform"], ["Sport Court"], ["Courtyard"], ["Square"], ["Library"], ["Square"], ["Sport Court"], ["Corridor"], ["Lobby"], ["Library"], ["Square"], ["Cafe"], ["Cafe"], ["Corridor"], ["Courtyard"], ["Library"], ["Square"], ["Sport Court"], ["Square"], ["Library"], ["Square"], ["Courtyard"], ["Library"], ["Lobby"], ["Courtyard"], ["Square"], ["Library"], ["Corridor"], ["Square"], ["Platform"], ["Dance Room"], ["Square"], ["Dance Room"], ["Courtyard"], ["Corridor"], ["Square"], ["Library"], ["Cafe"], ["Square"], ["Lobby"], ["Courtyard"], ["Square"], ["Corridor"], ["Courtyard"], ["Dance Room"], ["Library"], ["Lobby"], ["Park"], ["Platform"], ["Sport Court"], ["Square"], ["(?)"], ["(?)"]],
        // ids: ["Indoor/Library/Greeting", "Indoor/Corridor/Greeting", "Outdoor/Cafe/Greeting", "Outdoor/Courtyard/Folk dance", "Outdoor/Square/Flybird", "Outdoor/Square/Eat", "Outdoor/Cafe/Eat", "Outdoor/Square/Drink", "Outdoor/Platform/Eat", "Indoor/Library/Walk", "Outdoor/Square/Umbrella", "Outdoor/Courtyard/Umbrella", "Outdoor/Cafe/Umbrella", "Indoor/Library/Wash hands", "Outdoor/Square/Wear headphone", "Indoor/Library/Wear glasses", "Outdoor/Sport Court/Wave hands", "Indoor/Library/Write", "Outdoor/Square/Wash hands", "Outdoor/Square/Upstair", "Outdoor/Courtyard/Urban", "Outdoor/Square/Urban", "Indoor/Corridor/Walk", "Outdoor/Square/Wacking", "Outdoor/Platform/Wave hands", "Outdoor/Courtyard/Wacking", "Outdoor/Courtyard/Move chair", "Outdoor/Square/Kick shuttlecock", "Outdoor/Courtyard/Kpop", "Outdoor/Platform/Latin", "Outdoor/Courtyard/Latin", "Outdoor/Square/Latin", "Outdoor/Sport Court/Leg lifting", "Indoor/Corridor/Move chair", "Outdoor/Courtyard/Make hair", "Outdoor/Square/Lateral raise", "Indoor/Library/Move chair", "Outdoor/Square/Leg lifting", "Outdoor/Cafe/Move mat", "Indoor/Corridor/Move mat", "Indoor/Library/Move mat", "Indoor/Library/Make hair", "Outdoor/Square/Move chair", "Indoor/Library/Make table", "Outdoor/Platform/Strentch lower", "Indoor/Corridor/Strentch lower", "Outdoor/Sport Court/Strentch", "Outdoor/Platform/Strentch", "Outdoor/Park/Strentch", "Indoor/Dance Room/Strentch", "Outdoor/Platform/Talk", "Outdoor/Square/Tie shoe", "Outdoor/Sport Court/Tie shoe", "Indoor/Library/Tie shoe", "Indoor/Corridor/Tie shoe", "Outdoor/Platform/Throw", "Outdoor/Cafe/Throw", "Outdoor/Square/Talk", "Outdoor/Sport Court/Talk", "Indoor/Corridor/Turn around", "Outdoor/Platform/Turn around", "Outdoor/Platform/Taichi", "Outdoor/Square/Typing", "Outdoor/Square/Take bag", "Indoor/Library/Take bag", "Indoor/Library/Talk", "Outdoor/Square/Strentch upper", "Outdoor/Sport Court/Strentch upper", "Indoor/Library/Strentch upper", "Indoor/Corridor/Strentch upper", "Outdoor/Square/Strentch lower", "Outdoor/Sport Court/Strentch lower", "Indoor/Library/Typing", "Indoor/Corridor/Talk", "Outdoor/Cafe", "Indoor/Corridor", "Outdoor/Square/Write", "Outdoor/Square/Stand", "Outdoor/Courtyard/Strentch", "Outdoor/Courtyard/Hiphop", "Indoor/Dance Room/Hiphop", "Outdoor/Park/Hiphop", "Outdoor/Platform/Hiphop", "Outdoor/Square/Hiphop", "Outdoor/Platform/Kick", "Indoor/Dance Room/Jazz", "Outdoor/Square/Jazz", "Indoor/Corridor/Jump", "Outdoor/Sport Court/Jump", "Outdoor/Square/Jump", "Indoor/Dance Room/K-Pop", "Outdoor/Square/Jacket", "Indoor/Library/Jacket", "Outdoor/Square/Aerobics", "Outdoor/Sport Court/Drink", "Indoor/Library/Drink", "Outdoor/Courtyard/Drink", "Indoor/Corridor/Drink", "Outdoor/Sport Court/Dribble", "Outdoor/Square/Cross barrier", "Indoor/Library/Clean table", "Outdoor/Square/Dance", "Outdoor/Square/Clean", "Outdoor/Square/Breaking", "Outdoor/Platform/Boxing", "Outdoor/Courtyard/Ballet", "Outdoor/Square/Arm lifting", "Outdoor/Square/Arm curl", "Outdoor/Square/Clean chair", "Outdoor/Sport Court/Move things", "Outdoor/Sport Court/Pass ball", "Outdoor/Sport Court/Pass", "Outdoor/Square/Packaging", "Indoor/Corridor/Packaging", "Outdoor/Cafe/Packaging", "Outdoor/Platform/Move things", "Outdoor/Sport Court/Shoot ball", "Outdoor/Courtyard/Move things", "Outdoor/Square/Move table", "Indoor/Library/Move table", "Outdoor/Square/Move mat", "Outdoor/Sport Court/Move mat", "Indoor/Corridor/Phone call", "Indoor/Lobby/Move things", "Indoor/Library/Phone call", "Outdoor/Square/Phone call", "Outdoor/Cafe/Photo", "Outdoor/Cafe/Sit", "Indoor/Corridor/Sit", "Outdoor/Courtyard/Sit", "Indoor/Library/Sit", "Outdoor/Square/Sit", "Outdoor/Sport Court/Skipping rope", "Outdoor/Square/Skipping rope", "Indoor/Library/Sleep", "Outdoor/Square/Squat", "Outdoor/Courtyard/Stand", "Indoor/Library/Stand", "Indoor/Lobby/Relax", "Outdoor/Courtyard/Relax", "Outdoor/Square/Read", "Indoor/Library/Read", "Indoor/Corridor/Push up", "Outdoor/Square/Posing", "Outdoor/Platform/Posing", "Indoor/Dance Room/Popping", "Outdoor/Square/Play phone", "Indoor/Dance Room/Play phone", "Outdoor/Courtyard/Play phone", "Indoor/Corridor/Play phone", "Outdoor/Square/Pick things", "Indoor/Library/Pick things", "Outdoor/Cafe/Pick thing", "Outdoor/Square/Photo", "Indoor/Lobby/Photo", "Outdoor/Courtyard/Photo", "Outdoor/Square/Rowing", "Indoor/Corridor/Pick things", "Outdoor/Courtyard", "Indoor/Dance Room", "Indoor/Library", "Indoor/Lobby", "Outdoor/Park", "Outdoor/Platform", "Outdoor/Sport Court", "Outdoor/Square", "Indoor", "Outdoor"],
        // labels: ["Greeting", "Greeting", "Greeting", "Folk dance", "Flybird", "Eat", "Eat", "Drink", "Eat", "Walk", "Umbrella", "Umbrella", "Umbrella", "Wash hands", "Wear headphone", "Wear glasses", "Wave hands", "Write", "Wash hands", "Upstair", "Urban", "Urban", "Walk", "Wacking", "Wave hands", "Wacking", "Move chair", "Kick shuttlecock", "Kpop", "Latin", "Latin", "Latin", "Leg lifting", "Move chair", "Make hair", "Lateral raise", "Move chair", "Leg lifting", "Move mat", "Move mat", "Move mat", "Make hair", "Move chair", "Make table", "Strentch lower", "Strentch lower", "Strentch", "Strentch", "Strentch", "Strentch", "Talk", "Tie shoe", "Tie shoe", "Tie shoe", "Tie shoe", "Throw", "Throw", "Talk", "Talk", "Turn around", "Turn around", "Taichi", "Typing", "Take bag", "Take bag", "Talk", "Strentch upper", "Strentch upper", "Strentch upper", "Strentch upper", "Strentch lower", "Strentch lower", "Typing", "Talk", "Cafe", "Corridor", "Write", "Stand", "Strentch", "Hiphop", "Hiphop", "Hiphop", "Hiphop", "Hiphop", "Kick", "Jazz", "Jazz", "Jump", "Jump", "Jump", "K-Pop", "Jacket", "Jacket", "Aerobics", "Drink", "Drink", "Drink", "Drink", "Dribble", "Cross barrier", "Clean table", "Dance", "Clean", "Breaking", "Boxing", "Ballet", "Arm lifting", "Arm curl", "Clean chair", "Move things", "Pass ball", "Pass", "Packaging", "Packaging", "Packaging", "Move things", "Shoot ball", "Move things", "Move table", "Move table", "Move mat", "Move mat", "Phone call", "Move things", "Phone call", "Phone call", "Photo", "Sit", "Sit", "Sit", "Sit", "Sit", "Skipping rope", "Skipping rope", "Sleep", "Squat", "Stand", "Stand", "Relax", "Relax", "Read", "Read", "Push up", "Posing", "Posing", "Popping", "Play phone", "Play phone", "Play phone", "Play phone", "Pick things", "Pick things", "Pick thing", "Photo", "Photo", "Photo", "Rowing", "Pick things", "Courtyard", "Dance Room", "Library", "Lobby", "Park", "Platform", "Sport Court", "Square", "Indoor", "Outdoor"],
        // marker: {
        //   colors: ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#FFA15A", "#00cc96", "#FFA15A", "#19d3f3", "#636efa", "#FFA15A", "#ab63fa", "#00cc96", "#636efa", "#FFA15A", "#636efa", "#FF6692", "#636efa", "#FFA15A", "#FFA15A", "#ab63fa", "#FFA15A", "#EF553B", "#FFA15A", "#19d3f3", "#ab63fa", "#ab63fa", "#FFA15A", "#ab63fa", "#19d3f3", "#ab63fa", "#FFA15A", "#FF6692", "#EF553B", "#ab63fa", "#FFA15A", "#636efa", "#FFA15A", "#00cc96", "#EF553B", "#636efa", "#636efa", "#FFA15A", "#636efa", "#19d3f3", "#EF553B", "#FF6692", "#19d3f3", "#B6E880", "#FF97FF", "#19d3f3", "#FFA15A", "#FF6692", "#636efa", "#EF553B", "#19d3f3", "#00cc96", "#FFA15A", "#FF6692", "#EF553B", "#19d3f3", "#19d3f3", "#FFA15A", "#FFA15A", "#636efa", "#636efa", "#FFA15A", "#FF6692", "#636efa", "#EF553B", "#FFA15A", "#FF6692", "#636efa", "#EF553B", "#00cc96", "#EF553B", "#FFA15A", "#FFA15A", "#ab63fa", "#ab63fa", "#FF97FF", "#B6E880", "#19d3f3", "#FFA15A", "#19d3f3", "#FF97FF", "#FFA15A", "#EF553B", "#FF6692", "#FFA15A", "#FF97FF", "#FFA15A", "#636efa", "#FFA15A", "#FF6692", "#636efa", "#ab63fa", "#EF553B", "#FF6692", "#FFA15A", "#636efa", "#FFA15A", "#FFA15A", "#FFA15A", "#19d3f3", "#ab63fa", "#FFA15A", "#FFA15A", "#FFA15A", "#FF6692", "#FF6692", "#FF6692", "#FFA15A", "#EF553B", "#00cc96", "#19d3f3", "#FF6692", "#ab63fa", "#FFA15A", "#636efa", "#FFA15A", "#FF6692", "#EF553B", "#FECB52", "#636efa", "#FFA15A", "#00cc96", "#00cc96", "#EF553B", "#ab63fa", "#636efa", "#FFA15A", "#FF6692", "#FFA15A", "#636efa", "#FFA15A", "#ab63fa", "#636efa", "#FECB52", "#ab63fa", "#FFA15A", "#636efa", "#EF553B", "#FFA15A", "#19d3f3", "#FF97FF", "#FFA15A", "#FF97FF", "#ab63fa", "#EF553B", "#FFA15A", "#636efa", "#00cc96", "#FFA15A", "#FECB52", "#ab63fa", "#FFA15A", "#EF553B", "#ab63fa", "#FF97FF", "#636efa", "#FECB52", "#B6E880", "#19d3f3", "#FF6692", "#FFA15A", "#636efa", "#636efa"]
        // },
        // parents: ["Indoor/Library", "Indoor/Corridor", "Outdoor/Cafe", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Square", "Outdoor/Cafe", "Outdoor/Square", "Outdoor/Platform", "Indoor/Library", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Cafe", "Indoor/Library", "Outdoor/Square", "Indoor/Library", "Outdoor/Sport Court", "Indoor/Library", "Outdoor/Square", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Corridor", "Outdoor/Square", "Outdoor/Platform", "Outdoor/Courtyard", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Platform", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Corridor", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Cafe", "Indoor/Corridor", "Indoor/Library", "Indoor/Library", "Outdoor/Square", "Indoor/Library", "Outdoor/Platform", "Indoor/Corridor", "Outdoor/Sport Court", "Outdoor/Platform", "Outdoor/Park", "Indoor/Dance Room", "Outdoor/Platform", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Indoor/Corridor", "Outdoor/Platform", "Outdoor/Cafe", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Corridor", "Outdoor/Platform", "Outdoor/Platform", "Outdoor/Square", "Outdoor/Square", "Indoor/Library", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Indoor/Corridor", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Indoor/Corridor", "Outdoor", "Indoor", "Outdoor/Square", "Outdoor/Square", "Outdoor/Courtyard", "Outdoor/Courtyard", "Indoor/Dance Room", "Outdoor/Park", "Outdoor/Platform", "Outdoor/Square", "Outdoor/Platform", "Indoor/Dance Room", "Outdoor/Square", "Indoor/Corridor", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Dance Room", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Library", "Outdoor/Courtyard", "Indoor/Corridor", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Square", "Outdoor/Square", "Outdoor/Platform", "Outdoor/Courtyard", "Outdoor/Square", "Outdoor/Square", "Outdoor/Square", "Outdoor/Sport Court", "Outdoor/Sport Court", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Corridor", "Outdoor/Cafe", "Outdoor/Platform", "Outdoor/Sport Court", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Indoor/Corridor", "Indoor/Lobby", "Indoor/Library", "Outdoor/Square", "Outdoor/Cafe", "Outdoor/Cafe", "Indoor/Corridor", "Outdoor/Courtyard", "Indoor/Library", "Outdoor/Square", "Outdoor/Sport Court", "Outdoor/Square", "Indoor/Library", "Outdoor/Square", "Outdoor/Courtyard", "Indoor/Library", "Indoor/Lobby", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Library", "Indoor/Corridor", "Outdoor/Square", "Outdoor/Platform", "Indoor/Dance Room", "Outdoor/Square", "Indoor/Dance Room", "Outdoor/Courtyard", "Indoor/Corridor", "Outdoor/Square", "Indoor/Library", "Outdoor/Cafe", "Outdoor/Square", "Indoor/Lobby", "Outdoor/Courtyard", "Outdoor/Square", "Indoor/Corridor", "Outdoor", "Indoor", "Indoor", "Indoor", "Outdoor", "Outdoor", "Outdoor", "Outdoor", "", ""],
        // values: [20248, 4432, 21784, 65792, 21984, 11328, 40048, 183824, 4064, 42608, 56032, 33192, 22144, 52616, 18624, 21184, 7416, 144328, 17568, 63792, 264272, 360808, 5472, 13650, 4280, 86016, 5400, 101312, 81128, 184760, 282560, 68508, 3264, 2480, 4832, 44832, 25104, 13584, 5200, 3200, 54264, 29440, 31744, 118792, 5008, 2608, 18512, 26472, 71024, 15648, 4272, 63424, 3232, 15936, 1656, 62616, 5000, 196750, 1056, 1824, 1408, 23400, 22800, 36240, 7072, 224968, 49336, 136936, 30144, 5080, 64768, 85088, 106048, 2832, 162472, 118056, 39904, 16896, 289192, 434816, 12008, 477936, 118144, 332263, 1056, 552757, 68325, 2016, 2000, 51504, 178488, 78888, 111680, 40920, 6400, 127472, 19392, 27744, 183872, 6768, 33176, 25824, 66912, 268016, 10448, 105736, 62928, 22176, 12240, 8616, 151512, 22336, 53640, 7472, 21608, 12000, 234120, 4056, 16112, 35592, 10992, 8400, 25208, 22824, 130928, 76272, 23656, 14424, 12688, 3864, 159384, 110952, 135648, 268832, 67256, 59664, 2624, 26936, 2600, 20848, 172184, 94256, 1424, 11112, 1200, 117944, 5088, 11112, 6248, 11120, 3408, 58320, 8608, 112344, 20400, 45304, 78072, 800, 1755272, 887957, 1737752, 45824, 548960, 459128, 1008408, 3513144, 2789589, 7447384]
      },
      comparisonData: [
        { name: '中广天择多视角数据集（2026）', environment: '真实场景', scenes: '2000+', duration: '10000+小时', one_min: '60分钟', cameras: '6', fps: '30', people: '6000+', isOurs: true, isFixed: false },
        { name: '数据集-A (2024)', environment: '真实场景', scenes: '10', duration: '13小时', one_min: '1分钟', cameras: '8', fps: '30 / 60', people: '40', isOurs: false, isFixed: false },
        { name: '数据集-B (2019)', environment: '真实场景', scenes: '1', duration: '1小时', one_min: '2分钟', cameras: '14', fps: '30', people: '8', isOurs: false, isFixed: true },
        { name: '数据集-C (2023)', environment: '实验室', scenes: '17', duration: '20小时', one_min: '6分钟', cameras: '4', fps: '50', people: '11', isOurs: false, isFixed: true },
        { name: '数据集-D (2018)', environment: '实验室', scenes: '1', duration: '5.5小时', one_min: '1分钟', cameras: '31', fps: '30', people: '8', isOurs: false, isFixed: true },
        { name: '数据集-E (2023)', environment: '真实场景', scenes: '3', duration: '2小时', one_min: '1分钟', cameras: '8', fps: '30', people: '36', isOurs: false, isFixed: true },
        { name: '数据集-F (2019)', environment: '真实场景', scenes: '4', duration: '1小时', one_min: '4分钟', cameras: '1', fps: '30', people: '7', isOurs: false, isFixed: true },
        { name: '数据集-G (2022)', environment: '实验室', scenes: '1', duration: '3小时', one_min: '1分钟', cameras: '11', fps: '30', people: '132', isOurs: false, isFixed: true }
        // { name: 'FreeMan (2024)', environment: '真实场景', scenes: '10', duration: '13小时', cameras: '8', fps: '30 / 60', people: '40', isOurs: false },
        // { name: 'MPI-INF-3DHP', environment: '真实场景', scenes: '1', duration: '2小时', cameras: '14', fps: '30', people: '8', isOurs: false },
        // { name: 'Human3.6M', environment: '实验室', scenes: '17', duration: '20小时', cameras: '4', fps: '50', people: '11', isOurs: false },
        // { name: 'CMU Panoptic Studio', environment: '实验室', scenes: '1', duration: '5.5小时', cameras: '31', fps: '30', people: '8', isOurs: false },
        // { name: 'Human-M3 (2023)', environment: '真实场景', scenes: '3', duration: '2小时', cameras: '8', fps: '30', people: '36', isOurs: false },
        // { name: '3DPW', environment: '真实场景', scenes: '4', duration: '1小时', cameras: '1', fps: '30', people: '7', isOurs: false },
        // { name: 'HuMMan-Released', environment: '实验室', scenes: '1', duration: '4小时', cameras: '11', fps: '30', people: '132', isOurs: false }

      ],
      // 视频播放器状态
      isPlaying: false,
      showControls: false,
      isLooping: false,
      isMuted: false,
      currentTime: '0:00',
      duration: '0:00',
      progressPercentage: 0,
      // 视频滚动观察器和事件处理器
      videoObserver: null,
      videoScrollHandler: null,
      videoLoadedDataHandler: null,
      // 声音分类数据库相关数据
      soundRawData:`
人声,“哀嚎” 声、“奥” 的声音、“不好” 的声音、“不屑” 的声音、“嘲讽” 声、“吃东西” 的声音、“抽泣” 的声音、“喘气” 的声音、“吹口哨” 的声音、“吹气” 的声音、“搓手” 的声音、“打耳光” 的声音、“打嗝” 的声音、“打鼾” 的声音、“打喷嚏” 的声音、“打气” 声、“打响指” 的声音、“打招呼” 的声音、“弹舌” 的声音、“抖腿” 声、“逗小孩” 声音、“嘟” 的声音、“哆嗦” 的声音、“跺脚” 的声音、“额” 的声音、“赶动物” 声音、“干杯” 的声音、“咯咯” 声、“哽咽” 声、“呱” 的声音、“鼓掌” 声、“哈欠” 声、“咳嗽” 声、“咳痰” 声音、“好” 的声音、“呵” 的声音、“喝东西” 的声音、“嘿” 的声音、“吼” 的声音、“呼气” 声、“呼吸” 声、“欢呼” 的声音、“嚯” 的声音、“尖叫” 的声音、“叫喊” 声、“惊叹” 声、“咀嚼” 声、“开心” 的声音、“口吃” 的声音、“哭” 的声音、“练气” 声、“略略” 声、“摸索” 声、“摩擦” 的声音、“磨牙” 声、“喏” 声、“呕吐” 声、“拍打” 的声音、“气泡” 声、“切” 的声音、“亲嘴” 的声音、“撒娇” 声、“生气” 的声音、“漱口” 声音、“嘶” 声、“嘶哈” 声、“叹气” 声、“疼痛” 的声音、“突突” 声、“吞咽” 声、“闻” 的声音、“吸溜” 声、“吸气” 声、“笑” 声、“咻” 的声音、“咦” 的声音、“疑惑” 声、“疑问” 声、“应和” 声、“自我介绍” 声、“吞咽” 声、“OK” 的声音、“啊” 的声音、“唉” 的声音、“唉呀” 的声音、“吧唧” 的声音、“鼻音” 的声音、“颤音” 的声音、“呲” 的声音、“尴尬” 的声音、“嗨” 的声音、“哼” 的声音、“唤动物” 声音、“嗯” 的声音、“哦” 的声音、“噗” 的声音、“哇” 的声音、“喂” 的声音、“擤鼻涕” 的声音、“嘘” 的声音、“小声说话” 的声音、“学动物叫声” 的声音、“长音” 的声音,“悲凉哀嚎声”、“凄切哀嚎”、“恍然奥声”、“否定不好”、“淡漠不屑声”、“嗤笑哧哧声”、“冷言讥讽声”、“轻鄙呸”、“疏离嫌弃声”、“厌弃呸声”、“咀嚼吃食物”、“慢咽吃东西声音”、“细嚼吃东西”、“细品吃东西的声音”、“粗重喘气声”、“低吟喘息声”、“急促喘气”、“微喘喘息”、“请亮口哨”、“婉转口哨声”、“悠扬吹口哨”、“轻送吹气”、“徐缓吹气声”、“干涩搓手声”、“摩擦搓手”、“脆响打耳光”、“凌厉耳光”、“清亮打耳光声”、“震响耳光声”、“闷逆打嗝”、“轻顿嗝”、“突兀打嗝声”、“沉缓打鼾声”、“沉闷打呼噜声”、“酣然打呼噜”、“厚重打鼾”、“悠远鼾声”、“猝然打喷嚏”、“低哑啧声”、“短促喷嚏”、“断续啧啧声”、“闷响打喷嚏声”、“轻抿啧”、“沉厚用力声”、“鼓劲加油”、“激昂喝彩声”、“雄浑劳动号子”、“脆亮打响指”、“随和打招呼”、“温和打招呼声”、“脆响弹舌”、“利落弹舌”、“利落弹舌声”、“利落咋舌”、“清越弹舌声”、“轻晃抖腿声”、“亲昵逗孩子”、“童趣小孩互动”、“低沉嘟噜声”、“连环嘟嘟声”、“绵软打嘟噜”、“绵长打嘟噜声”、“抿嘴嘟嘴声”、“轻响打嘟声”、“轻扬嘟声”、“碎念嘟囔声”、“圆润打嘟”、“发颤哆嗦”、“瑟缩打哆嗦”、“微抖哆嗦声”、“沉稳脚部声音”、“厚重跺脚声”、“用力跺脚”、“沉吟额声”、“迟疑额”、“顿住额音”、“呵斥赶动物”、“厉声驱赶动物”、“碰杯干杯声”、“清脆咯咯声”、“酸涩哽咽声”、“低沉呱声”、“合拍手掌拍打”、“洪亮掌声”、“节奏鼓点声”、“热烈鼓掌声”、“沉缓哈欠声”、“低柔哈声”、“倦闷斯哈”、“倦意哈气声”、“困倦哈欠”、“绵长哈气声”、“松弛哈气”、“慵懒哈”、“沉实咳嗽声”、“粗哑口噪声”、“低沉清嗓子”、“利落清嗓子声”、“轻浅咳嗽”、“浊重咯痰”、“爽快好”、“淡然呵声”、“轻缓呵气”、“畅快喝东西”、“清冽喝水声”、“昂扬嘿呀”、“利落嘿”、“清亮嘿声”、“爽朗嘿嘿”、“暴怒怒吼声”、“沉闷低吼声”、“粗狂吼”、“仿声模仿摩托车”、“浑厚低泡声”、“凄厉嘶吼声”、“震鸣吼声”、“绵长呼气声”、“轻吐呼气”、“悠然呼声”、“平缓呼吸声”、“匀净呼吸”、“雀跃欢呼”、“热烈欢呼声”、“诧异嚯咦声”、“短促嚯声”、“惊觉嚯”、“刺耳尖叫”、“尖锐尖叫声”、“清亮叫声”、“激昂呐喊声”、“娇柔喊妈妈”、“朦胧迷糊时的叫喊”、“稚嫩喊爸爸”、“诧异惊讶声”、“愕然惊叹声”、“恍然惊讶哦豁”、“讶异惊讶”、“扬调惊讶声调上扬声”、“由衷赞叹声”、“沉稳咀嚼声”、“鲜香咀嚼”、“高扬耶声”、“雀跃耶”、“热忱恭喜”、“舒心愉悦”、“舒展放松声”、“结巴口吃”、“滞涩口吃声”、“低沉呜咽声”、“哽咽呜咽”、“闷郁唔声”、“凄切哭声”、“委屈哭”、“喜极边笑边哭”、“聚气练气声”、“凝神练功声”、“调皮略略声”、“俏皮吐舌头略”、“脆响掰手指”、“细碎悉悉索索”、“粗砺刮擦声”、“干涩摩擦声”、“沉震磨牙声”、“紧咬磨牙”、“磨动齿音”、“轻叩叩齿声”、“应声喏声”、“反胃呕吐”、“作呕呕吐”、“沉稳敲门声”、“笃定拍胸脯声”、“厚实胸脯声”、“轻缓身体拍打声”、“轻拍护肤”、“清脆敲打声”、“重拍桌子”、“轻盈气泡声”、“不屑切”、“冷淡切声”、“亲昵亲嘴”、“轻吻亲吻”、“细碎亲嘴声”、“软媚撒娇”、“甜柔撒娇声”、“暴怒咆哮”、“怒吼咆哮”、“轻响漱口声”、“清爽漱口”、“倒吸嘶”、“冷嘶嘶声”、“抽气嘶哈”、“忍痛嘶哈”、“怅然惋惜声”、“沉闷叹气声”、“低沉叹息声”、“落寞叹气”、“轻缓叹息”、“意外惊叹声”、“刺痛痛感声”、“难忍疼痛声”、“痛苦呻吟声”、“急促突突声”、“馋人咽口水声”、“厚重吞咽声”、“自然吞咽”、“凑近嗅闻”、“淡淡嗅闻声”、“轻浅闻嗅”、“清幽嗅声”、“细碎闻嗅声”、“软糯吸溜声”、“绵长吸气声”、“轻缓吸气”、“开怀笑”、“清甜笑声”、“连绵咻咻声”、“破空咻声”、“娇软咦呀”、“惊奇咦”、“轻细咦声”、“柔和咦音”、“婉转咦呀”、“不解质疑声”、“困惑疑问声”、“利落应和声”、“随和应和声”、“大方自我介绍”、“沉闷咽吞声”、“顺滑咽水”、“爽快OK”、“高亢啊叫声”、“哽咽呜啊”、“欢快啊哈”、“恍然啊哦”、“惊呀啊”、“平淡啊声”、“柔和啊哦声”、“爽朗啊哈声”、“婉转啊呀声”、“微弱低啊声”、“低沉唉声”、“轻叹唉声”、“轻细唉声”、“柔和唉”、“无奈唉”、“娇呼唉呀”、“娇俏唉呀”、“惊呼唉呀”、“轻缓唉呀”、“清甜唉呀”、“婉转唉呀声”、“满足吧唧嘴”、“轻弹咂舌声”、“贪吃吧唧”、“玩味咂舌”、“慵懒咂嘴声”、“闷沉鼻声”、“软糯鼻音”、“慵懒鼻息声”、“惊惧颤抖”、“绵长颤音声”、“柔转颤音”、“瑟缩打寒颤”、“微抖颤声”、“憋笑噗呲”、“冷厉呲声”、“轻嗤呲呲”、“细碎呲呲声”、“窘迫尴尬声”、“开朗嗨”、“清爽嗨声”、“不屑哼”、“赌气哼气”、“冷淡哼声”、“轻快哼唱”、“软萌哼唧”、“温柔哼唱声”、“愉悦哼唱”、“呼唤动物”、“轻唤嘬声”、“投喂喂动物”、“温柔啰啰声”、“招呼动物”、“宠溺嗯哼”、“低沉嗯声”、“娇软嗯哼声”、“软糯嗯嗯声”、“应诺嗯”、“恍然哦”、“惊喜哦吼”、“清淡哦声”、“惋惜哦豁”、“无奈哦豁声”、“安静噗 噤声”、“不屑噗 撇唇声”、“短促噗 噗声”、“尴尬噗 屁声”、“含糊噗 秃噜声”、“可爱噗 打噗噜”、“轻快噗 噗噗”、“委委屈屈的噗”、“细碎噗 嘴部口腔声”、“细微噗 噗噗声”、“呆萌的哇偶”、“调皮的哇”、“慌张的哇呀”、“惊喜的哇”、“惊讶的哇”、“夸张的哇塞”、“难过的呜哇”、“轻轻的哇声”、“软萌的哇呜”、“爽朗的哇”、“突然的打”、“委屈的哇哇”、“响亮的哇塞”、“小声的哇唔”、“悠长的哇”、“大声喂”、“小声喂”、“轻擤鼻涕”、“重擤鼻涕”、“大声嘘”、“低声嘘”、“短嘘”、“长嘘”、“呢喃声”、“悄悄话声”、“呓语声”、“骑马”、“情绪高涨的模仿声”、“蛙鸣”、“很长的拖音”
自然,“城市环境声”、“城市环境音”、“特定设备声”、“自然界声音”,“大学--课后休息日常生活环境”、“办公室”、“餐饮”、“超市”、“车内”、“城郊”、“电脑城”、“公园”、“广场”、“户外日常”、“会议室”、“车库”、“城郊车辆”、“城郊公路”、“城市路边人行道”、“窗外”、“大巴车”、“大道旁”、“大桥”、“地铁”、“地铁站”、“地下车库”、“地下车库双车道”、“电动车”、“电动车上”、“动车列车”、“飞机”、“高架”、“高架桥”、“高楼”、“高铁”、“工地”、“工地上”、“公交车”、“公交车和车站”、“公交车内”、“公交车站”、“公交站”、“共享电动车”、“古镇”、“国道”、“湖泊边”、“火车”、“货运车辆”、“江边”、“轿车内”、“轿车上”、“街道”、“景区”、“酒店”、“垃圾站”、“路边”、“路边停车内休息”、“露营地”、“马路边”、“马路边交通车流胎噪声+不规律鸣笛”、“牧区”、“汽车维修店”、“桥上”、“轻轨交通”、“商业街”、“十字路口”、“室内窗边”、“水上交通”、“私家车内”、“隧道”、“停车场”、“网约和出租车”、“乡村”、“小区”、“学校”、“幼儿园”、“雨天马路边”、“主干道十字路口东西向（有风的影响）”、“主干道十字路口西东向（有风的影响）”、“地铁警报”、“警示语音声”、“提示音”、“酒吧歌厅”、“居家环境”、“厨房冰块”、“餐桌”、“剧组”、“路边菜摊”、“路边食物摊”、“吃东西”、“儿童乐园”、“饭馆”、“话剧院”、“家庭”、“教育机构”、“快递站”、“走路”、“KTV”、“便利店”、“步行街”、“菜鸟驿站”、“菜市场”、“餐饮店”、“城市河道”、“出租房”、“厨房”、“磁浮列车”、“大市场”、“地下通道”、“电梯口”、“电玩城”、“电影院”、“飞机场”、“高铁站”、“河边”、“候车厅”、“湖边”、“花店”、“火车站”、“机场”、“教室”、“街道边”、“橘子洲”、“咖啡店”、“快递驿站”、“垃圾回收站”、“篮球场”、“理发店”、“美甲店”、“美术馆”、“密室”、“民俗体验馆”、“奶茶店”、“农村”、“农贸市场”、“乒乓球馆”、“棋牌室”、“汽车站”、“山”、“商店”、“烧烤店”、“小学环境音”、“写字楼”、“养殖场”、“夜市”、“医院”、“银行”、“游乐场”、“羽毛球馆”、“足球场”、“湘超株洲展演和比赛全程观众区八个通道”、“商业商场”、“KFC”、“按摩店”、“百货店”、“彩票店”、“宠物乐园”、“店铺”、“废品店”、“服装店”、“家具超市”、“街边商贩”、“精品店”、“酒馆”、“棋牌”、“商场广场”、“商场嘈杂声”、“商业广场”、“商业推广”、“市场”、“室外”、“水果店”、“网吧电竞”、“洗车店”、“药店”、“夜宵摊”、“宜家”、“娱乐场所”、“娱乐活动”、“岳麓山”、“展馆”、“社区菜市场”、“社区菜市场50”、“生活日常小件”、“安置小区”、“场地维护”、“车间”、“喷漆声”、“汽车修理厂”、“商场外”、“园区”、“体育活动”、“体育活动50”、“文艺团体”、“文艺现场”、“初中日常”、“大学课堂”、“大学日常”、“高中日常”、“医院”、“娱乐”、“运动场地”、“自驾”、“家电设备”、“大块冰川断裂落水声”、“大山暴风雪后寂静的声音”、“大山山口呼啸声”、“洞穴里风声”、“风吹过草原”、“风吹过枯草”、“海底水流涌动”、“海浪击打人工堤坝”、“海浪拍打海岸”、“海浪拍打礁石”、“海浪拍打沙滩”、“河流流水”、“湖面平静水声”、“湖面起伏”、“湖面水滴落”、“湖水冲击人工护坡”、“湖水高低落差”、“湖水拍岸”、“湖水拍打石头”、“江面起伏”、“江水拍岸”、“江水拍打亲水平台”、“平原打雷”、“平原环境底噪”、“人造景观非自然类水流水滴”、“人造设施排水管道”、“人造设施水渠”、“森林环境底噪”、“沙漠峡谷呼啸”、“沙丘”、“山洞水滴”、“山谷呼啸”、“山环境底噪”、“山泉水”、“树枝摇曳”、“田野”、“无风的午后森林”、“溪流流水”、“溪流河床转弯处激荡”、“溪水高处跌落深潭沉闷声”、“正常洞穴”、“白鹭”、“北极熊叫声”、“边境牧羊犬”、“鹅”、“鹅叫”、“海鸥”、“红腹锦鸡”、“家鸡”、“金毛”、“麻雀”、“奶牛”、“其他鸟类”、“企鹅叫声”、“禽类聚集”、“乌鸦”、“鸭”、“鹦鹉”、“中华田园犬”、“大风”、“大雨”、“风吹动管道”、“风吹动铁索栏杆”、“风吹动帐篷”、“风吹塑料薄膜”、“风吹塑料袋”、“风通过缝隙”、“雷雨”、“微风”、“小雨”、“雪水融化滴落”、“雨打尼龙雨伞面”、“雨滴打雨棚”、“雨量渐变”、“雨落帐篷”、“雨落草地”、“雨落防盗窗”、“雨落金属面”、“雨落木质面”、“雨落泥土”、“雨落泡沫”、“雨落汽车挡风玻璃”、“雨落汽车顶部”、“雨落石质面”、“雨落水泥路面”、“雨落塑胶跑道”、“雨落塑料面”、“雨落叶片”、“雨水打雨幕”、“雨水滴入水池”、“中雨”、“干芭蕉树枝叶摩擦”、“干草本灌木丛摩擦”、“干竹枝叶摩擦”、“混合枝叶踩踏”、“混合枝叶摩擦”、“湿草本灌木丛摩擦”、“湿杜鹃花枝叶摩擦”、“湿竹枝叶摩擦”
音乐,“伴奏”、“唱歌”、“合唱”、“交响乐演出”、“进行曲”、“乐器合奏”、“乐器演奏”、“通俗唱法”、“戏曲”、“音乐盒”、“音乐演奏”、“音效合成”,“伴奏1”、“唱歌50”、“合唱--50”、“交响乐演出实况”、“进行曲1”、“乐器合奏1”、“阿拉伯乐器布祖基琴-50”、“阿拉伯乐器卡农琴-50”、“阿拉伯乐器卡瓦拉笛子-50”、“阿拉伯乐器内伊笛子-50”、“阿拉伯乐器撒兹琴-50”、“阿拉伯乐器乌德琴-50”、“巴洛克琴-50”、“巴洛克小提琴-50”、“巴松-50”、“班博尔德笛子-50”、“贝斯-50”、“拨片鲁特琴-50”、“玻璃琴-50”、“打击乐”、“大阮”、“单簧管-50”、“弹拨--古琴”、“弹拨--古琴-50”、“弹拨--琵琶”、“低音笛子-50”、“低音号-50”、“低音长号-50”、“电声乐器--电贝司”、“电声乐器--电颤琴-50”、“电声乐器--电吉他”、“定音锣-50”、“杜卡纳管-50”、“短笛”、“二胡”、“二胡与其他乐器”、“鼓-架子鼓-50”、“鼓-中国鼓”、“管风琴-50”、“吉他--古典吉他”、“吉他--民谣吉他”、“口琴-49”、“乐器合奏”、“马林巴-50”、“民族-扬琴”、“木琴-49”、“日本乐器SHAKUHACHI-49”、“日本乐器TSUGARU SHAMISEN-49”、“日本乐器日本笙-50”、“萨克斯-49”、“哨笛-50”、“手碟”、“手摇琴”、“竖琴”、“双簧管”、“唢呐”、“坦克鼓”、“唐布拉琴”、“提琴--大提琴”、“提琴--大提琴-50”、“提琴--小提琴”、“萧”、“小号”、“小提琴音色”、“音乐节拍器100bpm”、“音乐节拍器105bpm”、“音乐节拍器110bpm”、“音乐节拍器115bpm”、“音乐节拍器120bpm”、“音乐节拍器125bpm”、“音乐节拍器130bpm”、“音乐节拍器135bpm”、“音乐节拍器140bpm”、“音乐节拍器145bpm”、“音乐节拍器150bpm”、“音乐节拍器155bpm”、“音乐节拍器160bpm”、“音乐节拍器165bpm”、“音乐节拍器170bpm”、“音乐节拍器175bpm”、“音乐节拍器180bpm”、“音乐节拍器185bpm”、“音乐节拍器190bpm”、“音乐节拍器50bpm”、“音乐节拍器55bpm”、“音乐节拍器60bpm”、“音乐节拍器65bpm”、“音乐节拍器70bpm”、“音乐节拍器75bpm”、“音乐节拍器75bpm 版本2”、“音乐节拍器80bpm”、“音乐节拍器85bpm”、“音乐节拍器90bpm”、“音乐节拍器95bpm”、“印度乐器班苏里笛”、“印度乐器桑图尔琴”、“印度乐器西塔琴”、“印度乐器印度手风琴”、“英国号”、“圆号”、“长笛”、“长号”、“指拨”、“中胡”、“中世纪高音直笛”、“中世纪号”、“中世纪六弦鲁特”、“中世纪鲁特琴”、“中世纪木质竖笛”、“中世纪维吉那琴”、“中世纪希尔博琴”、“中世纪小笛子”、“中世纪小管风琴”、“中世纪小吉他”、“中世纪羽管键琴”、“中世纪长号”、“中世纪长颈鲁特琴”、“中提琴”、“钟琴”、“通俗唱法1”、“戏曲50”、“音乐盒1”、“12.31摇滚重金属重金属”、“12.86摇滚重金属颗粒合成音色”、“80s合成器音色摇滚”、“80年代合成器摇滚”、“80年代合成器重金属”、“90年代合成器摇滚”、“rapKpop音色”、“rap八音盒音色”、“rap主奏铃铛合成器”、“安魂曲”、“八音盒音色”、“变奏曲”、“沉闷跳跃的电钢琴”、“脆裂钢琴音色”、“电钢琴”、“电钢琴2”、“电子--dubstep”、“电子--EDM”、“电子--house”、“电子--Progressive House”、“电子--trance”、“电子合成器2摇滚”、“电子合成器3重金属”、“电子合成器摇滚”、“电子合成器重金属”、“氛围音色”、“复合电子琴”、“复合电子琴2”、“复兴音色”、“工业感音色”、“古典的圆舞曲”、“幻想曲”、“交响乐”、“交响诗”、“金属80s合成器音色”、“金属八音盒音色”、“金属合成电吉他拨奏感”、“金属合成电吉他清音”、“金属合成原声吉他”、“金属合成原声木吉他2”、“金属经典合成器音色”、“金属空灵的合成器音色”、“金属拇指琴音色”、“经典合成器音色”、“爵士--比波普”、“爵士--传统爵士”、“爵士--大摇摆”、“爵士--调式爵士”、“爵士--冷爵士”、“爵士--融合爵士”、“爵士--硬波普”、“空灵的合成器音色”、“凌厉合成器音色”、“流行”、“梦幻电钢琴”、“民谣”、“民族”、“明亮合成器”、“明亮跳跃的电钢琴”、“拇指琴音色”、“说唱--alternative hip hop”、“说唱--boombap”、“说唱--cloud rap”、“说唱--conscious political rap”、“说唱--conscious rap”、“说唱--drill”、“说唱--emo”、“说唱--G funk”、“说唱--gangsta rap”、“说唱--gospel rap”、“说唱--horror core”、“说唱--hyperpop pc music-influence”、“说唱--jazz rap”、“说唱--mumble rap”、“说唱--southern hip hop”、“说唱--trap”、“特艺彩色合成器音色”、“跳跃的电子琴”、“吐泡泡的合成电子琴”、“吐泡泡的合成电子琴2温暖版”、“温暖的电子琴”、“温暖火焰音色”、“温暖闪烁的电钢琴”、“戏曲50长沙花鼓戏”、“乡村”、“乡村布鲁斯”、“小步舞曲”、“协奏曲”、“学校音乐会”、“摇摆的电子琴”、“摇滚--后浪摇滚”、“摇滚--另类摇滚”、“摇滚--迷幻摇滚”、“摇滚--朋克摇滚”、“摇滚--前卫摇滚”、“摇滚--情绪摇滚”、“摇滚--数字摇滚”、“摇滚--英伦摇滚”、“摇滚--硬核摇滚”、“摇滚--重金属摇滚”、“宗教”、“奏鸣曲”、“XXSC-音频制作-古典明亮电子钢琴弹奏流行风格乐曲”、“XXSC-音频制作-古典轻快的钢琴弹流行风格乐曲”、“XXSC-音频制作-古典音色偏暗的电钢琴弹流行风格乐曲”、“沉闷的钢琴演奏古典音乐”、“氛围钢琴演奏古典乐”、“极简钢琴演奏古典音乐”、“键盘音色1演奏古典音乐”、“节拍钢琴演奏古典音乐”、“科幻钢琴演奏古典音乐”、“颗粒钢琴演奏古典音乐”
复杂,“室内”、“室外”,“KTV”、“按摩店”、“办公室”、“包子铺”、“便利店”、“别墅”、“冰块厂”、“菠萝地”、“彩票店”、“菜市场”、“餐厅”、“餐饮”、“餐饮店”、“茶馆”、“茶馆内”、“场馆”、“超市”、“车库”、“车辆”、“车内”、“大头贴店”、“蛋糕店内”、“地下库”、“电竞酒店”、“电梯”、“电梯间”、“雕刻室”、“动物园”、“饭店”、“服饰店”、“服装店”、“高中课堂”、“工厂--户外厂房”、“工厂--户外厂房-1”、“工厂--室内厂房”、“工作室”、“购物场所”、“话剧场”、“会议室”、“会议室-95”、“活动大厅”、“火锅店”、“机场”、“家庭”、“家庭-1”、“健身房”、“教育机构”、“警情--消防”、“酒吧”、“酒店”、“酒馆”、“居家”、“居家环境”、“剧院”、“剧组--剧目”、“剧组--影视”、“聚会活动”、“聚会活动-2”、“咖啡店”、“快递服务站”、“篮球馆”、“乐器店”、“理发店”、“理疗店、中医馆”、“零食店”、“零食店50”、“麻将馆”、“猫粮店”、“美甲店”、“美容美甲店”、“美术馆”、“密室逃脱”、“民宿”、“奶茶店”、“棋牌室”、“企业--大厅”、“企业--团建”、“汽修店”、“拳击店”、“人活动音50”、“日常活动”、“软件教学”、“商场”、“商店”、“商业”、“商业娱乐50”、“社区”、“社区菜市场50”、“社区中心”、“生活日常”、“生活日常小件”、“生态农场”、“室内”、“室内-49”、“蔬菜大棚”、“寺庙”、“台球店”、“台球厅”、“甜品店”、“停车场”、“网吧”、“卫生院”、“文化学习”、“文体活动”、“文艺活动”、“文艺活动50”、“文娱活动”、“舞蹈室”、“戏院”、“小酒馆”、“校园--初中课堂”、“校园--初中日常”、“校园--大学课堂”、“校园--大学日常”、“校园--大学上课”、“校园--大学生活日常”、“校园--高中”、“校园--高中课堂”、“校园--高中日常”、“校园--小学”、“校园--小学课堂”、“校园--小学课堂-1”、“校园--小学日常”、“校园--幼儿园课堂”、“校园--幼儿园日常”、“写字楼”、“休闲”、“学校”、“眼镜店”、“演播厅”、“演唱会”、“药材研制工作室”、“药店”、“医院”、“音响店”、“银行”、“游戏体验馆”、“游戏厅”、“幼儿园”、“幼儿园--校园环境50”、“娱乐场所”、“羽毛球场”、“羽毛球馆”、“扎染房”、“展览”、“展厅”、“展厅-4”、“照相馆”、“直播间”、“直播间-4”、“中医馆”、“比赛现场”、“比赛现场-9”、“菜园”、“操场”、“草原”、“城市--公园”、“城市--公园--湿地公园下水道”、“城市--公园--湿地--口袋公园”、“城市--广场”、“船”、“船上”、“地铁站”、“飞机”、“飞机上”、“甘蔗地”、“高铁”、“高铁上”、“高铁站”、“工程机械”、“工地”、“公园”、“枸杞地”、“广场”、“海边”、“河边”、“湖边”、“滑翔伞”、“滑雪场”、“集市”、“驾校”、“驾校户外”、“驾校--交通工具教学”、“交通--城市地铁”、“交通--城市公交”、“交通--城市客运出租”、“交通工具维修”、“交通--轮渡”、“交通--铁路客运”、“交通--自驾”、“交通--自驾-81”、“街边”、“景区”、“景区--人文景区”、“景区--自然景区”、“路边”、“路边食物摊50”、“露台”、“马场”、“马路边”、“马路边--城郊”、“马路边--城市”、“马路边--集镇”、“马路边--乡村”、“马术场”、“农场”、“农村”、“农村生活”、“农林牧渔--森林-1”、“农林牧渔--滩涂”、“农林牧渔--渔场”、“祁连山”、“企业--业务推广发布相关活动”、“企业--周边-停车场-通道等”、“企业--周边-停车场-通道等-1”、“青海湖二朗剑景区”、“球场”、“沙滩”、“山林”、“商业街”、“施工”、“施工现场”、“施工噪音50”、“市场”、“室外”、“树林”、“水上”、“体育活动50”、“田边”、“庭院”、“涠洲岛”、“乡村”、“湘江边”、“小区”、“泳池”、“游乐场”、“游乐园”、“张掖七彩丹霞旅游景区”
`,
      soundCategoryData: {
        "人声": { lv2: 103, lv3: 338 },
        "自然": { lv2: 4,   lv3: 398 },
        "音乐": { lv2: 12,  lv3: 427 },
        "复杂": { lv2: 2,   lv3: 241 }
      },
      level1Order: ["人声", "自然", "音乐", "复杂"],
      statusText: '加载中...',
      allSoundData: [],
      // 音频数据能力相关
      currentTab: 0,
      playingIndex: -1,
      progressWidths: [0, 0, 0, 0],
      audioDataList: [
        {
          title: "人声",
          desc: "聚焦真实世界中人体生理反应、情绪表达与非语言行为声音，系统覆盖从基础发声到复杂情绪反馈的多层级人声事件。数据包含哭、笑、咳嗽、喷嚏、叹气、惊呼等300+细分类别。包含10种性别年龄组合，覆盖儿童男（3-6岁）、儿童女（3-6岁）、少年男（7-14岁）、少年女（7-14岁）、青年男（15-35岁）、青年女（15-35岁）、中年男（36-60岁）、中年女（36-60岁）、老年男（61岁以上）、老年女（61岁以上），高度还原真实生活中的情绪、生理与行为声学特征。",
          specs: ["44.1kHz / 16bit", "抽泣声 / 弹舌声 / 欢呼声 / 漱口声 / 叹气声 / 哈欠声等100+类别", "4000+小时", "音频描述准确率≥97%"],
          tags: ["情感分析", "情感标注", "说话人识别"],
          titles: ["笑声", "欢呼声", "抽噎声", "哈欠"]
        },
        {
          title: "自然",
          desc: "聚焦真实世界中稀缺、传统采集难以规模化获取的声源，构建覆盖自然生态、人类活动与设备运行三大核心领域的2000+细分类别体系。特别针对稀缺动物叫声（如北极熊叫声）、极端天气变化声（如河面结冰声）和多类型专业设备运行声等高价值、高难度声源开展专项化采集，每类样本量均超过50条（例如不同时节、不同气候下的流水场景，采集到五十余种差异化水流声响样本）。",
          specs: ["44.1kHz / 16bit", "雨声 / 鸟鸣 / 风声 / 交通噪音 / 商场环境 / 家用电器等2000+类别", "2000+小时", "音频描述准确率≥97%"],
          tags: ["声源识别", "环境感知", "影视音效"],
          titles: ["自然界声音-地理水文-水流声", "自然界声音-动物声音-狗叫声", "特定设备声-家电设备-儿童电动牙刷", "城市环境声-体育活动"]
        },
        {
          title: "音乐",
          desc: "聚焦真实乐器演奏场景与多风格音乐表达，系统覆盖中西方多类别乐器声音，涵盖钢琴、吉他、贝斯、鼓、电子琴、萨克斯，以及琵琶、唢呐、笛等传统民族乐器，累计收录300+细分类别。数据具有独奏、旋律、节奏、演奏技巧与多样化音色特征，包含丰富乐器体系、多元音乐风格与真实演奏场景。",
          specs: ["44.1kHz / 16bit", "钢琴 / 吉他 / 贝斯 / 鼓 / 萨克斯 / 琵琶 等300+类别", "2000+小时", "音频描述准确率≥97%"],
          tags: ["音频创作", "音色建模", "乐器识别"],
          titles: ["乐器演奏-二胡与其他乐器", "乐器演奏-民族扬琴", "合唱", "长沙花鼓戏"]
        },
        {
          title: "复杂",
          desc: "基于真实复杂场景采集，每条音频包含不少于3个声音事件，多事件叠加的真实声场。覆盖家庭日常、休闲娱乐、商铺经营、办公会议、校园生活、文旅演出、社区公共、餐饮服务等240余种复合场景。",
          specs: ["44.1kHz / 16bit", "比赛现场 / 演唱会 / 会议室 / 公园 / 广场 / 地铁等240+复合场景", "5500+小时", "音频描述准确率≥97%"],
          tags: ["场景理解", "场景感知", "多事件标注"],
          titles: ["夜市", "超市", "餐馆", "医院"]
        }
      ],
      audioPathMap: {
        0: ['中年女-嘲讽笑1058.wav', '欢呼声.wav', '抽噎声.wav', '哈欠.wav'],
        1: ['自然界声音-地理水文-水流声.wav', '自然界声音-动物声音-狗叫声.wav', '特定设备声-家电设备-儿童电动牙刷.wav', '城市环境声-体育活动.wav'],
        2: ['乐器演奏-二胡与其他乐器.wav', '乐器演奏-民族扬琴.wav', '合唱.wav', '长沙花鼓戏.wav'],
        3: ['夜市.wav', '超市.wav', '餐馆.wav', '医院.wav']
      }



    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    // 视频自动播放处理（浏览器兼容性）
    this.initVideo();
    // 动态加载 Plotly.js
    this.initPlotlyChart();
    // 初始化视频滚动播放观察器
    this.initVideoScrollObserver();
    // 启动4个轮播自动播放
    this.startAutoPlay(1);
    this.startAutoPlay(2);
    this.startAutoPlay(3);
    this.startAutoPlay(4);

    // 初始化悬浮栏事件
    this.initSidebarEvents();

    // 初始化声音分类数据库
    this.processSoundData();
  },
  computed: {
    currentData() {
      return this.audioDataList[this.currentTab];
    },
    allFlatRows() {
      const rows = [];
      this.allSoundData.forEach(group => {
        group.rows.forEach(row => {
          rows.push({
            ...row,
            lv1: group.lv1,
            lv1RowSpan: group.rowSpan,
            showLv1: row.showLv1
          });
        });
      });
      return rows;
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    // 清理 Plotly 图表
    if (window.Plotly && this.plotlyLoaded) {
      const container = document.getElementById('plotly-action-viz');
      if (container) {
        window.Plotly.purge('plotly-action-viz');
      }
    }
    // 清理视频滚动观察器
    if (this.videoObserver) {
      this.videoObserver.disconnect();
      this.videoObserver = null;
    }
    // 清理视频滚动事件处理器
    if (this.videoScrollHandler) {
      window.removeEventListener('scroll', this.videoScrollHandler);
      this.videoScrollHandler = null;
    }
    // 清理视频元素事件监听器
    const video = this.$refs.introVideo;
    if (video) {
      video.removeEventListener('loadeddata', this.onVideoLoaded);
      video.removeEventListener('timeupdate', this.onTimeUpdate);
      video.removeEventListener('ended', this.onVideoEnded);
      // 清理滚动观察器添加的 loadeddata 事件
      if (this.videoLoadedDataHandler) {
        video.removeEventListener('loadeddata', this.videoLoadedDataHandler);
        this.videoLoadedDataHandler = null;
      }
    }
    // 清理4个轮播定时器
    this.stopAutoPlay(1);
    this.stopAutoPlay(2);
    this.stopAutoPlay(3);
    this.stopAutoPlay(4);
  },
  methods: {
    // 音频数据能力相关方法
    switchAudioTab(idx) {
      this.currentTab = idx;
      this.stopAllAudios();
      this.progressWidths = [0, 0, 0, 0];
      this.playingIndex = -1;
    },
    getAudioPath(index) {
      const filename = this.audioPathMap[this.currentTab][index];
      return require('./assets/audio/' + filename);
    },
    // getAudioSrc(index) {
    //   const urls = [
    //     'https://www.w3schools.com/html/horse.mp3',
    //     'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3',
    //     'https://www.w3schools.com/html/horse.mp3',
    //     'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
    //   ];
    //   return urls[index % urls.length];
    // },
    toggleAudioPlay(index) {
      const audioRefs = this.$refs[`audio-${index}`];
      if (!audioRefs) return;
      const audio = Array.isArray(audioRefs) ? audioRefs[0] : audioRefs;

      if (audio.paused) {
        this.stopAllAudios();
        audio.play();
        this.playingIndex = index;
      } else {
        audio.pause();
        this.playingIndex = -1;
      }
    },
    stopAllAudios() {
      for (let i = 0; i < 4; i++) {
        const audioRefs = this.$refs[`audio-${i}`];
        if (audioRefs) {
          const audio = Array.isArray(audioRefs) ? audioRefs[0] : audioRefs;
          audio.pause();
        }
      }
      this.playingIndex = -1;
    },
    onAudioTimeUpdate(index) {
      const audioRefs = this.$refs[`audio-${index}`];
      if (!audioRefs) return;
      const audio = Array.isArray(audioRefs) ? audioRefs[0] : audioRefs;

      if (audio.duration) {
        const percent = (audio.currentTime / audio.duration) * 100;
        this.$set(this.progressWidths, index, percent);
      }
    },
    onAudioEnd(index) {
      this.$set(this.progressWidths, index, 0);
      if (this.playingIndex === index) {
        this.playingIndex = -1;
      }
    },
    seekAudio1(event, index) {
      const audioRefs = this.$refs[`audio-${index}`];
      if (!audioRefs) return;
      const audio = Array.isArray(audioRefs) ? audioRefs[0] : audioRefs;

      if (isNaN(audio.duration)) return;
      const rect = event.currentTarget.getBoundingClientRect();
      const percent = (event.clientX - rect.left) / rect.width;
      audio.currentTime = percent * audio.duration;
    },
    // 声音分类数据库相关方法
    getSortWeight(name) {
      const idx = this.level1Order.indexOf(name);
      return idx === -1 ? 999 : idx;
    },
    processSoundData() {
      const allData = this.soundRawData.trim().split("\n").map(row => {
        const parts = row.split(",");
        return {
          lv1: parts[0].trim(),
          lv2: parts[1] ? parts[1].trim() : '',
          lv3: parts[2] ? parts[2].trim() : ''
        };
      });

      const sortedData = [...allData].sort((a, b) => {
        if (a.lv1 !== b.lv1) return this.getSortWeight(a.lv1) - this.getSortWeight(b.lv1);
        return a.lv2.localeCompare(b.lv2, "zh");
      });

      let currentLv1 = "";
      let currentLv2 = "";
      const result = [];
      let lv1Group = null;

      sortedData.forEach(row => {
        const lv1 = row.lv1;
        const lv2 = row.lv2;
        const lv3 = row.lv3;

        if (lv1 !== currentLv1) {
          const rowSpan = sortedData.filter(r => r.lv1 === lv1).length;
          lv1Group = { lv1, rowSpan, rows: [] };
          result.push(lv1Group);
          currentLv1 = lv1;
          currentLv2 = "";
        }

        const showLv2 = lv2 !== currentLv2;
        let lv2RowSpan = 0;
        if (showLv2) {
          lv2RowSpan = sortedData.filter(r => r.lv1 === lv1 && r.lv2 === lv2).length;
          currentLv2 = lv2;
        }

        lv1Group.rows.push({ lv2, lv3, showLv1: lv1Group.rows.length === 0, showLv2, lv2RowSpan });
      });

      this.allSoundData = result;
      this.$nextTick(() => { this.updateStatus(); });
    },
    updateStatus() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const anchors = container.querySelectorAll('.scroll-anchor');
      const containerTop = container.getBoundingClientRect().top;
      let activeName = "人声";

      for (let i = 0; i < anchors.length; i++) {
        const rect = anchors[i].getBoundingClientRect();
        if (rect.top <= containerTop + 50) {
          activeName = anchors[i].getAttribute('data-name');
        } else {
          break;
        }
      }

      const info = this.soundCategoryData[activeName];
      if (info) {
        this.statusText = `当前展示 一级类目<strong>"${activeName}"</strong> ｜包含 <strong>${info.lv2}</strong> 个二级分类｜包含 <strong>${info.lv3}</strong> 个三级分类`;
      }
    },
    expandFeishuQR() {
      this.showFeishuPreview = true;
    },
    closeFeishuPreview() {
      this.showFeishuPreview = false;
    },
    initSidebarEvents() {
      // 添加点击状态变量
      this.feishuTooltipVisible = false;
      this.emailTooltipVisible = false;

      // 飞书按钮 - 展示图片
      const feishuBtn = document.getElementById('feishu-btn');
      if (feishuBtn) {
        const tooltip = document.createElement('div');
        tooltip.className = 'fixed-tooltip';
        tooltip.style.cssText = 'position: absolute; right: 82px; top: 50%; transform: translateY(-50%); background: #ffffff; border-radius: 12px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15); z-index: 1000000; padding: 20px; display: none;';

        // 使用require获取图片路径
        const imgUrl = require('./assets/img/tongna.png');

        tooltip.innerHTML = `
          <div style="width: 200px; height: 200px; display: flex; align-items: center; justify-content: center; background: #f8fafc; border-radius: 8px; overflow: hidden;">
            <img src="${imgUrl}" alt="飞书二维码" style="width: 100%; height: 100%; object-fit: contain;">
          </div>
        `;
        feishuBtn.appendChild(tooltip);

        // 悬停显示（仅在未固定显示时）
        feishuBtn.addEventListener('mouseenter', () => {
          if (!this.feishuTooltipVisible && !this.emailTooltipVisible) {
            tooltip.style.display = 'block';
          }
        });
        feishuBtn.addEventListener('mouseleave', () => {
          if (!this.feishuTooltipVisible) {
            tooltip.style.display = 'none';
          }
        });

        // 点击固定显示/隐藏
        feishuBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();

          // 切换飞书显示状态
          this.feishuTooltipVisible = !this.feishuTooltipVisible;

          if (this.feishuTooltipVisible) {
            // 显示飞书，隐藏邮箱
            tooltip.style.display = 'block';
            this.emailTooltipVisible = false;
            const emailTooltip = document.querySelector('#email-btn .fixed-tooltip');
            if (emailTooltip) {
              emailTooltip.style.display = 'none';
            }
          } else {
            // 隐藏飞书
            tooltip.style.display = 'none';
          }
        });
      }

      // 邮箱按钮 - 展示邮箱地址文本
      const emailBtn = document.getElementById('email-btn');
      if (emailBtn) {
        const tooltip = document.createElement('div');
        tooltip.className = 'fixed-tooltip';
        tooltip.style.cssText = 'position: absolute; right: 82px; top: 50%; transform: translateY(-50%); background: #ffffff; border-radius: 12px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15); z-index: 1000000; padding: 20px; display: none; cursor: pointer;';
        tooltip.innerHTML = `
          <div style="width: 200px; text-align: center;">
            <div style="font-size: 12px; color: #94a3b8; margin-bottom: 8px;">联系我们</div>
            <div style="font-size: 15px; color: #0f172a; font-weight: 600; word-break: break-all;">
              szzx@tvzone.cn
            </div>
          </div>
        `;
        emailBtn.appendChild(tooltip);

        // 悬停显示（仅在未固定显示时）
        emailBtn.addEventListener('mouseenter', () => {
          if (!this.emailTooltipVisible && !this.feishuTooltipVisible) {
            tooltip.style.display = 'block';
          }
        });
        emailBtn.addEventListener('mouseleave', () => {
          if (!this.emailTooltipVisible) {
            tooltip.style.display = 'none';
          }
        });

        // 点击固定显示/隐藏并复制
        emailBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();

          // 切换邮箱显示状态
          this.emailTooltipVisible = !this.emailTooltipVisible;

          if (this.emailTooltipVisible) {
            // 显示邮箱，隐藏飞书
            tooltip.style.display = 'block';
            this.feishuTooltipVisible = false;
            const feishuTooltip = document.querySelector('#feishu-btn .fixed-tooltip');
            if (feishuTooltip) {
              feishuTooltip.style.display = 'none';
            }
            // 复制邮箱地址
            this.copyEmailToClipboard();
          } else {
            // 隐藏邮箱
            tooltip.style.display = 'none';
          }
        });
      }

      // 点击页面其他地方关闭所有tooltip
      document.addEventListener('click', () => {
        this.feishuTooltipVisible = false;
        this.emailTooltipVisible = false;
        const allTooltips = document.querySelectorAll('.fixed-tooltip');
        allTooltips.forEach(t => t.style.display = 'none');
      });
    },

    copyEmailToClipboard() {
      const email = 'szzx@tvzone.cn';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(() => {
          console.log('邮箱地址已复制到剪贴板');
          this.showCopySuccess('邮箱地址已复制');
        }).catch(err => {
          console.error('复制失败:', err);
          this.showCopySuccess('复制失败，请手动复制', true);
        });
      } else {
        // 兼容旧版浏览器的复制方法
        const textArea = document.createElement('textarea');
        textArea.value = email;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          console.log('邮箱地址已复制到剪贴板');
          this.showCopySuccess('邮箱地址已复制');
        } catch (err) {
          console.error('复制失败:', err);
          this.showCopySuccess('复制失败，请手动复制', true);
        }
        document.body.removeChild(textArea);
      }
    },

    handleFeishuEnter() {

      console.log('飞书鼠标进入');
      this.showFeishuTip = true;
      this.$forceUpdate();
    },
    // ========== 轮播图方法 ==========
    nextCarousel(n) {
      const key = 'carouselIndex' + n;
      const imgKey = 'carouselImages' + n;
      this[key] = (this[key] + 1) % this[imgKey].length;
    },
    prevCarousel(n) {
      const key = 'carouselIndex' + n;
      const imgKey = 'carouselImages' + n;
      this[key] = (this[key] - 1 + this[imgKey].length) % this[imgKey].length;
    },
    goToCarousel(n, index) {
      this['carouselIndex' + n] = index;
    },
    startAutoPlay(n) {
      this.stopAutoPlay(n);
      const timerKey = 'carouselTimer' + n;
      this[timerKey] = setInterval(() => {
        this.nextCarousel(n);
      }, 3000);
    },
    stopAutoPlay(n) {
      const timerKey = 'carouselTimer' + n;
      if (this[timerKey]) {
        clearInterval(this[timerKey]);
        this[timerKey] = null;
      }
    },

    openContactModal() {
      this.showContactModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeContactModal() {
      this.showContactModal = false;
      document.body.style.overflow = '';
    },

    submitContactForm() {
      const formData = {
        name: this.contactForm.name,
        gender: this.contactForm.gender,
        phone: this.contactForm.phone,
        company: this.contactForm.company,
        email: this.contactForm.email,
        position: this.contactForm.position,
        message: this.contactForm.message
      };

      const apiUrl = process.env.VUE_APP_API_BASE_URL;

      console.log('提交API地址:', apiUrl);
      console.log('提交数据:', formData);

      if (!apiUrl) {
        console.error('错误：未配置 VUE_APP_API_BASE_URL');
        this.showSuccessMessage('系统配置错误，请联系管理员');
        return;
      }

      fetch(`${apiUrl}/auto-annotate/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
          .then(response => response.json())
          .then(data => {
            this.closeContactModal();
            if (data.code === 10000) {
              this.showSuccessMessage('提交成功！我们会尽快与您联系。');
              this.contactForm = {
                name: '',
                gender: '',
                phone: '',
                company: '',
                email: '',
                position: '',
                message: ''
              };
            } else {
              this.showSuccessMessage(data.message || '提交失败，请重试', true);
            }
          })
          .catch(error => {
            console.error('提交失败:', error);
            this.closeContactModal();
            this.showSuccessMessage('提交失败，请检查网络连接后重试', true);
          });
    },
    showSuccessMessage(message, isError = false) {
      const messageDiv = document.createElement('div');
      messageDiv.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        padding: 12px 24px;
        background: ${isError ? '#0279FF' : '#10b981'};
        color: white;
        border-radius: 8px;
        font-size: 16px;
        z-index: 99999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideDown 0.3s ease;
      `;
      messageDiv.textContent = message;
      document.body.appendChild(messageDiv);

      setTimeout(() => {
        messageDiv.style.animation = 'slideUp 0.3s ease';
        setTimeout(() => {
          document.body.removeChild(messageDiv);
        }, 300);
      }, 2000);
    },

    consultSales() {
      this.openContactModal();
    },

    switchLanguage() {
      // 跳转到英文版本页面
      window.location.href = 'http://szzx.sjj.tvzone.cn/audio-viewData-en/index/';
    },

    handleScroll() {
      const scrollY = window.scrollY;

      // 导航栏固定逻辑 - 滚动超过0px就固定
      if (scrollY > 0) {
        this.isNavbarFixed = true;
      } else {
        this.isNavbarFixed = false;
      }

      // 滚动超过100px时添加阴影效果
      if (scrollY > 100) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }

      // 根据滚动位置高亮当前导航项
      this.updateActiveNav();
    },

    updateActiveNav() {
      const sections = ['home', 'overview', 'annotation', 'structure', 'contact'];
      const scrollPosition = window.scrollY + 150; // 偏移量

      sections.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          const offsetTop = element.offsetTop;
          const height = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            // 可以在这里添加激活状态的逻辑
            const navItem = document.querySelector(`a[href="#${id}"]`);
            if (navItem) {
              document.querySelectorAll('.navbar-item').forEach(item => item.classList.remove('active'));
              navItem.classList.add('active');
            }
          }
        }
      });
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80; // 导航栏高度
        const elementPosition = element.offsetTop - offset;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    },

    playIntroVideo() {
      this.scrollToSection('video-intro');
      setTimeout(() => {
        this.playVideo();
      }, 500);
    },

    // 视频播放控制方法
    playVideo() {
      this.$nextTick(() => {
        const video = this.$refs.introVideo;
        if (video) {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.isPlaying = true;
              this.showControls = true;
            }).catch(error => {
              console.log('视频播放被阻止:', error);
              // 如果自动播放被阻止，只显示控制栏
              this.showControls = true;
            });
          }
        }
      });
    },

    togglePlayPause() {
      const video = this.$refs.introVideo;
      if (!video) return;

      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
      this.showControls = true;
    },

    toggleMute() {
      const video = this.$refs.introVideo;
      if (!video) return;

      this.isMuted = !this.isMuted;
      video.muted = this.isMuted;
    },

    toggleFullscreen() {
      const video = this.$refs.introVideo;
      const container = video?.parentElement;
      if (!container) return;

      if (!document.fullscreenElement) {
        container.requestFullscreen().catch(err => {
          console.log('无法进入全屏模式:', err);
        });
      } else {
        document.exitFullscreen();
      }
    },

    seekVideo(event) {
      const video = this.$refs.introVideo;
      if (!video) return;

      const progressBar = event.currentTarget;
      const clickX = event.offsetX;
      const width = progressBar.offsetWidth;
      const percentage = clickX / width;

      video.currentTime = percentage * video.duration;
    },

    onVideoLoaded(videoType) {
      // 处理相机视频加载完成事件
      if (videoType && typeof videoType === 'string') {
        if (Object.prototype.hasOwnProperty.call(this.videoLoaded, videoType)) {
          this.videoLoaded[videoType] = true;
        }
        return;
      }

      // 处理介绍视频加载完成事件（兼容原有逻辑）
      const video = this.$refs.introVideo;
      if (!video) return;

      this.duration = this.formatTime(video.duration);
    },

    onTimeUpdate() {
      const video = this.$refs.introVideo;
      if (!video) return;

      this.currentTime = this.formatTime(video.currentTime);
      this.progressPercentage = (video.currentTime / video.duration) * 100;
    },

    onVideoEnded() {
      this.isPlaying = false;
      this.progressPercentage = 0;
    },

    formatTime(seconds) {
      if (isNaN(seconds)) return '0:00';

      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },

    goToMoreDetails() {
      // 跳转到详细页面并滚动到场景与动作详情
      this.$router.push('/details');
      setTimeout(() => {
        const sceneElement = document.getElementById('scene-action');
        if (sceneElement) {
          const offset = 80;
          const elementPosition = sceneElement.offsetTop - offset;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    },

    goToOneAct() {
      this.$router.push('/details').then(() => {
        setTimeout(() => {
          const element = document.getElementById('solo-action');
          if (element) {
            const offset = 80;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      });
    },
    goToTwoAct() {
      this.$router.push('/details').then(() => {
        setTimeout(() => {
          const element = document.getElementById('two-interaction');
          if (element) {
            const offset = 80;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      });
    },
    goToaudioAct() {
      this.$router.push('/details').then(() => {
        setTimeout(() => {
          const element = document.getElementById('audio-person');
          if (element) {
            const offset = 80;
            const elementPosition = element.offsetTop - offset;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      });
    },

    // 初始化视频滚动播放观察器 - 实现视频预加载和滚动播放
    initVideoScrollObserver() {
      this.$nextTick(() => {
        const video = this.$refs.introVideo;
        if (!video) return;

        // 预加载视频
        video.preload = 'auto';
        video.load();

        // 方法1: 使用 IntersectionObserver (现代浏览器)
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                // 视频进入视口，尝试自动播放
                this.autoPlayIntroVideo();
              } else {
                // 视频离开视口，暂停播放
                if (!video.paused) {
                  video.pause();
                  this.isPlaying = false;
                }
              }
            });
          }, {
            threshold: 0.5, // 视频50%可见时触发
            rootMargin: '0px'
          });

          observer.observe(video);
          this.videoObserver = observer;
        } else {
          // 方法2: 使用滚动事件监听 (兼容性方案)
          this.handleIntroVideoScroll();
        }

        // 视频加载完成事件
        const onLoadedData = () => {
          console.log('视频预加载完成');
        };
        video.addEventListener('loadeddata', onLoadedData);
        // 保存引用以便清理
        this.videoLoadedDataHandler = onLoadedData;
      });
    },

    // 滚动事件处理 - 用于兼容不支持 IntersectionObserver 的浏览器
    handleIntroVideoScroll() {
      const video = this.$refs.introVideo;
      if (!video) return;

      const checkVideoVisibility = () => {
        const rect = video.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        // 计算视频在视口中的可见比例
        const visibleTop = Math.max(0, rect.top);
        const visibleBottom = Math.min(viewportHeight, rect.bottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visiblePercentage = (visibleHeight / Math.min(rect.height, viewportHeight)) * 100;

        // 如果视频50%以上可见，尝试播放
        if (visiblePercentage > 50) {
          this.autoPlayIntroVideo();
        } else {
          // 如果可见度低于50%，暂停播放
          if (!video.paused) {
            video.pause();
            this.isPlaying = false;
          }
        }
      };

      // 绑定滚动事件
      window.addEventListener('scroll', checkVideoVisibility, { passive: true });
      this.videoScrollHandler = checkVideoVisibility;

      // 初始检查
      checkVideoVisibility();
    },

    // 自动播放介绍视频 - 处理浏览器自动播放策略
    autoPlayIntroVideo() {
      const video = this.$refs.introVideo;
      if (!video || video.paused === false) return;

      // 设置静音以提高自动播放成功率
      if (!this.isMuted) {
        video.muted = true;
        this.isMuted = true;
      }

      // 尝试播放
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.then(() => {
          // 播放成功
          this.isPlaying = true;
          this.showControls = true;
          console.log('视频自动播放成功');
          // 移除视觉提示
          this.removePlayHint();
        }).catch(error => {
          // 播放失败，可能是浏览器策略限制
          console.log('视频自动播放被阻止:', error);
          // 显示控制栏，让用户手动播放
          this.showControls = true;
          // 移除静音状态
          video.muted = false;
          this.isMuted = false;
          // 添加视觉提示
          this.addPlayHint();
        });
      }
    },

    // 添加播放提示按钮
    addPlayHint() {
      this.$nextTick(() => {
        const video = this.$refs.introVideo;
        if (!video) return;

        const container = video.parentElement;
        if (!container || container.querySelector('.video-play-hint')) return;

        // 创建播放按钮提示
        const hint = document.createElement('div');
        hint.className = 'video-play-hint';
        hint.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
          background: rgba(220, 38, 38, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 30px;
          cursor: pointer;
          z-index: 10;
          box-shadow: 0 10px 25px rgba(0,0,0,0.3);
          transition: transform 0.2s ease;
        `;
        hint.innerHTML = '▶';
        hint.onmouseenter = () => hint.style.transform = 'translate(-50%, -50%) scale(1.1)';
        hint.onmouseleave = () => hint.style.transform = 'translate(-50%, -50%) scale(1)';
        hint.onclick = () => {
          video.play().then(() => {
            hint.remove();
            this.isPlaying = true;
            this.showControls = true;
          });
        };
        container.style.position = 'relative';
        container.appendChild(hint);
      });
    },

    // 移除播放提示
    removePlayHint() {
      const video = this.$refs.introVideo;
      if (!video) return;

      const container = video.parentElement;
      if (container) {
        const hint = container.querySelector('.video-play-hint');
        if (hint) hint.remove();
      }
    },

    // 下载完整文档说明
    downloadDocument() {
      // 构建文件路径（相对于当前组件的路径）
      const filePath = './assets/dataset_structure_preview.txt';

      // 创建下载链接
      const link = document.createElement('a');
      link.href = filePath;
      link.download = 'dataset_structure_preview.txt';

      // 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 初始化 Plotly 图表
    initPlotlyChart() {
      this.$nextTick(() => {
        if (!window.Plotly) {
          console.warn('Plotly not loaded yet');
          return;
        }

        const container = document.getElementById('plotly-action-viz');
        if (!container) {
          console.warn('Plotly container not found');
          return;
        }

        // 构建图表数据
        const data = [{
          type: "sunburst",
          branchvalues: this.plotlyData.branchvalues,
          ids: this.plotlyData.ids,
          labels: this.plotlyData.labels,
          parents: this.plotlyData.parents,
          values: this.plotlyData.values,
          customdata: this.plotlyData.customdata,
          marker: this.plotlyData.marker,
          hovertemplate: "labels=%{label}<br>Hours=%{value}<br>parent=%{parent}<br>id=%{id}<br>Scene=%{customdata[0]}<extra></extra>",
          name: ""
        }];

        // 构建布局配置
        const layout = {
          margin: { t: 20, l: 0, r: 0, b: 0 },
          font: {
            family: "'Noto Sans SC', sans-serif",
            size: 12
          },
          template: {
            data: {
              histogram2dcontour: [{ type: "histogram2dcontour", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}],
              choropleth: [{ type: "choropleth", colorbar: { outlinewidth: 0, ticks: "" } }],
              histogram2d: [{ type: "histogram2d", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}],
              heatmap: [{ type: "heatmap", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}],
              heatmapgl: [{ type: "heatmapgl", colorbar: { outlinewidth: 0, ticks: "" }, colorscale: [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}]
            }
          },
          showlegend: false,
          paper_bgcolor: 'rgba(0,0,0,0)',
          plot_bgcolor: 'rgba(0,0,0,0)'
        };

        const config = {
          responsive: true,
          displayModeBar: true,
          modeBarButtonsToAdd: ['hoverclosest', 'hovercompare'],
          displaylogo: false
        };

        // 初始化图表
        window.Plotly.newPlot('plotly-action-viz', data, layout, config);
      });
    },

    // 打开全屏饼图页面
    openFullscreenChart() {
      // 直接打开新窗口，不传递数据（数据已嵌入到 ChartFullscreen 组件中）
      // 这样可以避免 431 Request Header Fields Too Large 错误
      const routeData = this.$router.resolve({
        path: '/chart-fullscreen'
      });

      window.open(routeData.href, '_blank');
    },

    initVideo() {
      // 处理视频自动播放 - 超强增强版
      this.$nextTick(() => {
        const video = this.$refs.heroVideo;
        if (!video) {
          console.log('Hero视频元素未找到');
          return;
        }

        console.log('Hero视频初始化，readyState:', video.readyState, 'paused:', video.paused);

        // 强制静音（关键：浏览器策略要求）
        video.muted = true;
        video.setAttribute('muted', 'muted');

        // 预加载策略
        video.preload = 'auto';

        // 监听视频加载事件
        video.addEventListener('loadeddata', () => {
          console.log('Hero视频数据加载完成，readyState:', video.readyState);
          this.forceHeroVideoPlay();
        });

        video.addEventListener('canplay', () => {
          console.log('Hero视频可播放，readyState:', video.readyState);
          this.forceHeroVideoPlay();
        });

        // 尝试直接加载
        try {
          video.load();
        } catch (e) {
          console.log('视频load()调用异常:', e);
        }

        // 强制播放尝试 - 多次尝试
        this.forceHeroVideoPlay();

        // 延迟二次尝试（应对异步加载）
        setTimeout(() => {
          this.forceHeroVideoPlay();
        }, 500);

        // 三次尝试（应对复杂网络环境）
        setTimeout(() => {
          this.forceHeroVideoPlay();
        }, 1500);
      });
    },

    // 强制播放Hero视频
    forceHeroVideoPlay() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      console.log('强制播放尝试 - readyState:', video.readyState, 'paused:', video.paused);

      // 如果已经在播放，跳过
      if (!video.paused) {
        console.log('Hero视频已在播放');
        return;
      }

      // 确保静音
      if (!video.muted) {
        video.muted = true;
        video.setAttribute('muted', 'muted');
      }

      // 尝试播放
      const playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => {
          console.log('Hero视频播放成功！');
          this.removeHeroPlayHint();
        }).catch(error => {
          console.log('Hero视频播放失败:', error.name, error.message);
          // 播放失败时添加提示
          this.addHeroPlayHint();
        });
      } else {
        // play() 返回非promise，可能已经成功
        if (!video.paused) {
          console.log('Hero视频已开始播放（非promise返回）');
          this.removeHeroPlayHint();
        } else {
          console.log('Hero视频play()返回异常值');
          this.addHeroPlayHint();
        }
      }
    },

    // 尝试自动播放视频（保留兼容）
    attemptAutoPlay() {
      this.forceHeroVideoPlay();
    },

    // 添加主视频播放提示
    addHeroPlayHint() {
      this.$nextTick(() => {
        const video = this.$refs.heroVideo;
        if (!video) return;

        // 方案A: 添加全局点击事件监听（任何点击都触发播放）
        const enableVideoPlayback = () => {
          if (video.paused) {
            video.play().then(() => {
              console.log('点击触发播放成功');
              // 播放成功后移除监听器
              document.removeEventListener('click', enableVideoPlayback);
              document.removeEventListener('touchstart', enableVideoPlayback);
              // 移除视觉提示
              this.removeHeroPlayHint();
            }).catch(err => {
              console.log('点击播放仍然失败:', err);
            });
          }
        };

        // 同时监听点击和触摸事件（支持移动端）
        document.addEventListener('click', enableVideoPlayback, { once: false });
        document.addEventListener('touchstart', enableVideoPlayback, { once: false });

        // 创建播放提示覆盖层
        const overlay = document.createElement('div');
        overlay.innerHTML = `
          <div style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;z-index:3;cursor:pointer;">
            <div style="background:rgba(220,38,38,0.9);color:white;width:80px;height:80px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:30px;box-shadow:0 10px 25px rgba(0,0,0,0.3);">
              ▶
            </div>
          </div>
        `;
        overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;';

        // 找到视频容器并添加覆盖层
        const container = video.parentElement;
        if (container && !container.querySelector('.video-play-hint')) {
          overlay.className = 'video-play-hint';
          overlay.style.pointerEvents = 'auto';
          overlay.style.cursor = 'pointer';
          overlay.onclick = () => {
            video.play().then(() => {
              overlay.remove();
              // 移除全局监听器
              document.removeEventListener('click', enableVideoPlayback);
              document.removeEventListener('touchstart', enableVideoPlayback);
            });
          };
          container.appendChild(overlay);
        }
      });
    },

    // 移除主视频播放提示
    removeHeroPlayHint() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      const container = video.parentElement;
      if (container) {
        const hint = container.querySelector('.video-play-hint');
        if (hint) hint.remove();
      }
    },

    // 音频播放控制
    togglePlay(index) {
      const audios = [
        this.$refs.audio0, this.$refs.audio1, this.$refs.audio2,
        this.$refs.audio3, this.$refs.audio4, this.$refs.audio5,
        this.$refs.audio6, this.$refs.audio7, this.$refs.audio8,
        this.$refs.audio9, this.$refs.audio10, this.$refs.audio11
      ];
      const currentAudio = audios[index];

      if (!currentAudio) {
        console.error(`Audio element ${index} not found`);
        return;
      }

      if (this.currentPlaying === index) {
        currentAudio.pause();
        this.currentPlaying = -1;
      } else {
        // 暂停其他正在播放的音频
        if (this.currentPlaying !== -1) {
          const prevAudio = audios[this.currentPlaying];
          if (prevAudio) prevAudio.pause();
        }

        // 使用 Promise 处理播放
        const playPromise = currentAudio.play();

        if (playPromise !== undefined) {
          playPromise.then(() => {
            this.currentPlaying = index;
            console.log(`Audio ${index} playing successfully`);
          }).catch(error => {
            console.error(`Audio ${index} play failed:`, error);
            this.currentPlaying = -1;
          });
        } else {
          this.currentPlaying = index;
        }
      }
    },

    loadAudio(index) {
      const audios = [
        this.$refs.audio0, this.$refs.audio1, this.$refs.audio2,
        this.$refs.audio3, this.$refs.audio4, this.$refs.audio5,
        this.$refs.audio6, this.$refs.audio7, this.$refs.audio8,
        this.$refs.audio9, this.$refs.audio10, this.$refs.audio11
      ];
      this.audioDuration[index] = audios[index].duration;
    },

    updateProgress(index) {
      const audios = [
        this.$refs.audio0, this.$refs.audio1, this.$refs.audio2,
        this.$refs.audio3, this.$refs.audio4, this.$refs.audio5,
        this.$refs.audio6, this.$refs.audio7, this.$refs.audio8,
        this.$refs.audio9, this.$refs.audio10, this.$refs.audio11
      ];
      const audio = audios[index];
      if (audio.duration) {
        this.$set(this.audioProgress, index, (audio.currentTime / audio.duration) * 100);
        this.$set(this.audioCurrentTime, index, audio.currentTime);
      }
    },

    seekAudio(event, index) {
      const audios = [
        this.$refs.audio0, this.$refs.audio1, this.$refs.audio2,
        this.$refs.audio3, this.$refs.audio4, this.$refs.audio5,
        this.$refs.audio6, this.$refs.audio7, this.$refs.audio8,
        this.$refs.audio9, this.$refs.audio10, this.$refs.audio11
      ];
      const audio = audios[index];
      const rect = event.currentTarget.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const percent = clickX / rect.width;
      audio.currentTime = percent * audio.duration;
    },

    audioEnded(index) {
      this.currentPlaying = -1;
      this.$set(this.audioProgress, index, 0);
      this.$set(this.audioCurrentTime, index, 0);
    },

    formatAudioTime(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
  },
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #030A19;
}

/* 导航栏样式 */
.navbar {
  background: rgba(15, 23, 42, 0.95);
  border-bottom: 1px solid rgba(51, 65, 85, 1);
  transition: all 0.3s ease;
  z-index: 1000;
}

.navbar.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.navbar.navbar-scrolled {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  background: rgba(15, 23, 42, 0.98);
}

.navbar-content {
  max-width: 1520px;
  margin: 0 auto;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.navbar-logo {
  width: 47px;
  height: 19px;
}

.navbar-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Noto Sans SC', sans-serif;
  white-space: nowrap;
}

.navbar-menu {
  display: flex;
  gap: 40px;
  align-items: center;
}

.navbar-item {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Noto Sans SC', sans-serif;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.navbar-item:hover,
.navbar-item.active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* 页面内容区域 */
.page-content {
  margin-top: 0;
}

.section {
  width: 100%;
  padding: 80px 20px;
  position: relative;
}

.section-header {
  text-align: center;
  margin-bottom: 10px;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  font-family: 'Noto Sans SC', sans-serif;
}

.action-str-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.section-title-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.section-icon {
  width: 8px;
  height: 33px;
}

.badge {
  background: rgba(219, 234, 254, 1);
  color: rgba(37, 99, 235, 1);
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 700;
}

.section-subtitle {
  color: #64748b;
  font-size: 16px;
}

/* 首页区域 */
.hero-section {
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
  position: relative;
  overflow: hidden;
}

/* 视频背景 */
.hero-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* 视频覆盖层 - 增强文字可读性 */
/*.hero-overlay {*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  background: linear-gradient(135deg, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%);*/
/*  z-index: 1;*/
/*}*/

/* 如果视频加载失败，显示备用背景 */
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  z-index: -1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
}

.hero-title {
  font-size: 53px;
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: -1.5px;
}

.hero-title-prefix {
  font-size: 0.6em;
  font-weight: 520;
  margin-right: 8px;
}

.hero-subtitle {
  font-size: 20px;
  color: #cbd5e1;
  margin-bottom: 40px;
  font-weight: 400;
  line-height: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 新增:胶囊标签样式 */
.hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 40px;
  justify-content: center;
}

.hero-tag {
  display: inline-block;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  white-space: nowrap;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.hero-tag:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.hero-subtitle .stat-line {
  display: block;
  color: #cbd5e1;
  letter-spacing: 0.3px;
}

.hero-subtitle strong {
  color: #ffffff;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.hero-subtitle .feature-tagline {
  display: inline-block;
  font-size: 1.1em;
  font-weight: 700;
  color: #ffffff;
  /* padding: 10px 20px; */
  border-radius: 8px;
  margin-top: 8px;
  letter-spacing: 0.5px;
}

/* 底部重点标语样式优化 */
.hero-subtitle.bottom {
  margin-top: 24px;
  margin-bottom: 0;
  gap: 0;
  width: 100%;
  text-align: center;
}

.hero-subtitle.bottom .feature-tagline {
  font-family: 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
  line-height: 1.6;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 9999px;
  backdrop-filter: blur(4px);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  display: inline-block;
  margin-top: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  text-align: center;
}

.hero-subtitle.bottom .feature-tagline:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.hero-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 16px 24px;
  border-radius: 9999px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  text-decoration: none;
}

.btn-primary {
  background: #0279FF;
  color: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  background: #0279FF;
  transform: translateY(-2px);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.2);
}

.btn-outline {
  background: white;
  color: #0f172a;
}

.btn-outline:hover {
  background: #f1f5f9;
  transform: translateY(-2px);
}

.scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.5);
  font-size: 24px;
  cursor: pointer;
  animation: bounce 2s infinite;
  z-index: 2;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
  40% { transform: translateX(-50%) translateY(-10px); }
  60% { transform: translateX(-50%) translateY(-5px); }
}

/* 项目简介 */
.overview-section {
  /* 基础保留样式 */
  padding: 60px 0;
  min-height: auto;
  /* 核心：整体水平居中 + 深色背景盒子 */
  width: 90%;
  max-width: 1200px;
  margin: 0 auto !important;
  background: rgba(0, 10, 41, 0.85);
  border-radius: 12px;
  padding: 40px 50px;
  box-sizing: border-box;
  color: #fff;
}

.data-details-section {
  background: #030A19;
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 1px;
}

.overview-content {
  max-width: 864px;
  margin: 0 auto;
}

/* 移动端移除overview-content的宽度限制，让feature-cards可以占满屏幕 */
@media screen and (max-width: 768px) {
  .overview-content {
    max-width: 100%;
    width: 100%;
  }
}

.overview-description {
  font-size: 18px;
  line-height: 29px;
  color: #475569;
  text-align: center;
  margin-bottom: 48px;
}

.feature-cards {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

.feature-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 32px 24px;
  width: 267px;
  text-align: center;
  transition: transform 0.2s ease;
}

.feature-card:hover {
  transform: translateY(-4px);
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: rgba(59, 130, 246, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
}

.feature-card h3 {
  font-size: 16px;
  color: #334155;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 14px;
  color: #64748b;
}

/* 移动端竖屏适配 - 强制3个卡片同行显示 */
@media screen and (max-width: 768px) {
  /* 重置所有父级容器的宽度限制 */
  .overview-section {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 40px 0 !important;
  }

  .overview-content {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* feature-cards 容器 - 强制3个同行 */
  .feature-cards {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 8px !important;
    padding: 0 8px !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: visible !important;
    justify-content: space-between !important;
    box-sizing: border-box !important;
  }

  /* 隐藏滚动条但保持功能 */
  .feature-cards::-webkit-scrollbar {
    display: none !important;
  }

  .feature-cards {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  /* 每个卡片 - 占据1/3宽度 */
  .feature-card {
    flex: 1 1 33.333% !important;
    min-width: 0 !important;
    max-width: 33.333% !important;
    width: 33.333% !important;
    padding: 12px 6px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    flex-shrink: 0 !important;
  }

  .feature-icon {
    width: 28px !important;
    height: 28px !important;
    margin: 0 auto 8px !important;
    font-size: 14px !important;
  }

  .feature-card h3 {
    font-size: 12px !important;
    margin-bottom: 4px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .feature-card p {
    font-size: 10px !important;
    line-height: 1.2 !important;
    display: none !important;
  }
}

/* 小屏竖屏适配 - 保持3个同行 */
@media screen and (max-width: 430px) {
  .feature-cards {
    gap: 6px !important;
    padding: 0 6px !important;
  }

  .feature-card {
    flex: 1 1 33.333% !important;
    width: 33.333% !important;
    max-width: 33.333% !important;
    min-width: 0 !important;
    padding: 10px 4px !important;
  }

  .feature-icon {
    width: 24px !important;
    height: 24px !important;
    margin: 0 auto 6px !important;
    font-size: 12px !important;
  }

  .feature-card h3 {
    font-size: 11px !important;
  }

  .feature-card p {
    display: none !important;
  }
}

/* 超小屏适配 - 保持3个同行 */
@media screen and (max-width: 375px) {
  .feature-cards {
    gap: 4px !important;
    padding: 0 4px !important;
  }

  .feature-card {
    flex: 1 1 33.333% !important;
    width: 33.333% !important;
    max-width: 33.333% !important;
    min-width: 0 !important;
    padding: 8px 3px !important;
  }

  .feature-icon {
    width: 20px !important;
    height: 20px !important;
    margin: 0 auto 4px !important;
    font-size: 10px !important;
  }

  .feature-card h3 {
    font-size: 10px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .feature-card p {
    display: none !important;
  }
}

/* 视频介绍 */
.video-section {
  background: #030A19;
  max-width: 1400px;
  margin: 0 auto;
}

.video-player {
  max-width: 992px;
  margin: 0 auto;
}

.video-container {
  background: rgba(15, 23, 42, 0.5);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  height: 558px;
  /*display: flex;*/
  /*flex-direction: column;*/
}

/* 视频元素 */
.intro-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

/* 视频覆盖层 - 播放按钮 */
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%);
  z-index: 2;
}

.play-button {
  width: 80px;
  height: 80px;
  border-radius: 9999px;
  background: #dc2626;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-button:hover {
  transform: scale(1.1);
}

/* 视频控制栏 */
.video-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, rgba(0,0,0,0.8) 0, rgba(0,0,0,0) 100%);
  padding: 20px;
  z-index: 3;
  transition: opacity 0.3s ease;
}

/* Logo标签 */
.logo-tag {
  display: inline-block;
  background: rgba(220, 38, 38, 0.9);
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Noto Sans SC', sans-serif;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

/* 进度条 */
.progress-bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  margin-bottom: 12px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.progress-bar:hover {
  height: 6px;
}

.progress-fill {
  height: 100%;
  background: #dc2626;
  width: 0%;
  transition: width 0.1s linear;
}

/* 控制按钮区域 */
.control-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
}

.control-btn {
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.control-btn:hover {
  opacity: 0.8;
}

.control-btn .active {
  color: #dc2626;
}

.time-display {
  font-size: 12px;
  margin-left: auto;
  white-space: nowrap;
}

/* 数据概览 */
.data-overview-section {
  background: #030A19;
  max-width: 1400px;
  margin: 0 auto;
}

/* 调整section-content和comparison-table之间的间距 */
.data-overview-section .section-content {
  margin-bottom: 60px;
}

.section-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  align-items: stretch;
}

.stat-card-new {
  flex: 1 1 220px;
  min-width: 200px;
  max-width: 280px;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(51, 65, 85, 0.6);
  border-radius: 16px;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.stat-card-new:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  border-color: rgba(59, 130, 246, 0.5);
}

/* 图标容器 */
.stat-card-icon {
  width: 40px;
  height: 40px;
  background: rgba(59, 130, 246, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.stat-card-icon img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

/* 不同颜色图标 */
.stat-card-icon.icon-blue {
  background: rgba(59, 130, 246, 0.15);
}

.stat-card-icon.icon-green {
  background: rgba(16, 185, 129, 0.15);
}

.stat-card-icon.icon-red {
  background: rgba(239, 68, 68, 0.15);
}

.stat-card-icon.icon-orange {
  background: rgba(245, 158, 11, 0.15);
}

/* 标签文字 */
.stat-card-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

/* 大数字 */
.stat-card-value {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
  margin: 4px 0;
}

.stat-card-unit {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  margin-left: 2px;
}

/* 底部标签 */
.stat-card-tag {
  font-size: 12px;
  color: #60a5fa;
  background: rgba(59, 130, 246, 0.15);
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-block;
  width: fit-content;
  margin-top: auto;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

/* 响应式 */
@media (max-width: 1200px) {
  .stat-card-new {
    flex: 1 1 180px;
    min-width: 160px;
  }

  .stat-card-value {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .stat-card-new {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
  }

  .stat-card-value {
    font-size: 26px;
  }
}

@media (max-width: 480px) {
  .section-content {
    gap: 12px;
    padding: 0 8px;
  }

  .stat-card-new {
    padding: 18px 16px;
  }

  .stat-card-value {
    font-size: 24px;
  }
}

/* section-content 内部字体自适应 - 保持原有布局 */
/* 1200px - 1440px 屏幕 */
@media (max-width: 1440px) and (min-width: 1200px) {
  .section-content .stat-value {
    font-size: 20px; /* 从22px减小 */
  }
  .section-content .stat-unit {
    font-size: 9px; /* 从10px减小 */
  }
  .section-content .stat-label {
    font-size: 11px; /* 从12px减小 */
  }
  .section-content .stat-detail {
    font-size: 11px; /* 从12px减小 */
  }
}

/* 1024px - 1199px 屏幕 */
@media (max-width: 1199px) and (min-width: 1024px) {
  .section-content .stat-value {
    font-size: 18px;
  }
  .section-content .stat-unit {
    font-size: 8px;
  }
  .section-content .stat-label {
    font-size: 10px;
  }
  .section-content .stat-detail {
    font-size: 10px;
  }
}

/* 768px - 1023px 屏幕 (平板) */
@media (max-width: 1023px) and (min-width: 768px) {
  .section-content .stat-value {
    font-size: 20px;
  }
  .section-content .stat-unit {
    font-size: 9px;
  }
  .section-content .stat-label {
    font-size: 11px;
  }
  .section-content .stat-detail {
    font-size: 11px;
  }
}

/* 480px - 767px 屏幕 (手机横屏/小平板) */
@media (max-width: 767px) and (min-width: 480px) {
  .section-content .stat-value {
    font-size: 22px;
  }
  .section-content .stat-unit {
    font-size: 10px;
  }
  .section-content .stat-label {
    font-size: 12px;
  }
  .section-content .stat-detail {
    font-size: 12px;
  }
}

/* 移动端竖屏专用优化 - 针对 section-content 减少屏占比和空白 */
@media (max-width: 480px) and (orientation: portrait) {
  /* 主容器优化 */
  .data-overview-section {
    padding: 20px 0; /* 减小整体内边距 */
  }

  /* section-content 核心优化 - 减少屏占比 */
  .section-content {
    gap: 6px; /* 进一步减小间距 */
    padding: 0 4px; /* 进一步减小边距 */
    margin-bottom: 20px; /* 减小底部外边距 */
  }

  /* 统计卡片密集布局 */
  .stats-grid {
    margin-bottom: 6px; /* 卡片间更紧凑 */
  }

  .stat-card {
    min-height: 120px; /* 进一步减小高度 */
    padding: 10px; /* 进一步减小内边距 */
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 28px; /* 进一步减小 */
    height: 28px;
    font-size: 12px;
  }

  .stat-value {
    font-size: 20px; /* 进一步减小 */
  }

  .stat-unit {
    font-size: 10px;
  }

  .stat-label {
    font-size: 10px; /* 进一步减小 */
  }

  .stat-detail {
    font-size: 10px;
    padding: 1px 4px;
    margin-top: 4px;
  }

  /* 移动端竖屏：stat-value-label-wrapper 强制横向排列所有子元素 */
  .stat-value-label-wrapper {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    gap: 6px !important;
    width: 100% !important;
    overflow-x: visible !important;
    overflow-y: hidden !important;
    align-items: flex-start !important;
  }

  /* 移动端竖屏：stat-value-label 和 stat-value-label3 强制同行显示 */
  .stat-value-label,
  .stat-value-label3 {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 1 0 !important;
    min-width: 0 !important;
    max-width: none !important;
    width: auto !important;
    overflow: visible !important;
  }

  /* 移动端竖屏：stat-value-container 强制横向显示 */
  .stat-value-container {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
    align-items: baseline !important;
    gap: 2px !important;
    white-space: nowrap !important;
    overflow: visible !important;
    width: auto !important;
    margin-bottom: 1px !important;
  }

  /* 移动端竖屏：stat-label 也调整为紧凑显示 */
  .stat-label {
    display: block !important;
    width: 100% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
  }

  /* 特性盒子优化 */
  .feature-box {
    padding: 12px; /* 进一步减小 */
  }

  .box-header {
    margin-bottom: 8px;
  }

  .box-description {
    font-size: 12px;
    margin-bottom: 8px;
  }

  /* 场景概述优化 */
  .scene-overview {
    padding: 12px;
    margin-bottom: 12px;
  }

  .scene-overview-desc {
    font-size: 11px;
  }

  /* 特性卡片优化 */
  .feature-cards {
    gap: 6px;
    padding: 0 4px;
  }

  .feature-card {
    padding: 12px 8px;
  }

  .feature-icon {
    width: 32px;
    height: 32px;
    margin-bottom: 6px;
  }

  .feature-card h3 {
    font-size: 12px;
  }

  /* 高亮框优化 */
  .intro-highlight-box {
    padding: 12px;
    margin-bottom: 12px;
  }

  .highlight-item {
    padding: 10px;
  }

  .highlight-text {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .highlight-item p {
    font-size: 11px;
  }

  /* 效率部分优化 */
  .efficiency-section {
    padding: 12px;
    margin-bottom: 12px;
  }

  .efficiency-section .section-subtitle {
    font-size: 15px;
    margin-bottom: 6px;
  }

  .efficiency-description {
    font-size: 11px;
  }

  /* 动作集优化 */
  .action-set-container {
    padding: 8px;
  }

  .action-set-desc {
    font-size: 11px;
    margin-bottom: 8px;
  }

  /* Plotly 图表优化 */
  .plotly-container {
    height: 250px;
    padding: 6px;
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 200px;
  }

  /* 对比表格优化 */
  .comparison-table .table-row {
    padding: 8px 10px;
    gap: 4px;
  }

  .comparison-table .table-row.header {
    padding: 6px 10px;
  }

  .comparison-table .note-header {
    padding: 10px;
  }
}

/* 480px以下 屏幕 (手机竖屏) */
@media (max-width: 479px) {
  .section-content .stat-value {
    font-size: 24px;
  }
  .section-content .stat-unit {
    font-size: 11px;
  }
  .section-content .stat-label {
    font-size: 13px;
  }
  .section-content .stat-detail {
    font-size: 13px;
  }
}

/* 超宽屏 1920px+ */
@media (min-width: 1920px) {
  .section-content .stat-value {
    font-size: 23px;
  }
  .section-content .stat-unit {
    font-size: 11px;
  }
  .section-content .stat-label {
    font-size: 12px;
  }
  .section-content .stat-detail {
    font-size: 12px;
  }
}

/* 大屏幕布局优化 (1920px+) - 确保stat-value-label3正确显示 */
@media (min-width: 1920px) {
  .stat-value-label-wrapper {
    flex-direction: row !important;
  }
  .stat-value-label3 {
    flex: 1 1 calc(33.333% - 6px) !important;
    max-width: calc(33.333% - 6px) !important;
    min-width: 60px !important;
  }
  .stat-value-label {
    flex: 1 1 calc(50% - 6px) !important;
    max-width: calc(50% - 6px) !important;
    min-width: 80px !important;
  }
}

/* 2K 分辨率屏幕 (2048px - 3839px) - 专门适配 section-content */
@media (min-width: 2048px) and (max-width: 3839px) {
  .section-content .stat-value {
    font-size: 22px;
  }
  .section-content .stat-unit {
    font-size: 11px;
  }
  .section-content .stat-label {
    font-size: 12px;
  }
  .section-content .stat-detail {
    font-size: 12px;
  }
}

/* 4K 分辨率屏幕 (3840px+) - 专门适配 section-content */
@media (min-width: 3840px) {
  .section-content .stat-value {
    font-size: 16px;
  }
  .section-content .stat-unit {
    font-size: 8px;
  }
  .section-content .stat-label {
    font-size: 9px;
  }
  .section-content .stat-detail {
    font-size: 9px;
  }
}

.stats-grid {
  display: flex;
  flex: 1 1 220px;
  min-width: 220px;
  max-width: 280px;
  justify-content: center;
  margin-bottom: 0;
}

.stat-card {
  width: 97%;
  background: rgba(255,255,255,0.9);
  box-shadow: 0px 10px 25px -5px rgba(59,130,246,0.05), 0px 4px 10px -3px rgba(59,130,246,0.03);
  border-radius: 16px;
  border: 1px solid #FFFFFF;
  padding: 16px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0; /* 防止卡片被压缩 */
  overflow: hidden; /* 防止内容溢出 */
}

/* 为 stat-icon 和后续的 label 创建一个水平容器 */
.stat-card > .stat-icon,
.stat-card > .stat-icon2,
.stat-card > .stat-icon3,
.stat-card > .stat-icon4 {
  align-self: flex-start;
}

.stat-card::after {
  content: '';
  display: table;
  clear: both;
}

.stat-icon {
  width: 40px;
  height: 40px;
  background: #EFF6FF;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon2 {
  width: 40px;
  height: 40px;
  background: #ECFDF5;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon3 {
  width: 40px;
  height: 40px;
  background: #F5F3FF;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon4 {
  width: 40px;
  height: 40px;
  background: #FFF1F2;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 12px;
  border: 1px solid #DBEAFE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 18px;
}

.stat-icon img,
.stat-icon2 img,
.stat-icon3 img,
.stat-icon4 img {
  width: 20px;
  height: 20px;
}

/* 数据统计卡片内部样式 - 重构以解决 flex/inline-block 冲突 */

/* 统计值标签容器 - 用于包裹同行显示的 stat-value-label */
.stat-value-label-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  align-items: flex-start;
  flex-direction: row; /* 确保子元素横向排列 */
  overflow: visible; /* 防止内容被裁剪 */
}

/* 隐藏统计标签容器内的所有换行符，确保同行显示 */
.stat-value-label-wrapper br {
  display: none;
}

/* 单个统计值标签 (2个一组) - 使用flex确保同行显示 */
.stat-value-label {
  flex: 1 1 calc(50% - 4px);
  min-width: 100px;
  box-sizing: border-box;
  line-height: 1.2;
  max-width: calc(50% - 4px);
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止内容溢出 */
}

/* 单个统计值标签 (3个一组) - 使用flex确保同行显示 */
.stat-value-label3 {
  flex: 1 1 calc(33.333% - 6px);
  min-width: 60px;
  max-width: calc(33.333% - 6px);
  box-sizing: border-box;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止内容溢出 */
}

/* 统计值容器 */
.stat-value-container {
  width: 100%;
  display: flex;
  align-items: baseline;
  gap: 2px;
  margin-bottom: 2px;
  white-space: nowrap;
}

/* 统计数值 */
.stat-value {
  display: inline-block;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin-right: 2px;
  line-height: 1.1;
}

/* 统计单位 */
.stat-unit {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #94A3B8;
  line-height: 1;
  white-space: nowrap;
}

/* 统计标签 */
.stat-label {
  width: 100%;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 12px;
  color: #64748B;
  line-height: 1.2;
  text-align: left;
  font-style: normal;
  text-transform: none;
  white-space: normal;
  overflow: hidden; /* 防止文本溢出 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
}


.stat-detail {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  width: auto;
  white-space: nowrap;
  align-self: flex-start; /* 防止在flex容器中拉伸 */
  max-width: 100%; /* 确保不会超出父容器 */
  box-sizing: border-box;
}

.detail1 {
  color: #2563EB;
  background: #EFF6FF;
}

.detail2 {
  color: #059669;
  background: #ECFDF5;
}

.detail3 {
  color: #7C3AED;
  background: #F5F3FF;
}

.detail4 {
  color: #E11D48;
  background: #FFF1F2;
}

.stat-num {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.stat-name {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 12px;
}

/* 对比表格 */
.comparison-table {
  background: rgba(255,255,255,0.9);
  box-shadow: 0px 10px 25px -5px rgba(59,130,246,0.05), 0px 4px 10px -3px rgba(59,130,246,0.03);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  margin-top: 3%;
}

.comparison-table .table-header {
  background: white;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}

.comparison-table .table-header .w_first {
  display: flex;
  align-items: center;
  gap: 8px;
}

.comparison-table .table-header .w_1 {
  width: 8px;
  height: 24px;
  background: #2563EB;
  border-radius: 9999px;
  flex-shrink: 0;
}

.comparison-table .table-header .w_title {
  height: 22px;
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 20px;
  color: #1E293B;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  white-space: nowrap;
}

.comparison-table .table-content {
  overflow-x: auto;
  background: white;
}

.comparison-table .table-row {
  display: grid;
  grid-template-columns: 25% 12% 12% 15% 12% 14%;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;

  font-family: Inter, Inter;
  font-weight: normal;
  font-size: 14px;
  color: #334155;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.comparison-table .table-row > span {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.comparison-table .table-row > span:not(:first-child) {
  text-align: center;
}

.comparison-table .table-row.header {
  background: #f8fafc;
  font-weight: 600;
  color: #64748b;
  padding: 12px 24px;
}

.comparison-table .table-row.highlight {
  background: #eff6ff;
  border: 2px solid #bfdbfe;
  font-weight: 1000;
}

.comparison-table .our-text {
  color: #2563eb;
}

/* 环境字段样式 - 根据真实场景/实验室显示不同样式 */
.comparison-table .env-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  line-height: 1;
  margin: 0 auto;
}

.comparison-table .env-badge.real-world {
  width: 70px;
  height: 24px;
  background: #EEF2FF;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #E0E7FF;
  color: #4F46E5;
}

.comparison-table .env-badge.lab {
  width: 58px;
  height: 24px;
  background: #F1F5F9;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #E2E8F0;
  color: #64748B;
}

.comparison-table .legend {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: nowrap;
}

.comparison-table .legend .l_dot1 {
  width: 10px;
  height: 10px;
  background: #3B82F6;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 9999px;
  flex-shrink: 0;
}

.comparison-table .legend-item.our {
  width: 52px;
  height: 14px;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 12px;
  color: #334155;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  flex-shrink: 0;
}

.comparison-table .legend .l_dot2 {
  width: 10px;
  height: 10px;
  background: #CBD5E1;
  border-radius: 9999px;
  flex-shrink: 0;
}

.comparison-table .legend-item.other {
  width: 28px;
  height: 14px;
  font-family: Inter, Inter;
  font-weight: 500;
  font-size: 12px;
  color: #334155;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  flex-shrink: 0;
}

/* 说明框 - 作为comparison-table的子元素 */
.comparison-table .note-box {
  background: #f8fafc;
  padding: 20px;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 16px 16px;
}

.comparison-table .note-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12px;
  line-height: 1.4;
  color: #475569;
}

.comparison-table .note-footer {
  font-size: 12px;
  color: #64748b;
  padding-left: 62px;
  line-height: 1.4;
}

.comparison-table .tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}

.comparison-table .tag.our {
  background: #dbeafe;
  color: #2563eb;
}

.comparison-table .tag.fixed {
  background: #e2e8f0;
  color: #475569;
}

.comparison-table .tag.movable {
  background: #dbeafe;
  color: #2563eb;
}

/* 数据集对比表格中的镜头类型标签 */
.camera-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 3px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 1000;
  margin-left: 1px;
  border: 1px solid;
  white-space: nowrap;
  height: 18px;
  line-height: 1;
  flex-shrink: 0;
  position: relative;
  top: 0;
}

.camera-tag.fixed {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
}

.camera-tag.movable {
  background: #dbeafe;
  color: #2563eb;
  border-color: #93c5fd;
}


/* 第一列容器 - 确保内容可以正确展开 */
.comparison-table .table-row > span:first-child {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 6px !important;
  overflow: visible !important;
  white-space: nowrap;
  width: 100%;
  height: auto;
  min-height: 20px;
  text-align: left;
  font-weight: bold;
}

/* 第一列内的名称文本 */
.comparison-table .table-row > span:first-child > span:first-child {
  white-space: nowrap;
  overflow: visible;
  flex-shrink: 1;
  min-width: 0;
}

/* 第一列内的camera-tag - 确保在名称右侧正确显示 */
.comparison-table .table-row > span:first-child .camera-tag {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  white-space: nowrap !important;
  overflow: visible !important;
  flex-shrink: 0 !important;
  height: 18px !important;
  min-width: 40px !important;
  padding: 1px 4px !important;
  border-radius: 4px !important;
  font-size: 10px !important;
  font-weight: 1000 !important;
  border: 1px solid !important;
  position: relative !important;
  top: 0 !important;
  margin-left: 4px !important;
}

.comparison-table .table-row > span:first-child .camera-tag.fixed {
  background: #e2e8f0 !important;
  color: #475569 !important;
  border-color: #cbd5e1 !important;
}

.comparison-table .table-row > span:first-child .camera-tag.movable {
  background: #dbeafe !important;
  color: #2563eb !important;
  border-color: #93c5fd !important;
}

/* 特性盒子 */
.features-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

.feature-boxes {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 3%;
}

.feature-box {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
  padding: 24px;
  flex: 1;
  min-width: 0;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 1);
}

.box-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 18px;
  color: #1E293B;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;

}

.box-header h3 {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 18px;
  color: #1E293B;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.box-icon {
  width: 40px;
  height: 40px;
  background: #f0f9ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.box-description {
  font-size: 14px;
  line-height: 16px;
  color: #64748b;
  margin-bottom: 16px;
}

.box-tags {
  display: flex;
  gap: 8px;
}

.box-tags .tag {
  background: #eff6ff;
  color: #2563eb;
  padding: 4px 8px;
  font-size: 12px;
}

.tags2 .tag {
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 12px;
  color: #9333EA;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/* 分布图表 - 饼图 */
.distribution-chart {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 160px; /* 确保最小高度，防止布局塌陷 */
}

/* 饼图容器 */
.pie-chart {
  position: relative;
  width: 160px;
  height: 160px;
  min-width: 120px;
  min-height: 120px;
  border-radius: 50%;
  background: #f1f5f9;
  overflow: hidden;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
}

/* 饼图切片 - 使用conic-gradient实现，添加1px白色间隔线 */
.pie-chart::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: conic-gradient(
    #3b82f6 0deg 259.2deg,
    white 259.2deg 260.4deg,
    #8b5cf6 260.4deg 324deg,
    white 324deg 325.2deg,
    #ec4899 325.2deg 360deg
  );
  border-radius: 50%;
}

/* 图例样式 */
.chart-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 180px;
  font-size: 12px;
  padding-left: 5%;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-color.single { background: #3b82f6; }
.legend-color.double { background: #8b5cf6; }
.legend-color.audio { background: #ec4899; }

/* 场景多样性 */
.scene-diversity {
  margin-top: 30px;
}

.scene-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  overflow: hidden;
}

.scene-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  flex-wrap: nowrap;
  white-space: nowrap;
  flex-shrink: 1;
  max-width: calc(100% - 60px); /* 为按钮预留空间 */
}

.scene-header .h_1 {
  width: 6px;
  height: 24px;
  background: #10B981;
  border-radius: 9999px 9999px 9999px 9999px;
}

.scene-header .h_title {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 20px;
  color: #1E293B;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  min-width: 0; /* 允许在必要时压缩 */
}

.set-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
  max-width: 60%;
  flex-shrink: 1;
  min-width: 0;
  width: auto; /* 自动宽度 */
}

.scene-time {
  padding: 4px 8px;
  font-size: 14px;
  color: #2563eb;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
}

.more-btn {
  background: #f1f5f9;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #64748b;
  margin-left: auto;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  font-weight: 500;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* 基础动效 - 悬停状态 */
.more-btn:hover {
  background: #2563eb;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

/* 点击动效 */
.more-btn:active {
  transform: translateY(0) scale(0.95);
}

/* 点击波纹效果 */
.more-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.more-btn:active::after {
  width: 200px;
  height: 200px;
}

/* 脉冲动画 - 吸引注意力 */
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(37, 99, 235, 0);
  }
}

/* 第一个按钮（场景多样性）添加脉冲提示 */
.morebtn0 {
  background: white;
  border: 1px solid #e2e8f0;
  animation: pulse 2s infinite;
  overflow: visible !important; /* 允许slide-track动画完全显示 */
  position: relative;
  width: auto;
  min-width: 30px;
}

.morebtn0:hover {
  animation: none;
  background: #2563eb;
  color: white;
  border-color: #2563eb;
}

.slide-track {
  position: relative;
  height: 24px;
  width: 100%;
  min-width: 30px;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.slide-track span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 35px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  text-align: center;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  display: block;
  box-sizing: border-box;
}

/* 确保span元素有明确的宽度，防止宽度为0 */
.slide-track span {
  width: 100%;
  min-width: 30px;
}

.slide-track span:first-child {
  animation: slide-track-first 3s infinite ease-in-out;
}

.slide-track span:last-child {
  animation: slide-track-second 3s infinite ease-in-out;
}

@keyframes slide-track-first {
  0%, 45% {
    opacity: 1;
    transform: translateY(0);
  }
  50%, 100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

@keyframes slide-track-second {
  0%, 45% {
    opacity: 0;
    transform: translateY(10px);
  }
  50%, 95% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

/* 移动端竖屏适配 */
@media (max-width: 768px) and (orientation: portrait) {
  .slide-track {
    height: 24px;
    margin: 0;
    overflow: hidden;
  }
  .slide-track span {
    height: 24px;
    line-height: 24px;
    font-size: 13px;
  }

  /* 移动端竖屏按钮基础样式优化 */
  .more-btn {
    min-width: 35px; /* 确保最小宽度 */
    height: auto; /* 高度自适应 */
    padding: 8px 10px; /* 调整内边距 */
    font-size: 12px; /* 适配移动端字体 */
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap; /* 防止文字换行 */
  }

  /* morebtn0 在移动端竖屏的特殊处理 */
  .morebtn0 {
    padding: 8px 10px;
    min-width: 55px;
    animation: pulse-mobile 2s infinite; /* 移动端专用脉冲动画 */
    overflow: visible !important; /* 确保slide-track动画可见 */
  }

  /* 移动端脉冲动画 - 更温和 */
  @keyframes pulse-mobile {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.3);
    }
    50% {
      box-shadow: 0 0 0 6px rgba(37, 99, 235, 0);
    }
  }
}

/* 小屏幕竖屏适配 (iPhone SE, 小屏Android) */
@media (max-width: 480px) and (orientation: portrait) {
  .slide-track {
    height: 24px; /* 保持一致 */
    overflow: visible !important;
  }
  .slide-track span {
    height: 24px;
    line-height: 24px;
    font-size: 11px;
  }

  /* 小屏幕按钮进一步优化 */
  .more-btn {
    min-width: 45px;
    padding: 6px 8px;
    font-size: 11px;
  }

  .morebtn0 {
    min-width: 35px;
    padding: 6px 8px;
    animation: pulse-small 2s infinite;
  }

  /* 超小屏幕脉冲动画 */
  @keyframes pulse-small {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.25);
    }
    50% {
      box-shadow: 0 0 0 4px rgba(37, 99, 235, 0);
    }
  }

  /* 小屏幕头部样式优化 - 强制同行 */
  .scene-header,
  .action-header {
    font-size: 14px;
    gap: 6px;
    flex-wrap: nowrap !important; /* 强制不换行 */
  }

  .scene-header-left {
    min-width: 100px;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 50px);
  }

  .scene-header .h_title {
    font-size: 14px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    min-width: 0;
  }

  .action-header span:first-child {
    min-width: 70px;
    flex-shrink: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 100px); /* 为时间和按钮预留空间 */
  }

  .action-time {
    font-size: 10px;
    padding: 2px 4px;
    flex-shrink: 0;
  }

  .set-desc {
    font-size: 11px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
    max-width: 40%;
    flex-shrink: 1;
    min-width: 0;
    width: auto;
  }

  /* 确保按钮在小屏幕上不会挤压内容 */
  .more-btn {
    flex-shrink: 0;
    min-width: 45px; /* 保持最小宽度 */
  }

  /* 极小屏幕适配 (宽度 < 380px) */
  @media (max-width: 380px) and (orientation: portrait) {
    .more-btn > span {
      display: none; /* 只隐藏直接子元素的span，不影响slide-track内部的span */
    }
    .more-btn {
      min-width: 40px;
      padding: 6px;
    }
    /* 保持轮播效果 */
    .morebtn0 .slide-track span {
      height: 24px;
      line-height: 24px;
      font-size: 10px;
    }
  }
}

/* 高DPI屏幕适配 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .slide-track {
    transform: translateZ(0); /* 启用硬件加速 */
    backface-visibility: hidden;
    perspective: 1000px;
  }
}

/* 渐变背景动效 */
.more-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.more-btn:hover::before {
  left: 100%;
}

/* 边框发光效果 */
.more-btn {
  border: 1px solid transparent;
}

.more-btn:hover {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* 文字滑动效果 - 仅作用于直接子元素的span，不影响slide-track内部的span */
.more-btn > span {
  display: inline-block;
  transition: transform 0.3s ease;
}

.more-btn:hover > span {
  transform: translateX(2px);
}

/* 确保slide-track在morebtn0中正常工作 */
.morebtn0 .slide-track {
  overflow: hidden;
  position: relative;
  width: 100%;
  min-width: 35px;
}

/* 防止more-btn的overflow:hidden影响slide-track动画 */
.morebtn0 {
  overflow: visible !important;
}

/* 按钮组动效 - 差异化设计 */

/* 场景多样性按钮 - 温和提示 */
.morebtn0 {
  position: relative;
}

.morebtn0::before {
  content: '✨';
  position: absolute;
  right: 8px;
  opacity: 0;
  transform: translateX(-5px);
  transition: all 0.3s ease;
}

.morebtn0:hover::before {
  opacity: 1;
  transform: translateX(0);
}

/* 单人动作按钮 - 活力橙色 */
.more-btn:nth-of-type(1) {
  background: #fff7ed;
  color: #c2410c;
}

.more-btn:nth-of-type(1):hover {
  background: #ea580c;
  color: white;
}

/* 双人动作按钮 - 紫色渐变 */
.more-btn:nth-of-type(2) {
  background: #f5f3ff;
  color: #7c3aed;
}

.more-btn:nth-of-type(2):hover {
  background: linear-gradient(135deg, #7c3aed, #a78bfa);
  color: white;
}

/* 多人动作按钮 - 红色能量 */
.more-btn:nth-of-type(3) {
  background: #fef2f2;
  color: #dc2626;
}

.more-btn:nth-of-type(3):hover {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: white;
  transform: translateY(-2px) scale(1.05);
}

/* 悬停时的图标动画 */
.more-btn::before {
  content: '→';
  margin-right: 4px;
  display: inline-block;
  transition: transform 0.3s ease;
}

.more-btn:hover::before {
  transform: translateX(4px);
}

/* 禁用动画（减少动效偏好） */
@media (prefers-reduced-motion: reduce) {
  .more-btn,
  .more-btn::before,
  .more-btn::after {
    transition: none;
    animation: none;
  }
}

/* 移动端优化 - 通用 */
@media (max-width: 768px) {
  .more-btn {
    padding: 8px 12px;
    font-size: 13px;
    min-width: 48px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .more-btn:hover {
    transform: translateY(-1px);
  }

  /* morebtn0 移动端通用优化 */
  .morebtn0 {
    padding: 8px 12px;
    min-width: 52px;
  }

  /* action-header 在移动端的适配 - 保持同行 */
  .action-header {
    font-size: 16px;
    flex-wrap: nowrap; /* 强制不换行 */
    gap: 8px;
    min-height: 40px; /* 确保最小高度 */
    width: 100%;
    overflow: hidden;
  }

  .action-header span:first-child {
    flex-shrink: 1; /* 允许文字收缩 */
    min-width: 80px; /* 但保持最小宽度 */
    max-width: calc(100% - 120px); /* 为时间和按钮预留空间 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .action-time {
    font-size: 11px;
    padding: 3px 6px;
    margin-left: 0; /* 移除左边距，使用gap */
    flex-shrink: 0; /* 不收缩 */
  }

  /* 确保按钮在 action-header 中正确对齐 */
  .action-header .more-btn {
    margin-left: auto;
    transform: none !important; /* 移除悬停位移避免布局跳动 */
    flex-shrink: 0; /* 不收缩 */
  }

  /* scene-header 在移动端的适配 - 保持同行 */
  .scene-header {
    font-size: 16px;
    flex-wrap: nowrap; /* 强制不换行 */
    gap: 8px;
    min-height: 44px; /* 确保最小高度 */
  }

  .scene-header-left {
    flex: 1 1 auto;
    min-width: 120px;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    max-width: calc(100% - 55px); /* 为按钮预留空间 */
  }

  .scene-header .h_title {
    font-size: 16px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
    min-width: 0;
  }

  .scene-header .more-btn {
    margin-left: auto;
    transform: none !important;
    flex-shrink: 0;
  }

  .set-desc {
    font-size: 12px !important;
    margin: 0 !important;
    line-height: 1.4 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
    max-width: 50%;
    flex-shrink: 1;
    min-width: 0;
    width: auto;
  }
}

/* 横屏适配 - 必须放在通用移动端样式之后以确保优先级 */
@media (max-width: 768px) and (orientation: landscape) {
  /* 按钮基础样式 - 覆盖通用移动端样式 */
  .more-btn {
    min-width: 42px !important;
    height: 32px !important;
    padding: 6px 12px !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    white-space: nowrap !important;
    overflow: visible !important;
    background: #f1f5f9 !important;
    border: 1px solid #e2e8f0 !important;
  }

  .morebtn0 {
    min-width: 46px !important;
    width: 46px !important;
    height: 32px !important;
    padding: 6px 8px !important;
    overflow: visible !important;
    background: white !important;
    border: 1px solid #e2e8f0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
  }

  /* 确保slide-track在横屏下有固定宽度 */
  .morebtn0 .slide-track {
    overflow: visible !important;
    position: relative;
    height: 24px !important;
    width: 35px !important;
    min-width: 35px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  /* Slide-track 轮播样式 - 确保在横屏下正常显示 */
  .slide-track {
    position: relative;
    height: 24px;
    width: 35px !important;
    min-width: 35px !important;
    overflow: visible !important;
    margin: 0;
    padding: 0;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .slide-track span {
    position: absolute;
    top: 0;
    left: 0;
    width: 35px !important;
    min-width: 35px !important;
    max-width: 35px !important;
    height: 24px !important;
    line-height: 24px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    white-space: nowrap !important;
    text-align: center !important;
    opacity: 0 !important;
    display: block !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    background: transparent !important;
  }

  /* 横屏专用动画 - 使用translateY进行位移 */
  .slide-track span:first-child {
    animation: slide-track-first-landscape 3s infinite ease-in-out !important;
  }

  .slide-track span:last-child {
    animation: slide-track-second-landscape 3s infinite ease-in-out !important;
  }

  /* 隐藏可能干扰的伪元素 */
  .morebtn0::before {
    display: none !important;
  }
}

/* 横屏专用关键帧动画 */
@keyframes slide-track-first-landscape {
  0%, 45% {
    opacity: 1;
    transform: translateY(0);
  }
  50%, 100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

@keyframes slide-track-second-landscape {
  0%, 45% {
    opacity: 0;
    transform: translateY(10px);
  }
  50%, 95% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.scene-images {
  display: flex;
  gap: 16px;
  background: white;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
}

.scene-image {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  background: #f1f5f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  position: relative;
  overflow: hidden;
}

.scene-image .action-header {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.scene-image .action-header-tip {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(255, 255, 255, 0.85);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.scene-image .action-header-tip span {
  color: #000000;
  opacity: 0.9;
}

.camera-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  border-radius: 4px;
  display: block;
}

.camera-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

/* 动作类型 */
.action-types-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 48px;
}

.action-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 1);
}

.action-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 18px;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  overflow: hidden;
}

.action-time {
  background: #eff6ff;
  color: #2563eb;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  flex-shrink: 0;
  white-space: nowrap;
}

.action-preview {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.preview-placeholder {
  flex: 1;
  height: 182px;
  background: #f1f5f9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 12px;
}

.score-box {
  background: #000;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.score-value {
  background: #facc15;
  color: #422006;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 700;
}

.score-demo {
  color: #fff;
  font-size: 12px;
}

.score-description {
  font-size: 14px;
  color: #64748b;
  line-height: 16px;
}

.action-image {
  height: 132px;
  background: #f1f5f9;
  border-radius: 8px;
  margin-top: 12px;
}

/* 统计数据 */
.stats-section {
  background: white;
  max-width: 1400px;
  margin: 0 auto;
}

.stats-row {
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.stat-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 24px 32px;
  min-width: 200px;
  text-align: center;
}

.stat-item.large {
  background: white;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 1);
}

.stat-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.stat-num {
  font-size: 30px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.stat-name {
  font-size: 14px;
  color: #64748b;
}

/* 视频标注 */
.annotation-section {
  background: #f8fafc;
  max-width: 1400px;
  margin: 0 auto;
}

.annotation-content {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 48px;
}

.annotation-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 600px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.annotation-card h3 {
  margin-bottom: 16px;
  padding-left: 16px;
  border-left: 4px solid #dc2626;
}

.id-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.id-item {
  background: #f1f5f9;
  padding: 52px 0;
  border-radius: 4px;
  text-align: center;
  color: #94a3b8;
  font-weight: 700;
}

.smpl-view {
  background: #1e293b;
  border-radius: 8px;
  padding: 100px 0;
  text-align: center;
  color: white;
  font-size: 18px;
  margin-bottom: 16px;
}

.annotation-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 20px;
}

/* 数据集结构 */
.structure-section {
  background: #030A19;
  max-width: 1400px;
  margin: 0 auto;
}

.structure-content {
  background: #0f172a;
  border-radius: 12px;
  padding: 24px;
  max-width: 1120px;
  margin: 0 auto 0;
  color: white;
}

.file-header {
  background: #1e293b;
  padding: 8px 16px;
  border-bottom: 1px solid #334155;
  font-family: Menlo, monospace;
  font-size: 11px;
  color: #94a3b8;
}

.tree-view {
  font-family: Menlo, monospace;
  font-size: 13px;
  line-height: 20px;
  padding: 24px;
  overflow-x: auto;
  background: #0f172a;  /* 添加深色背景，与上方 structure-content 保持一致 */
}

.tree-line {
  white-space: nowrap;
}

/* 语义化颜色规则 */
.tree-line.tree-root { color: #4ade80; }        /* 绿色 - 根目录 */
.tree-line.tree-level1 { color: #60a5fa; }      /* 蓝色 - 一级目录 */
.tree-line.tree-level2 { color: #facc15; }      /* 黄色 - 一级分类 */
.tree-line.tree-level3 { color: #facc15; }      /* 黄色 - 二级分类 */
.tree-line.tree-file { color: #6063fa; }        /* 紫色 - 文件 */
.tree-line.tree-annotation { color: #60a5fa; }  /* 蓝色 - 标注结构 */
.tree-line.tree-object { color: #60a5fa; }      /* 蓝色 - JSON对象 */
.tree-line.tree-key { color: #facc15; }         /* 黄色 - JSON键 */
.tree-line.tree-bracket { color: #60a5fa; }     /* 蓝色 - 括号 */
.tree-line.tree-ellipsis { color: #fa60ed; }    /* 粉色 - 省略号 */
.tree-line.tree-divider { color: #60a5fa; }     /* 蓝色 - 分隔线 */


.compliance-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(234, 179, 8, 0.1);
  color: #eab308;
  padding: 12px;
  border-radius: 4px;
  margin: 24px 0;
  font-size: 14px;
}

.download-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  transition: all 0.2s ease;
}

.download-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 联系我们 */
.contact-section {
  background: #0f172a;
  color: white;
  max-width: 1400px;
  margin: 0 auto;
}

.contact-content {
  display: flex;
  gap: 48px;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
  flex-wrap: wrap;
}

.contact-info {
  min-width: 584px;
}

.contact-info h3 {
  margin-bottom: 24px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: bold;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;

  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: normal;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-emails {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  color: #cbd5e1;
  font-size: 16px;
  flex-wrap: wrap;
}

.contact-address {
  color: #cbd5e1;
  margin-left: 28px;

  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: normal;
  font-size: 16px;
  color: #CBD5E1;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contact-links {
  margin-top: 32px;
}

.link-group {
  display: flex;
  gap: 16px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.link-item {
  color: #cbd5e1;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

.link-item:hover {
  color: white;
}

.contact-qr {
  width: 584px;
  height: 375px;
  background: #1e293b;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.address-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  /* opacity: 0.6; */
}

.footer {
  border-top: 1px solid #334155;
  padding-top: 32px;

  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 14px;
  color: #64748B;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .navbar-menu {
    gap: 20px;
  }

  .table-row {
    grid-template-columns: 30% 10% 10% 10% 10% 10% 10%;
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .navbar-content {
    flex-direction: column;
    height: auto;
    gap: 12px;
    padding: 12px;
  }

  .navbar-menu {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }

  .navbar-item {
    font-size: 12px;
    padding: 6px 8px;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 18px;
    line-height: 1.8;
    gap: 10px;
  }

  .hero-subtitle strong {
    padding: 2px 6px;
  }

  .hero-subtitle .feature-tagline {
    font-size: 1em;
    padding: 8px 12px;
  }

  /* 新增:响应式标签 */
  .hero-tags {
    gap: 10px;
    margin-bottom: 30px;
  }

  .hero-tag {
    padding: 6px 16px;
    font-size: 13px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .section {
    padding: 40px 16px;
  }

  .section-title {
    font-size: 28px;
  }

  .section-content {
    flex-direction: column;
    gap: 16px;
  }

  .stats-grid {
    width: 100%;
    max-width: 400px;
    min-width: auto;
  }

  /* feature-cards 已在上面定义为3个同行显示，此处删除冲突样式 */

  .action-grid {
    grid-template-columns: 1fr;
  }

  .annotation-card {
    width: 100%;
  }

  .contact-info {
    min-width: auto;
    width: 100%;
  }

  /* 饼图响应式 - 768px以下 */
  .distribution-chart {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .pie-chart {
    width: 140px;
    height: 140px;
  }

  .chart-legend {
    padding-left: 0;
    text-align: center;
    min-width: auto;
  }

  .comparison-table {
    background: rgba(255,255,255,0.9);
    box-shadow: 0px 10px 25px -5px rgba(59,130,246,0.05), 0px 4px 10px -3px rgba(59,130,246,0.03);
    border-radius: 16px 16px 16px 16px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 14px;
    line-height: 1.6;
    gap: 8px;
  }

  .hero-subtitle .stat-line {
    padding: 2px 0;
  }

  .hero-subtitle strong {
    font-size: 0.95em;
    padding: 1px 6px;
  }

  /* 新增:小屏幕标签 */
  .hero-tags {
    gap: 8px;
    margin-bottom: 24px;
  }

  .hero-tag {
    padding: 6px 14px;
    font-size: 12px;
  }

  .hero-subtitle .feature-tagline {
    font-size: 0.9em;
    padding: 8px 8px;
    margin-top: 4px;
  }

  .hero-actions {
    flex-direction: column;
    gap: 10px;
  }

  .btn {
    width: 100%;
    max-width: 280px;
    padding: 14px 20px;
    font-size: 14px;
  }

  .section-title {
    font-size: 24px;
  }

  /* 移动端竖屏优化 - 减少section-content屏占比和空白 */
  .section-content {
    gap: 8px; /* 减小卡片间距 */
    margin: 0 auto;
    padding: 0 8px; /* 减少左右边距 */
  }

  /* 标题居中（适配你原有标题结构） */
  .overview-section .section-title {
    text-align: center !important;
    position: relative;
    margin-bottom: 30px;
    font-size: 32px;
    font-weight: 700;
  }

  .overview-section .section-title::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background: #00a8ff;
  }
  /* 正文排版（居中对齐、行间距） */
  .overview-section p {
    text-align: left;
    font-size: 16px;
    line-height: 1.8;
    margin: 0 0 20px 0;
    letter-spacing: 0.5px;
  }
  /* 正文高亮文字（蓝色关键词，和效果图一致） */
  .overview-section .highlight {
    color: #00a8ff !important;
    font-weight: 500;
  }
  /* 移动端适配（不破坏原有布局） */
  @media (max-width: 768px) {
    .overview-section {
      width: 95%;
      padding: 20px 25px;
    }
    .overview-section .section-title {
      font-size: 24px;
    }
  }

  .data-overview-section .section-content {
    margin-bottom: 30px; /* 减小底部间距 */
  }

  .stats-grid {
    min-width: 100%;
    flex: 1 1 100%; /* 占满宽度 */
    margin-bottom: 8px; /* 减小卡片底部间距 */
  }

  .stat-card {
    min-height: 140px; /* 减小卡片高度 */
    padding: 12px; /* 减小内边距 */
    gap: 4px; /* 减小内部元素间距 */
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 32px; /* 减小图标尺寸 */
    height: 32px;
    margin-bottom: 4px; /* 减小图标底部间距 */
    font-size: 14px;
  }

  .stat-value-label-wrapper {
    flex-direction: column;
    gap: 8px; /* 减小标签组间距 */
  }

  .stat-value-label,
  .stat-value-label3 {
    flex: 1 1 100%;
    min-width: 100%;
  }

  .stat-value-container {
    gap: 2px; /* 减小数值和单位间距 */
    margin-bottom: 1px; /* 减小数值容器底部间距 */
  }

  .stat-num {
    font-size: 22px; /* 稍微减小 */
  }

  .stat-value {
    font-size: 22px; /* 稍微减小 */
  }

  .stat-unit {
    font-size: 11px;
  }

  .stat-label {
    font-size: 11px; /* 减小标签字体 */
    line-height: 1.1; /* 减小行高 */
  }

  .stat-detail {
    margin-top: 6px; /* 减小详情标签上边距 */
    font-size: 11px; /* 减小详情字体 */
    padding: 2px 6px; /* 减小详情内边距 */
  }

  .stats-row {
    flex-direction: column;
    gap: 8px; /* 减小统计项间距 */
  }

  .stat-item {
    width: 100%;
  }

  .feature-boxes {
    flex-direction: column;
    flex-wrap: wrap;
    gap: 12px; /* 减小特性盒子间距 */
  }

  .feature-box {
    width: 100%;
    flex: none;
    padding: 16px; /* 减小内边距 */
  }

  .box-header {
    margin-bottom: 12px; /* 减小头部底部间距 */
  }

  .box-description {
    margin-bottom: 12px; /* 减小描述底部间距 */
    font-size: 13px; /* 稍微减小 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 饼图响应式 - 480px以下 */
  .pie-chart {
    width: 100px; /* 减小尺寸 */
    height: 100px;
    min-width: 80px;
    min-height: 80px;
  }

  .chart-legend {
    font-size: 10px; /* 减小字体 */
    gap: 4px; /* 减小间距 */
  }

  .tree-view {
    font-size: 10px; /* 减小字体 */
    line-height: 16px; /* 减小行高 */
  }

  .comparison-table .table-row {
    grid-template-columns: 35% 15% 15% 15% 10% 10%;
    font-size: 11px; /* 减小字体 */
    gap: 6px; /* 减小间距 */
    padding: 10px 12px; /* 减小内边距 */
  }

  .comparison-table .table-row.header {
    font-size: 10px; /* 减小字体 */
    padding: 8px 12px; /* 减小内边距 */
  }

  .comparison-table .note-header {
    font-size: 10px; /* 减小字体 */
    padding: 12px; /* 减小内边距 */
  }

  .action-grid {
    grid-template-columns: 1fr;
    gap: 12px; /* 减小动作卡片间距 */
  }

  .scene-images {
    flex-direction: column;
    gap: 8px; /* 减小场景图片间距 */
  }

  .scene-image {
    height: 120px; /* 减小高度 */
  }

  /* 场景概述部分优化 */
  .scene-overview {
    padding: 16px; /* 减小内边距 */
    margin-bottom: 16px; /* 减小底部间距 */
  }

  .scene-overview-desc {
    font-size: 12px; /* 减小字体 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 特性卡片容器优化 */
  .feature-cards {
    gap: 8px; /* 减小间距 */
    padding: 0 8px; /* 减小边距 */
  }

  .feature-card {
    padding: 16px 12px; /* 减小内边距 */
    min-width: 0;
  }

  .feature-icon {
    width: 36px; /* 减小图标尺寸 */
    height: 36px;
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .feature-card h3 {
    font-size: 13px; /* 减小字体 */
    margin-bottom: 4px; /* 减小底部间距 */
  }

  /* 高亮框优化 */
  .intro-highlight-box {
    padding: 16px; /* 减小内边距 */
    margin-bottom: 16px; /* 减小底部间距 */
  }

  .highlight-item {
    padding: 12px; /* 减小内边距 */
  }

  .highlight-text {
    font-size: 14px; /* 减小字体 */
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .highlight-item p {
    font-size: 12px; /* 减小字体 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 效率部分优化 */
  .efficiency-section {
    padding: 16px; /* 减小内边距 */
    margin-bottom: 16px; /* 减小底部间距 */
  }

  .efficiency-section .section-subtitle {
    font-size: 16px; /* 减小字体 */
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .efficiency-description {
    font-size: 12px; /* 减小字体 */
    line-height: 1.4; /* 减小行高 */
  }

  /* 动作集容器优化 */
  .action-set-container {
    padding: 12px; /* 减小内边距 */
  }

  .action-set-header {
    margin-bottom: 8px; /* 减小底部间距 */
  }

  .action-set-desc {
    font-size: 12px; /* 减小字体 */
    margin-bottom: 12px; /* 减小底部间距 */
  }

  .viz-box {
    min-width: 100%; /* 占满宽度 */
  }

  .viz-header {
    padding: 8px; /* 减小内边距 */
  }

  .plotly-container {
    height: 300px; /* 减小高度 */
    padding: 8px; /* 减小内边距 */
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 250px; /* 减小最小高度 */
  }
}

/* 2K+ 高分辨率屏幕优化 - 仅保留布局相关样式，字体由section-content专用媒体查询控制 */
@media (min-width: 2048px) {
  .stats-grid {
    flex: 1 1 260px;
    max-width: 280px;
  }

  .stat-card {
    padding: 12px;
    gap: 6px;
    min-height: 150px; /* 降低最小高度 */
    max-height: 180px; /* 限制最大高度 */
    overflow: hidden;
    width: 100%; /* 确保卡片占满容器 */
  }

  /* 2K屏幕下调整stat-value-label-wrapper */
  .stat-value-label-wrapper {
    flex-direction: row !important;
    gap: 6px;
  }

  /* 2K屏幕下stat-value-label3保持3列 */
  .stat-value-label3 {
    flex: 1 1 calc(33.333% - 4px) !important;
    max-width: calc(33.333% - 4px) !important;
    min-width: 35px !important;
  }

  /* 2K屏幕下stat-value-label保持2列 */
  .stat-value-label {
    flex: 1 1 calc(50% - 4px) !important;
    max-width: calc(50% - 4px) !important;
    min-width: 80px !important;
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 36px;
    height: 36px;
    margin-bottom: 6px;
  }
}

/* 4K 超高分辨率屏幕优化 - 仅保留布局相关样式，字体由section-content专用媒体查询控制 */
@media (min-width: 3840px) {
  .stats-grid {
    flex: 1 1 240px;
    max-width: 260px;
  }

  .stat-card {
    padding: 10px;
    gap: 5px;
    min-height: 140px; /* 降低最小高度 */
    max-height: 170px; /* 限制最大高度 */
    overflow: hidden;
  }

  .stat-value-label-wrapper {
    flex-direction: row !important;
    gap: 4px;
  }

  /* 4K屏幕下stat-value-label3保持3列布局 */
  .stat-value-label3 {
    flex: 1 1 calc(33.333% - 3px) !important;
    max-width: calc(33.333% - 3px) !important;
    min-width: 60px !important;
  }

  /* 4K屏幕下stat-value-label保持2列 */
  .stat-value-label {
    flex: 1 1 calc(50% - 3px) !important;
    max-width: calc(50% - 3px) !important;
    min-width: 60px !important;
  }

  .stat-icon,
  .stat-icon2,
  .stat-icon3,
  .stat-icon4 {
    width: 32px;
    height: 32px;
    margin-bottom: 4px;
  }

  .stat-icon img,
  .stat-icon2 img,
  .stat-icon3 img,
  .stat-icon4 img {
    width: 16px;
    height: 16px;
  }
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 加载动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section {
  animation: fadeInUp 0.6s ease-out;
}

/* 工具类 */
.justify-between {
  justify-content: space-between;
}

.flex-row {
  display: flex;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

/* 动作集容器样式 - 深色背景 */
.action-set-container {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 12px;
  padding: 24px;
}

.action-set-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.action-icon {
  width: 24px;
  height: 24px;
}

.action-set-header h3 {
  font-size: 18px;
  color: #ffffff;
}

.action-set-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 20px;
}

.action-visualization {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.viz-box {
  flex: 1;
  min-width: 300px;
  background: rgba(30, 41, 59, 0.6);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(51, 65, 85, 0.5);
}

.viz-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid rgba(51, 65, 85, 0.5);
  background: rgba(15, 23, 42, 0.5);
}

.viz-thumbnail {
  width: 20px;
  height: 20px;
}

.viz-text {
  font-size: 12px;
  color: #2563eb;
  font-weight: 500;
  text-decoration: none;
  transition: text-decoration 0.2s ease;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}


/* 新项目简介组件样式 */
.intro-text-section {
  max-width: 864px;
  margin: 0 auto;
}

.intro-description {
  font-size: 18px;
  line-height: 29px;
  color: #475569;
  margin-bottom: 32px;
  font-weight: 400;
  text-align: justify;
  letter-spacing: 0.3px;
  word-wrap: break-word;
  white-space: pre-line;
}


/* 优化简介文字在不同屏幕下的表现 */
@media (max-width: 768px) {
  .intro-description {
    font-size: 16px;
    line-height: 26px;
    text-align: left;
  }
}

@media (max-width: 480px) {
  .intro-description {
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 24px;
  }
}

/* 核心稀缺性与总量优势 - 高亮框 */
.intro-highlight-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 4px 10px -3px rgba(59, 130, 246, 0.05);
}

.highlight-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 24px;
  text-align: center;
  font-family: 'Noto Sans SC', sans-serif;
}

.highlight-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.highlight-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border-left: 4px solid #2563eb;
}

.highlight-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
  font-family: 'Noto Sans SC', sans-serif;
}

.highlight-item p {
  font-size: 14px;
  line-height: 22px;
  color: #475569;
  margin: 0;
}

/* 统计高亮数字样式 */
.stat-highlight {
  font-weight: 800;
  color: #dc2626;
  background: #fee2e2;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.95em;
  letter-spacing: 0.3px;
}

/* 开箱即用 - 效率部分 */
.efficiency-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
}

.efficiency-section .section-subtitle {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
  text-align: center;
  line-height: 1.4;
}

.efficiency-description {
  font-size: 15px;
  line-height: 24px;
  color: #334155;
  text-align: center;
  margin-bottom: 20px;
}

.tagline {
  font-size: 18px;
  font-weight: 700;
  color: #2563eb;
  text-align: center;
  font-style: italic;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 2px dashed #bfdbfe;
  margin-top: 16px;
}

/* Plotly 可视化容器样式 */
.plotly-container {
  width: 100%;
  height: 500px;
  background: transparent;  /* 改为透明，继承父级深色背景 */
  padding: 16px;
  border-radius: 0 0 8px 8px;
}

.plotly-container div[id="plotly-action-viz"] {
  width: 100% !important;
  height: 100% !important;
  min-height: 450px;
}

/* 响应式设计 - Plotly */
@media (max-width: 768px) {
  .plotly-container {
    height: 400px;
    padding: 12px;
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 350px;
  }
}

@media (max-width: 480px) {
  .plotly-container {
    height: 350px;
    padding: 8px;
  }

  .plotly-container div[id="plotly-action-viz"] {
    min-height: 300px;
  }

  /* 新项目简介组件响应式设计 */
  .intro-highlight-box {
    padding: 20px;
    margin-bottom: 24px;
  }

  .highlight-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .highlight-item {
    padding: 16px;
  }

  .highlight-text {
    font-size: 15px;
  }

  .efficiency-section {
    padding: 20px;
    margin-bottom: 20px;
  }

  .efficiency-section .section-subtitle {
    font-size: 18px;
  }

  .efficiency-description {
    font-size: 14px;
  }

  .tagline {
    font-size: 16px;
    padding: 12px;
  }
}

/* 中等屏幕响应式 */
@media (max-width: 768px) {
  .intro-highlight-box {
    padding: 24px;
  }

  .highlight-title {
    font-size: 22px;
  }

  .efficiency-section {
    padding: 24px;
  }
}

/* 视频加载中覆盖层样式 */
.video-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 500;
  z-index: 10;
  backdrop-filter: blur(2px);
}

/* 隐藏加载覆盖层 */
.video-loading-overlay.hidden {
  display: none !important;
}

/* 预览占位容器 - 确保覆盖层正确定位 */
.preview-placeholder {
  position: relative;
  overflow: hidden;
}

.stat-line-single {
  white-space: nowrap;
  display: inline-block;
}

.tagline-wide {
  white-space: nowrap;
  width: fit-content;
  min-width: 300px;
  padding: 12px 24px;
  display: block;
  margin: 0 auto;
}

/* 移动端适配 - 视频加载覆盖层 */
@media (max-width: 768px) {
  .video-loading-overlay {
    font-size: 12px;
    padding: 10px;
  }
}

/* 小屏幕适配 - 视频加载覆盖层 */
@media (max-width: 480px) {
  .video-loading-overlay {
    font-size: 11px;
  }
}

/* 底部重点标语响应式适配 */
@media (max-width: 768px) {
  .hero-subtitle.bottom {
    margin-top: 16px;
    width: 75%;
  }

  .hero-subtitle.bottom .feature-tagline {
    font-size: 16px;
    padding: 10px 14px;
    letter-spacing: 0.8px;
  }
}

@media (max-width: 480px) {
  .hero-subtitle.bottom .feature-tagline {
    font-size: 14px;
    padding: 8px 12px;
    letter-spacing: 0.5px;
    line-height: 1.5;
  }
}

@media (max-width: 375px) {
  .hero-subtitle.bottom .feature-tagline {
    font-size: 13px;
    padding: 6px 10px;
    letter-spacing: 0.3px;
  }
}

/* ==================== 音频样音试听区域样式 ==================== */
.audio-page-header {
  text-align: center;
  margin-bottom: 28px;
}

.audio-page-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 28px;
  color: #1a1a1a;
}

/* —— 引导提示 —— */
.guide-hint {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-left: 4px solid #1e66f5;
}

.guide-icon {
  font-size: 18px;
}

.guide-text {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.guide-text .highlight {
  color: #1e66f5;
  font-weight: 500;
}

/* —— 分类卡片容器 —— */
.category-section {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-bottom: 28px;
}

.category-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-icon {
  font-size: 20px;
}

.btn-more {
  font-size: 13px;
  color: #1e66f5;
  background: none;
  border: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.btn-more:hover {
  color: #1854d0;
  transform: translateX(2px);
}

.btn-more .arrow {
  transition: transform 0.25s;
}

.btn-more:hover .arrow {
  transform: translateX(2px);
}

/* —— 音频网格 —— */
.audio-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  padding: 20px;
}

/* —— 音频卡片 —— */
.audio-card {
  background: #f9fafb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e5e7eb;
  position: relative;
}

.audio-card:hover {
  border-color: #1e66f5;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 102, 245, 0.06);
}

.audio-card.playing {
  border-color: #1e66f5;
  background: #ffffff;
}

.audio-body {
  padding: 18px 20px;
}

.audio-control {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.play-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.play-btn:hover {
  background: #1e66f5;
  color: white;
  border-color: #1e66f5;
}

.play-btn.playing {
  background: #40c057;
  color: white;
  border-color: #40c057;
}

.play-icon {
  font-size: 14px;
  line-height: 1;
}

.audio-meta {
  flex: 1;
  min-width: 0;
}

.audio-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audio-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(30, 102, 245, 0.08);
  color: #1e66f5;
}

.progress-container {
  height: 4px;
  background: #e5e7eb;
  border-radius: 2px;
  margin-top: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: height 0.25s;
}

.progress-container:hover {
  height: 6px;
}

.sample-card .progress-bar {
  height: 100%;
  background: #1e66f5;
  border-radius: 2px;
  width: 0%;
  transition: width 0.1s linear;
}

.audio-card.playing .progress-bar {
  background: #1e66f5;
}

.audio-time {
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-family: 'Courier New', monospace;
}

/* 隐藏实际的 audio 元素 */
.audio-card audio {
  display: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .audio-grid {
    grid-template-columns: 1fr;
  }

  .audio-page-title {
    font-size: 22px;
  }

  .category-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .audio-grid {
    padding: 16px;
    gap: 14px;
  }

  .audio-body {
    padding: 14px 16px;
  }

  .category-title {
    font-size: 16px;
  }
}
#app {
  width: 100%;
  min-height: 100vh;
  background: #030A19;
}

/* 数据特色模块 - 严格一行两个卡片 + 居中 + 无红框 */
.data-features-section {
  padding: 60px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* 标题样式（和你的项目简介统一） */
.data-features-section .section-title-wrapper {
  text-align: center;
  margin-bottom: 40px;
}
.data-features-section .section-title {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  position: relative;
  display: inline-block;
}
.data-features-section .section-title::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #00a8ff;
}
/* 卡片布局：一行两个，居中排列 */
.features-container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}
/* 卡片样式（和你的页面统一） */
.feature-item {
  width: 48%;
  max-width: 550px;
  background: rgba(0, 10, 41, 0.85);
  border-radius: 12px;
  padding: 30px;
  color: #fff;
  box-sizing: border-box;
}
/* 卡片标题 */
.feature-item h3 {
  font-size: 20px;
  color: #00a8ff;
  margin: 0 0 20px 0;
  font-weight: 600;
}
/* 卡片文字 */
.feature-item p {
  font-size: 15px;
  line-height: 1.8;
  margin: 0 0 20px 0;
}
/* 卡片图片区域 */
.feature-img {
  width: 100%;
  height: 200px;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
}
/* 移动端适配：一行1个 */
@media (max-width: 768px) {
  .feature-item {
    width: 100%;
  }
}

/* 图片轮播样式（只新增，不修改原有样式） */
.carousel-container {
  width: 100%;
  height: 200px;
  position: relative;
  border: none;
  box-shadow: none;
  margin: 0;
  background: #0a1628;
  border-radius: 8px;
  overflow: hidden;  /* 添加这一行：隐藏超出容器的图片 */
}
.carousel-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.4s ease;
}
.carousel-card {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.carousel-card img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
/* 切换按钮（适配深色背景，hover高亮） */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.5);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
}
.carousel-btn:hover {
  background: rgba(64, 158, 255, 0.8);
}
.prev-btn { left: 10px; }
.next-btn { right: 10px; }
/* 指示器（适配深色背景） */
.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}
.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: background 0.2s;
}
.indicator.active {
  background: #409eff; /* 主色调，适配你页面的蓝色 */
}


/* ==================== 音频样音试听区域样式 - 蓝黑科技风 ==================== */

/* 标题区域 */
.scene-header {
  color: #ffffff;
}

.scene-header .h_title {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
}

.set-desc {
  color: rgba(255, 255, 255, 0.6);
}

/* 分类卡片容器 - 深色背景 */
.category-section {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin-bottom: 28px;
}

.category-header {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(51, 65, 85, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 音频网格 */
.audio-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  padding: 20px;
}

/* 音频卡片 - 深色卡片 */
.audio-card {
  background: rgba(30, 41, 59, 0.6);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.audio-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.audio-card.playing {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
}

.audio-body {
  padding: 18px 20px;
}

.audio-control {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

/* 播放按钮 - 深色风格 */
.play-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.play-btn:hover {
  background: #3b82f6;
  color: #ffffff;
  border-color: #3b82f6;
}

.play-btn.playing {
  background: #3b82f6;
  color: #ffffff;
  border-color: #3b82f6;
}

/* 音频元信息 - 白色文字 */
.audio-meta {
  flex: 1;
  min-width: 0;
}

.audio-title {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audio-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

/* 进度条 - 深色背景 */
.progress-container {
  height: 4px;
  background: rgba(51, 65, 85, 0.5);
  border-radius: 2px;
  margin-top: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: height 0.25s;
}

.progress-container:hover {
  height: 6px;
}

.audio-card.playing .progress-bar {
  background: #60a5fa;
  box-shadow: 0 0 8px rgba(96, 165, 250, 0.5);
}

/* 音频时间 - 白色文字 */
.audio-time {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-family: 'Courier New', monospace;
}

.audio-card audio {
  display: none;
}

/* 探索更多按钮 - 蓝色风格 */
.btn-more {
  font-size: 13px;
  color: #60a5fa;
  background: none;
  border: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.btn-more:hover {
  color: #93c5fd;
  transform: translateX(2px);
}

/* 响应式 - 移动端 */
@media (max-width: 768px) {
  .audio-grid {
    grid-template-columns: 1fr;
  }

  .category-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .audio-grid {
    padding: 16px;
    gap: 14px;
  }

  .audio-body {
    padding: 14px 16px;
  }

  .category-title {
    font-size: 16px;
  }
}

.next-btn { right: 10px; }
/* 指示器（适配深色背景） */
.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}
.indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: background 0.2s;
}
.indicator.active {
  background: #409eff; /* 主色调，适配你页面的蓝色 */
}


/* ==================== 音频样音试听区域样式 - 蓝黑科技风 ==================== */

/* 标题区域 */
.scene-header {
  color: #ffffff;
}

.scene-header .h_title {
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
}

.set-desc {
  color: rgba(255, 255, 255, 0.6);
}

/* 分类卡片容器 - 深色背景 */
.category-section {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin-bottom: 28px;
}

.category-header {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(51, 65, 85, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 音频网格 */
.audio-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  padding: 20px;
}

/* 音频卡片 - 深色卡片 */
.audio-card {
  background: rgba(30, 41, 59, 0.6);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.audio-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.audio-card.playing {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
}

.audio-body {
  padding: 18px 20px;
}

.audio-control {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

/* 播放按钮 - 深色风格 */
.play-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.play-btn:hover {
  background: #3b82f6;
  color: #ffffff;
  border-color: #3b82f6;
}

.play-btn.playing {
  background: #3b82f6;
  color: #ffffff;
  border-color: #3b82f6;
}

/* 音频元信息 - 白色文字 */
.audio-meta {
  flex: 1;
  min-width: 0;
}

.audio-title {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audio-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

/* 进度条 - 深色背景 */
.progress-container {
  height: 4px;
  background: rgba(51, 65, 85, 0.5);
  border-radius: 2px;
  margin-top: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: height 0.25s;
}

.progress-container:hover {
  height: 6px;
}

/* 音频时间 - 白色文字 */
.audio-time {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-family: 'Courier New', monospace;
}

.audio-card audio {
  display: none;
}

/* 探索更多按钮 - 蓝色风格 */
.btn-more {
  font-size: 13px;
  color: #60a5fa;
  background: none;
  border: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.btn-more:hover {
  color: #93c5fd;
  transform: translateX(2px);
}

/* 响应式 - 移动端 */
@media (max-width: 768px) {
  .audio-grid {
    grid-template-columns: 1fr;
  }

  .category-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .audio-grid {
    padding: 16px;
    gap: 14px;
  }

  .audio-body {
    padding: 14px 16px;
  }

  .category-title {
    font-size: 16px;
  }
}

.navbar-btn-sales {
  background: #0279FF;
  color: #ffffff;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Noto Sans SC', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(2, 121, 255, 0.3);
}

.navbar-btn-sales:hover {
  background: #0279FF;
  box-shadow: 0 4px 12px rgba(2, 121, 255, 0.5);
  transform: translateY(-1px);
}

.navbar-btn-lang {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Noto Sans SC', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 8px;
}

.navbar-btn-lang:hover {
  background: #ffffff;
  color: #0a1929;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

/* 联系我们弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-overlay.modal-active {
  opacity: 1;
  visibility: visible;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-content {
  width: 95%;
  max-width: 100%;
}

.modal-header {
  padding: 16px;
}

.modal-title {
  font-size: 20px;
}

.modal-body {
  padding: 16px;
}

.modal-content {
  background: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transform: scale(0.9);
  transition: all 0.3s ease;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 32px;
  color: #64748b;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #0f172a;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
  font-weight: 500;
}

.label-icon {
  font-size: 16px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #0f172a;
  transition: all 0.2s;
  outline: none;
}

.form-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-input::placeholder {
  color: #94a3b8;
}

.radio-group {
  display: flex;
  gap: 24px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #0f172a;
}

.radio-item input[type="radio"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #2563eb;
}

.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #0f172a;
  transition: all 0.2s;
  outline: none;
  resize: vertical;
  font-family: inherit;
  background: #f9fafb;
}

.form-textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-textarea::placeholder {
  color: #94a3b8;
}

.submit-btn {
  width: 100%;
  padding: 14px 24px;
  background: #0279FF;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(2, 121, 255, 0.3);
}

.submit-btn:hover {
  background: #0279FF;
  box-shadow: 0 6px 16px rgba(2, 121, 255, 0.5);
  transform: translateY(-1px);
}

.submit-btn:active {
  transform: translateY(0);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
}

.submit-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.submit-btn:active {
  transform: translateY(0);
}

.submit-image-wrapper {
  text-align: center;
  margin-bottom: 16px;
}

.submit-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  transition: transform 0.3s;
}

.submit-image:hover {
  transform: scale(1.05);
}

.modal-image-wrapper {
  text-align: center;
  padding: 16px 24px 0;
}

.modal-image {
  max-width: 120px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-overlay.modal-active .modal-content {
  transform: scale(1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.modal-image {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
}

/* 右侧悬浮栏样式 */
.floating-sidebar {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 999999 !important;
  pointer-events: auto !important;
}

.sidebar-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 80px;
  background: #0279FF;
  cursor: pointer;
  transition: all 0.3s;
  pointer-events: auto !important;
  overflow: visible !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.sidebar-item-email {
  border-radius: 50px;
}

.sidebar-item:hover {
  background: #0279FF;
}

.sidebar-divider {
  width: 72px;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

.sidebar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  margin-bottom: 4px;
  pointer-events: none;
}

.sidebar-label {
  font-size: 12px;
  color: #ffffff;
  font-weight: 500;
  pointer-events: none;
}

.sidebar-tooltip {
  position: absolute;
  right: 82px;
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 1000000 !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
  display: block !important;
  white-space: nowrap;
}

.sidebar-tooltip::before {
  content: '';
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  border: 8px solid transparent;
  border-left-color: #ffffff;
}

.tooltip-content {
  padding: 16px;
  text-align: center;
  display: block;
}

.tooltip-qr-wrapper {
  background: #f3f4f6;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  display: block;
}

.tooltip-qr {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: contain;
}

.tooltip-hint {
  font-size: 13px;
  color: #1f2937;
  font-weight: 500;
  margin-top: 8px;
  display: block;
}

.tooltip-email-content {
  padding: 16px;
  text-align: center;
  display: block;
}

.tooltip-qr-small {
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto 8px;
  object-fit: contain;
}

.email-tooltip {
  padding: 12px 16px;
}

.tooltip-email {
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
}

/* 飞书二维码预览弹窗 */
.feishu-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.feishu-preview-overlay.feishu-preview-active {
  opacity: 1;
  visibility: visible;
}

.feishu-preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  transform: scale(0.8);
  transition: all 0.3s ease;
}

.feishu-preview-overlay.feishu-preview-active .feishu-preview-content {
  transform: scale(1);
}

.feishu-preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #1f2937;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.feishu-preview-close:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

.feishu-preview-image {
  width: 400px;
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.feishu-item {
  margin-top: 16px;
}

.feishu-qr {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-left: 28px;
  margin-top: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.feishu-qr:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.feishu-qr-small {
  width: 80px;
  height: 80px;
}

/* 声音分类数据库样式（来自 D:\demo01） */
.sound-classification-section {
  padding: 40px 60px;
}

.sound-db-card {
  position: relative;
  width: 90%;
  max-width: 1400px;
  height: 90vh;
  padding: 20px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.header-area {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 10px;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: 1px;
}

.table-wrapper {
  flex: 1;
  overflow-y: auto;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
}

.sound-db-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

/* 比例调整：一级15% : 二级25% : 三级60% */
.sound-db-table th:nth-child(1),
.sound-db-table td:nth-child(1) {
  width: 15%;
}

.sound-db-table th:nth-child(2),
.sound-db-table td:nth-child(2) {
  width: 25%;
}

.sound-db-table th:nth-child(3),
.sound-db-table td:nth-child(3) {
  width: 60%;
}

.sound-db-table th {
  position: sticky;
  top: 0;
  z-index: 200;
  background: #1e293b;
  padding: 12px 20px;
  text-align: left;
  font-size: 13px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(59, 130, 246, 0.3);
}

.sound-db-table td {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: top;
  line-height: 1.6;
  font-size: 14px;
  color: #cbd5e1;
}

/* 一级分类单元格 */
.lv1-cell {
  background: rgba(30, 41, 59, 0.5);
}

/* 二级分类单元格 */
.lv2-cell {
  background: rgba(15, 23, 42, 0.3);
}

/* 吸顶样式 */
.sticky-wrapper {
  position: sticky;
  top: 60px;
  z-index: 10;
}

.cat-title {
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  display: block;
}

.cat-title.lv2-title {
  font-size: 14px;
  color: #cbd5e1;
}

/* 锚点标记 */
.scroll-anchor {
  position: absolute;
  margin-top: -65px;
  visibility: hidden;
}

/* 三级分类单元格 */
.lv3-cell {
  color: #cbd5e1;
}

/* 底部状态栏 */
.status-bar {
  margin-top: 15px;
  padding: 12px 20px;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(30, 41, 59, 0.8), rgba(15, 23, 42, 0.8));
  border: 1px solid rgba(96, 165, 250, 0.2);
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #94a3b8;
}

.status-bar strong {
  color: #3b82f6;
  margin: 0 5px;
}

/* 滚动条美化 */
.table-wrapper::-webkit-scrollbar {
  width: 6px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.3);
  border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(59, 130, 246, 0.5);
}

/* 声音分类数据库 */
.sound-classification-section {
  padding: 40px 60px;
}

.sound-db-card {
  position: relative;
  width: 90%;
  max-width: 1400px;
  height: 90vh;
  padding: 20px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.header-area {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 10px;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: 1px;
}

.table-wrapper {
  flex: 1;
  overflow-y: auto;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
}

.sound-db-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.sound-db-table th:nth-child(1), .sound-db-table td:nth-child(1) { width: 15%; }
.sound-db-table th:nth-child(2), .sound-db-table td:nth-child(2) { width: 25%; }
.sound-db-table th:nth-child(3), .sound-db-table td:nth-child(3) { width: 60%; }

.sound-db-table th {
  position: sticky;
  top: 0;
  z-index: 200;
  background: #1e293b;
  padding: 12px 20px;
  text-align: left;
  font-size: 13px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(59, 130, 246, 0.3);
}

.sound-db-table td {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  vertical-align: top;
  line-height: 1.6;
  font-size: 14px;
  color: #cbd5e1;
}

.lv1-cell { background: rgba(30, 41, 59, 0.5); }
.lv2-cell { background: rgba(15, 23, 42, 0.3); }

.sticky-wrapper {
  position: sticky;
  top: 60px;
  z-index: 10;
}

.cat-title {
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  display: block;
}

.cat-title.lv2-title {
  font-size: 14px;
  color: #cbd5e1;
}

.scroll-anchor {
  position: absolute;
  margin-top: -65px;
  visibility: hidden;
}

.lv3-cell { color: #cbd5e1; }

.status-bar {
  margin-top: 15px;
  padding: 12px 20px;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(30,41,59,0.8), rgba(15,23,42,0.8));
  border: 1px solid rgba(96,165,250,0.2);
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #94a3b8;
}

.status-bar strong { color: #3b82f6; margin: 0 5px; }

.table-wrapper::-webkit-scrollbar { width: 6px; }
.table-wrapper::-webkit-scrollbar-track { background: transparent; }
.table-wrapper::-webkit-scrollbar-thumb { background: rgba(59, 130, 246, 0.3); border-radius: 10px; }

/* 音频数据能力 */
.audio-capability-section {
  padding: 40px 60px;
}

.audio-cap-container {
  max-width: 1000px;
  margin: 0 auto;
}

.audio-cap-container h1 {
  font-size: 26px;
  margin-bottom: 30px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
  color: #e6edf3;
}

.tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.tab {
  padding: 8px 16px;
  cursor: pointer;
  color: #8b9eb7;
  font-size: 15px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
}

.tab.active {
  color: #00d2ff;
  border-bottom: 2px solid #00d2ff;
}

.tab:hover:not(.active) {
  color: #fff;
}

.desc-bar {
  background: #131c31;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #8b9eb7;
  border: 1px solid #1e2c4a;
  line-height: 1.6;
  min-height: 80px;
}

.spec-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.spec-card {
  background: #131c31;
  padding: 18px;
  border-radius: 8px;
  border: 1px solid #1e2c4a;
}

.spec-label {
  font-size: 14px;
  color: #8b9eb7;
  margin-bottom: 8px;
  display: block;
}

.spec-value {
  font-size: 15px;
  font-weight: 500;
  color: #e6edf3;
}

.func-tags {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  height: 26px;
}

.f-tag {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  background: rgba(0, 210, 255, 0.1);
  color: #00d2ff;
  border: 1px solid rgba(0, 210, 255, 0.2);
}

/* 改为 */
.audio-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 0;
  width: 100%;
}

.audio-grid-align {
  padding: 0;
  width: 100%;
}

.audio-card {
  background: #131c31;
  border-radius: 8px;
  padding: 18px;      /* 原来 20px，改为 18px */
  border: 1px solid #1e2c4a;
  transition: all 0.3s ease;
}

.audio-card:hover {
  border-color: rgba(0, 210, 255, 0.4);
  background: #1a2642;
  box-shadow: 0 4px 20px rgba(0, 210, 255, 0.05);
}

.audio-info {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.btn-play-control {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 210, 255, 0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-play-control:hover {
  background: #00d2ff;
}

.icon-play {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0 6px 10px;
  border-color: transparent transparent transparent #00d2ff;
  margin-left: 3px;
}

.btn-play-control:hover .icon-play {
  border-color: transparent transparent transparent #0a0f1c;
}

.icon-pause {
  display: none;
  width: 10px;
  height: 12px;
  border-left: 3px solid #00d2ff;
  border-right: 3px solid #00d2ff;
}

.btn-play-control:hover .icon-pause {
  border-color: #0a0f1c;
}

.playing .icon-play {
  display: none;
}

.playing .icon-pause {
  display: block;
}

.audio-title {
  font-size: 16px;
  font-weight: 500;
  color: #e6edf3;
}

.progress-wrapper {
  width: 100%;
  padding: 10px 0;
  cursor: pointer;
}

.progress-track {
  width: 100%;
  height: 4px;
  background: #1e2c4a;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0%;
  background: #00d2ff;
  transition: width 0.1s linear;
}

</style>
